/* tslint:disable */
/* eslint-disable */
/**
 * SALA RMS
 * SALA RMS Cloud Endpoints Swagger Specification
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * How online bookings are accepted
 */

export const AcceptBookingEmum = {
    Automatic: 'automatic',
    Manualy: 'manualy',
} as const;

export type AcceptBookingEmum = typeof AcceptBookingEmum[keyof typeof AcceptBookingEmum];


/**
 * Reservation status
 */

export const ActiveReservationStatusEnum = {
    Seated: 'seated',
    Requested: 'requested',
    Accepted: 'accepted',
    Confirmed: 'confirmed',
    Pending: 'pending',
    Arrived: 'arrived',
} as const;

export type ActiveReservationStatusEnum = typeof ActiveReservationStatusEnum[keyof typeof ActiveReservationStatusEnum];


export interface AddressDto {
    /**
     * Primary address line
     */
    'address_line_1': string;
    /**
     * Secondary address line
     */
    'address_line_2'?: string | null;
    /**
     * City name
     */
    'city': string;
    /**
     * State, province, or region
     */
    'state_province_region'?: string | null;
    /**
     * Postal/ZIP code
     */
    'postal_code': string;
    /**
     * Country
     */
    'country': CountryEmum;
}


export interface Areas {
    /**
     * Area unique identifier
     */
    'uuid': string;
    /**
     * Store UUID this area belongs to
     */
    'store_uuid': string;
    /**
     * Area name
     */
    'name': string;
    /**
     * Area priority (1-3). 1: LOW, 3: High
     */
    'priority': number;
    /**
     * Area display order
     */
    'order': number;
    /**
     * Whether area is available for reservation
     */
    'available_for_reservation': boolean;
    /**
     * Whether area is available for online reservation
     */
    'available_for_online_reservation': boolean;
    /**
     * Store notes for the area
     */
    'store_notes'?: string | null;
    /**
     * Customer notes for the area
     */
    'customer_notes'?: string | null;
    /**
     * Archived at timestamp
     */
    'archived_at'?: object;
    /**
     * When the area was last updated
     */
    'updated_at': string;
    /**
     * When the area was created
     */
    'created_at': string;
    /**
     * Tables in this area
     */
    'tables'?: Array<Tables>;
}
/**
 * Store country
 */

export const CountryEmum = {
    Albania: 'ALBANIA',
    Andorra: 'ANDORRA',
    Austria: 'AUSTRIA',
    Belarus: 'BELARUS',
    Belgium: 'BELGIUM',
    BosniaAndHerzegovina: 'BOSNIA_AND_HERZEGOVINA',
    Bulgaria: 'BULGARIA',
    Croatia: 'CROATIA',
    Cyprus: 'CYPRUS',
    CzechRepublic: 'CZECH_REPUBLIC',
    Denmark: 'DENMARK',
    Estonia: 'ESTONIA',
    Finland: 'FINLAND',
    France: 'FRANCE',
    Germany: 'GERMANY',
    Greece: 'GREECE',
    Hungary: 'HUNGARY',
    Iceland: 'ICELAND',
    Ireland: 'IRELAND',
    Italy: 'ITALY',
    Latvia: 'LATVIA',
    Liechtenstein: 'LIECHTENSTEIN',
    Lithuania: 'LITHUANIA',
    Luxembourg: 'LUXEMBOURG',
    Malta: 'MALTA',
    Moldova: 'MOLDOVA',
    Monaco: 'MONACO',
    Montenegro: 'MONTENEGRO',
    Netherlands: 'NETHERLANDS',
    NorthMacedonia: 'NORTH_MACEDONIA',
    Norway: 'NORWAY',
    Poland: 'POLAND',
    Portugal: 'PORTUGAL',
    Romania: 'ROMANIA',
    SanMarino: 'SAN_MARINO',
    Serbia: 'SERBIA',
    Slovakia: 'SLOVAKIA',
    Slovenia: 'SLOVENIA',
    Spain: 'SPAIN',
    Sweden: 'SWEDEN',
    Switzerland: 'SWITZERLAND',
    Ukraine: 'UKRAINE',
    UnitedKingdom: 'UNITED_KINGDOM',
    VaticanCity: 'VATICAN_CITY',
} as const;

export type CountryEmum = typeof CountryEmum[keyof typeof CountryEmum];


export interface CreateAreaDto {
    /**
     * Area name
     */
    'name': string;
    /**
     * Area priority (1-3).  1: LOW, 3: High
     */
    'priority': number;
    /**
     * Area display order
     */
    'order': number;
    /**
     * Whether area is available for reservation
     */
    'available_for_reservation': boolean;
    /**
     * Whether area is available for online reservation
     */
    'available_for_online_reservation': boolean;
    /**
     * Store notes for the area
     */
    'store_notes'?: string | null;
    /**
     * Customer notes for the area
     */
    'customer_notes'?: string | null;
}
export interface CreateCustomerDto {
    /**
     * Customer first name
     */
    'first_name': string;
    /**
     * Customer last name
     */
    'last_name': string;
    /**
     * Customer phone number
     */
    'phone_number'?: string | null;
    /**
     * Customer email address
     */
    'email'?: string | null;
    /**
     * Customer gender
     */
    'sex'?: CustomerSexEmum | null;
    /**
     * Customer birth date
     */
    'birth_date'?: string | null;
    /**
     * Customer anniversary date
     */
    'anniversary_date'?: string | null;
    /**
     * Customer tags
     */
    'tags'?: Array<string> | null;
    /**
     * Customer addresses
     */
    'addresses'?: Array<AddressDto> | null;
    /**
     * Customer notes
     */
    'notes'?: string;
}


export interface CreateFloorPlanDto {
    /**
     * Floor plan name
     */
    'name': string;
    /**
     * Floor plan layout configuration as JSON object
     */
    'layout': object;
    /**
     * Whether this floor plan is currently active
     */
    'is_active': boolean;
}
export interface CreateReservationDto {
    /**
     * Array of table UUIDs
     */
    'tables_uuid'?: Array<string> | null;
    /**
     * Array of table group UUIDs
     */
    'table_groups_uuid'?: Array<string> | null;
    /**
     * Customer UUID
     */
    'customer_uuid'?: string | null;
    /**
     * Reservation start date and time
     */
    'reservation_starts': string;
    /**
     * Reservation end date and time
     */
    'reservation_ends': string;
    /**
     * Number of adults for the reservation
     */
    'adults': number;
    /**
     * Number of children for the reservation
     */
    'children': number;
    /**
     * Store/business notes
     */
    'store_notes'?: string | null;
    /**
     * Reservation source
     */
    'source': ReservationSourceEmum;
    /**
     * Purpose of the reservation
     */
    'purpose'?: ReservationPurposeEmum;
    /**
     * Reservation status
     */
    'status': ActiveReservationStatusEnum;
    /**
     * Tags for the reservation
     */
    'tags'?: Array<string> | null;
    /**
     * Language for notifications
     */
    'notification_language': LanguageEmum;
    /**
     * Email notification preference
     */
    'email_notification'?: boolean;
}


export interface CreateSpecialWorkingHourDto {
    /**
     * Optional title for this working hour period
     */
    'title'?: string | null;
    /**
     * Optional note for this working hour period
     */
    'notes'?: string | null;
    /**
     * Type of special working hour
     */
    'type': SpecialWorkingHourTypeEnum;
    /**
     * Date when the store will be closed (required for SPECIAL_CLOSED_SINGLE_DATE)
     */
    'date'?: string;
    /**
     * Start date/time (required for date ranges, intervals, and special open hours)
     */
    'from'?: string;
    /**
     * End date/time (required for date ranges, intervals, and special open hours)
     */
    'to'?: string;
    /**
     * Reservation settings
     */
    'reservationSettings'?: WorkingHourSettingsDto;
}


export interface CreateStoreDto {
    /**
     * Store name
     */
    'name': string;
    /**
     * Store country
     */
    'country': CountryEmum;
    /**
     * Store city
     */
    'city': string;
    /**
     * Store address
     */
    'address': string;
    /**
     * Store timezone
     */
    'timezone': TimeZonesEmum;
    /**
     * First day of the week (1-7). 1: Monday, 7: Sunday
     */
    'first_day_of_the_week': number;
    /**
     * Store language
     */
    'language': LanguageEmum;
    /**
     * Store phone number. Must contains a valid country code
     */
    'phone_number': string;
    /**
     * Store email address
     */
    'email': string;
    /**
     * Store type
     */
    'type': StoreTypeEmum;
    /**
     * Store domain name
     */
    'domain': string;
    /**
     * Store website URL
     */
    'website'?: string | null;
    /**
     * Social media links
     */
    'social'?: SocialDto | null;
}


export interface CreateTableDto {
    /**
     * Area UUID where the table belongs
     */
    'area_uuid': string;
    /**
     * Table name
     */
    'name': string;
    /**
     * Table priority (1-3).  1: LOW, 3: High
     */
    'priority': number;
    /**
     * Table display order
     */
    'order': number;
    /**
     * Minimum number of people
     */
    'min_people': number;
    /**
     * Maximum number of people
     */
    'max_people': number;
    /**
     * Whether table is available for reservation
     */
    'available_for_reservation': boolean;
    /**
     * Whether table is available for online reservation
     */
    'available_for_online_reservation': boolean;
    /**
     * Zone UUID (optional)
     */
    'zone_uuid'?: string | null;
    /**
     * Additional notes
     */
    'notes'?: string | null;
}
export interface CreateTableGroupDto {
    /**
     * Area UUID where the table group belongs
     */
    'area_uuid': string;
    /**
     * Table group name
     */
    'name': string;
    /**
     * Minimum number of people
     */
    'min_people': number;
    /**
     * Maximum number of people
     */
    'max_people': number;
    /**
     * Table group priority (1-3). 1: LOW, 3: High
     */
    'priority': number;
    /**
     * Store notes for the table group
     */
    'store_notes'?: string | null;
    /**
     * Customer notes for the table group
     */
    'customer_notes'?: string | null;
    /**
     * Whether table group is available for reservation
     */
    'available_for_reservation': boolean;
    /**
     * Whether table group is available for online reservation
     */
    'available_for_online_reservation': boolean;
    /**
     * Array of table UUIDs to group together (minimum 2 tables)
     */
    'tables': Array<string>;
}
export interface CreateUserDto {
    /**
     * User email address
     */
    'email': string;
    /**
     * User password (8-50 chars, must contain uppercase, lowercase, number, symbol)
     */
    'password': string;
    /**
     * User first name
     */
    'first_name': string;
    /**
     * User last name
     */
    'last_name': string;
}
export interface CreateWorkingHourDto {
    /**
     * Day of the week (1-7, where 1 is Monday)
     */
    'day': number;
    /**
     * Working hour start time in HH:MM format
     */
    'from': string;
    /**
     * Working hour end time in HH:MM format (must be at least 2 hours after start)
     */
    'to': string;
    /**
     * Optional title for this working hour period
     */
    'title': string;
    /**
     * Optional note for this working hour period
     */
    'notes'?: string | null;
    /**
     * Reservation settings
     */
    'reservationSettings'?: WorkingHourSettingsDto | null;
}
export interface CustomerAddresses {
    /**
     * Customer address unique identifier
     */
    'uuid': string;
    /**
     * Store UUID this address belongs to
     */
    'customer_uuid': string;
    /**
     * First line of the customer address
     */
    'address_line_1': string;
    /**
     * Second line of the customer address
     */
    'address_line_2'?: string | null;
    /**
     * City of the customer address
     */
    'city': string;
    /**
     * State, province or region of the customer address
     */
    'state_province_region'?: string | null;
    /**
     * Postal code of the customer address
     */
    'postal_code': string;
    /**
     * Country of the customer address
     */
    'country': CountryEmum;
    /**
     * When the customer address was last updated
     */
    'updated_at': string;
    /**
     * When the customer address was created
     */
    'created_at': string;
}


/**
 * Customer gender
 */

export const CustomerSexEmum = {
    Male: 'male',
    Female: 'female',
} as const;

export type CustomerSexEmum = typeof CustomerSexEmum[keyof typeof CustomerSexEmum];


export interface CustomerStatisticsResponseDto {
    /**
     * Total number of reservations
     */
    'totalReservations': number;
    /**
     * Total number of no-show reservations
     */
    'totalNoShow': number;
    /**
     * Total number of canceled reservations
     */
    'totalCanceled': number;
    /**
     * List of reservations for the customer
     */
    'reservations': Array<Reservations>;
}
export interface CustomerTag {
    /**
     * Customer tag unique identifier
     */
    'uuid': string;
    /**
     * Customer UUID this tag is associated with
     */
    'customer_uuid': string;
    /**
     * Tag UUID this customer tag is associated with
     */
    'tag_uuid': string;
}
export interface Customers {
    /**
     * Customer unique identifier
     */
    'uuid': string;
    /**
     * Store UUID this customer belongs to
     */
    'store_uuid': string;
    /**
     * Customer first name
     */
    'first_name': string;
    /**
     * Customer last name
     */
    'last_name': string;
    /**
     * Customer phone number
     */
    'phone_number'?: string | null;
    /**
     * Customer email address
     */
    'email'?: string | null;
    /**
     * Customer gender
     */
    'sex'?: CustomerSexEmum;
    /**
     * Customer birth date
     */
    'birth_date'?: string | null;
    /**
     * Customer anniversary date
     */
    'anniversary_date'?: string | null;
    /**
     * Customer notes
     */
    'notes'?: string;
    /**
     * When the customer was last updated
     */
    'updated_at': string;
    /**
     * When the customer was created
     */
    'created_at': string;
    /**
     * List of addresses associated with the customer
     */
    'addresses'?: Array<CustomerAddresses>;
    /**
     * List of tags associated with the customer
     */
    'tags'?: Array<CustomerTag>;
}


export interface FloorPlans {
    /**
     * Floor plan unique identifier
     */
    'uuid': string;
    /**
     * Store UUID this floor plan belongs to
     */
    'store_uuid': string;
    /**
     * Floor plan name
     */
    'name': string;
    /**
     * Floor plan layout configuration
     */
    'layout': object;
    /**
     * Whether the floor plan is active
     */
    'is_active': boolean;
    /**
     * When the floor plan was last updated
     */
    'updated_at': string;
    /**
     * When the floor plan was created
     */
    'created_at': string;
}
export interface Ga4TrackingDto {
    /**
     * Whether Google Analytics 4 tracking is enabled
     */
    'enabled': boolean;
    /**
     * GA4 Measurement ID
     */
    'measurement_id'?: string | null;
    /**
     * Truncated GA4 Measurement Protocol API secret. The full value is never returned.
     */
    'api_secret'?: string | null;
}
export interface GeneralSettingsDto {
    /**
     * Default duration for manual reservations in HH:MM format
     */
    'duration': string;
    /**
     * Custom duration rules for manual reservations based on party size
     */
    'durationRules'?: Array<SeatingDurationRuleDto> | null;
}
export interface GoogleAdsTrackingDto {
    /**
     * Whether Google Ads conversion tracking is enabled
     */
    'enabled': boolean;
    /**
     * Google Ads conversion ID
     */
    'conversion_id'?: string | null;
    /**
     * Google Ads conversion label used with gtag send_to
     */
    'conversion_label'?: string | null;
}
export interface HealthControllerCheck200Response {
    'status'?: string;
    'timestamp'?: string;
    'checks'?: HealthControllerCheck200ResponseChecks;
}
export interface HealthControllerCheck200ResponseChecks {
    'database'?: string;
}
export interface InviteDto {
    /**
     * Email address to send the invitation to
     */
    'email': string;
    /**
     * Role to assign to the invited user
     */
    'role': RolesEnum;
}


export interface Invites {
    /**
     * Invite unique identifier
     */
    'uuid': string;
    /**
     * Store UUID this invite belongs to
     */
    'store_uuid': string;
    /**
     * User UUID who sent the invite
     */
    'user_uuid': string;
    /**
     * Email address of the invited user
     */
    'email': string;
    /**
     * Unique token for the invite
     */
    'token': string;
    /**
     * Role to be assigned to the invited user
     */
    'role': RolesEnum;
    /**
     * When the invite expires
     */
    'expires_at': string;
    /**
     * When the invite was last updated
     */
    'updated_at': string;
    /**
     * When the invite was created
     */
    'created_at': string;
}


/**
 * Preferred language of the user
 */

export const LanguageEmum = {
    En: 'EN',
    El: 'EL',
} as const;

export type LanguageEmum = typeof LanguageEmum[keyof typeof LanguageEmum];


/**
 * Maximum time limit for online reservations
 */

export const LimitsMaxTimeEnum = {
    OneDay: 'one_day',
    TwoDays: 'two_days',
    ThreeDays: 'three_days',
    FourDays: 'four_days',
    FiveDays: 'five_days',
    SixDays: 'six_days',
    OneWeek: 'one_week',
    TwoWeeks: 'two_weeks',
    ThreeWeeks: 'three_weeks',
    OneMonth: 'one_month',
    TwoMonths: 'two_months',
    ThreeMonths: 'three_months',
    FourMonths: 'four_months',
    FiveMonths: 'five_months',
    SixMonths: 'six_months',
    SevenMonths: 'seven_months',
    EightMonths: 'eight_months',
    NineMonths: 'nine_months',
    TenMonths: 'ten_months',
    ElevenMonths: 'eleven_months',
    TwelveMonths: 'twelve_months',
} as const;

export type LimitsMaxTimeEnum = typeof LimitsMaxTimeEnum[keyof typeof LimitsMaxTimeEnum];


export interface LocalizedTextDto {
    /**
     * English text variant (max length enforced by the parent field)
     */
    'en'?: string | null;
    /**
     * Greek text variant (max length enforced by the parent field)
     */
    'el'?: string | null;
}
/**
 * How tables are mapped for online reservations
 */

export const MappingTablesEnum = {
    Automatic: 'automatic',
    Manualy: 'manualy',
    None: 'none',
} as const;

export type MappingTablesEnum = typeof MappingTablesEnum[keyof typeof MappingTablesEnum];


export interface MetaTrackingDto {
    /**
     * Whether Meta Pixel / Conversions API tracking is enabled
     */
    'enabled': boolean;
    /**
     * Meta Pixel ID (Dataset ID in Meta Events Manager)
     */
    'pixel_id'?: string | null;
    /**
     * Truncated Meta Conversions API access token. The full value is never returned.
     */
    'access_token'?: string | null;
    /**
     * Optional Meta test event code used while verifying Conversions API events
     */
    'test_event_code'?: string | null;
}
export interface OnlineReservationDto {
    /**
     * Area UUID for the reservation
     */
    'area_uuid'?: string;
    /**
     * Number of adults for the reservation
     */
    'adults': number;
    /**
     * Number of children for the reservation
     */
    'children': number;
    /**
     * Reservation start date and time
     */
    'reservation_starts': string;
    /**
     * Reservation end date and time
     */
    'reservation_ends': string;
    /**
     * Customer first name
     */
    'first_name': string;
    /**
     * Customer last name
     */
    'last_name': string;
    /**
     * Customer phone number (either phone or email required)
     */
    'phone_number'?: string | null;
    /**
     * Customer email address (either phone or email required)
     */
    'email'?: string | null;
    /**
     * Tags for the reservation
     */
    'tags'?: Array<string> | null;
    /**
     * Customer notes
     */
    'customer_notes'?: string;
    /**
     * Language for notifications
     */
    'notification_language': LanguageEmum;
}


export interface OnlineReservationRequestResponseDto {
    /**
     * Available time slot start time
     */
    'from': string;
    /**
     * Available time slot end time
     */
    'to': string;
    /**
     * Name of the area for this time slot
     */
    'area_name'?: string | null;
    /**
     * UUID of the area for this time slot
     */
    'area_uuid'?: string | null;
}
export interface OnlineSettingsDto {
    /**
     * Whether online reservations are allowed
     */
    'allow_online_reservations': boolean;
    /**
     * Whether to allow children in reservations
     */
    'allowChildren': boolean;
    /**
     * How tables are mapped for online reservations
     */
    'tables_mapping': MappingTablesEnum;
    /**
     * How online bookings are accepted
     */
    'accept_booking': AcceptBookingEmum;
    /**
     * Whether customers can choose specific areas online
     */
    'allow_choose_areas': boolean;
    /**
     * Whether to show reservation duration to customers
     */
    'show_duration': boolean;
    /**
     * Minimum number of guests per reservation (0 for no minimum)
     */
    'min_guests': number;
    /**
     * Maximum number of guests per reservation (0 for unlimited)
     */
    'max_guests': number;
    /**
     * Minimum time for online reservations (HH:MM format, 00:00 for unlimited)
     */
    'min_time': string;
    /**
     * Maximum time limit for online reservations
     */
    'max_time': LimitsMaxTimeEnum;
    /**
     * UTC ISO timestamp until online reservations are paused
     */
    'pause_online_reservations_until'?: string | null;
}


export interface OverviewDto {
    /**
     * Total number of reservations
     */
    'totalReservations': number;
    /**
     * Total number of guests
     */
    'totalGuests': number;
    /**
     * Average party size
     */
    'averagePartySize': number;
}
export interface PauseOnlineSettingsDto {
    /**
     * Whether to pause online reservations for the current day
     */
    'pause': boolean;
}
export interface PercentagesDto {
    /**
     * Percentage of no-show reservations
     */
    'noShowPercentage': number;
    /**
     * Percentage of canceled reservations
     */
    'canceledPercentage': number;
    /**
     * Percentage of first-time guests
     */
    'firstTimeGuestsPercentage': number;
}
export interface PublicGa4TrackingDto {
    /**
     * Whether GA4 should be initialized on the widget
     */
    'enabled': boolean;
    /**
     * GA4 Measurement ID for gtag config. Null when tracking is disabled.
     */
    'measurement_id'?: string | null;
}
export interface PublicGoogleAdsTrackingDto {
    /**
     * Whether Google Ads conversion tracking should be initialized on the widget
     */
    'enabled': boolean;
    /**
     * Google Ads conversion ID for gtag config. Null when tracking is disabled.
     */
    'conversion_id'?: string | null;
    /**
     * Google Ads conversion label for reservation conversions. Null when not configured.
     */
    'conversion_label'?: string | null;
}
export interface PublicMetaTrackingDto {
    /**
     * Whether Meta Pixel should be initialized on the widget
     */
    'enabled': boolean;
    /**
     * Meta Pixel ID for fbq init. Null when tracking is disabled.
     */
    'pixel_id'?: string | null;
}
export interface PublicStoreTrackingDto {
    /**
     * Public Meta Pixel identifiers for the widget
     */
    'meta': PublicMetaTrackingDto;
    /**
     * Public GA4 identifiers for the widget
     */
    'ga4': PublicGa4TrackingDto;
    /**
     * Public Google Ads identifiers for the widget
     */
    'google_ads': PublicGoogleAdsTrackingDto;
}
export interface ReorderAreasDto {
    /**
     * Array of area UUIDs in the new order
     */
    'areas': Array<string>;
}
export interface ReorderTablesDto {
    /**
     * Area UUID where the tables belong
     */
    'areaUUID': string;
    /**
     * Array of table UUIDs in the new order
     */
    'tables': Array<string>;
}
export interface ReservationGeneralSettings {
    /**
     * Store UUID these settings belong to
     */
    'store_uuid': string;
    /**
     * General reservation settings configuration
     */
    'settings': GeneralSettingsDto;
    /**
     * When the settings were last updated
     */
    'updated_at': string;
    /**
     * When the settings were created
     */
    'created_at': string;
}
/**
 * History action
 */

export const ReservationHistoryActionEnum = {
    Create: 'CREATE',
    Update: 'UPDATE',
} as const;

export type ReservationHistoryActionEnum = typeof ReservationHistoryActionEnum[keyof typeof ReservationHistoryActionEnum];


/**
 * Actor type
 */

export const ReservationHistoryActorTypeEnum = {
    User: 'USER',
    Customer: 'CUSTOMER',
    Public: 'PUBLIC',
} as const;

export type ReservationHistoryActorTypeEnum = typeof ReservationHistoryActorTypeEnum[keyof typeof ReservationHistoryActorTypeEnum];


export interface ReservationHistoryEntryDto {
    /**
     * History entry unique identifier
     */
    'uuid': string;
    /**
     * History action
     */
    'action': ReservationHistoryActionEnum;
    /**
     * Actor type
     */
    'actor_type': ReservationHistoryActorTypeEnum;
    /**
     * Acting staff user UUID
     */
    'actor_user_uuid'?: string | null;
    /**
     * Acting customer UUID
     */
    'actor_customer_uuid'?: string | null;
    /**
     * Actor first name when available
     */
    'actor_first_name'?: string | null;
    /**
     * Actor last name when available
     */
    'actor_last_name'?: string | null;
    /**
     * Field-level changes as from/to pairs
     */
    'changes': object;
    /**
     * When the change was recorded
     */
    'created_at': string;
}


export interface ReservationOnlineSettings {
    /**
     * Store UUID these settings belong to
     */
    'store_uuid': string;
    /**
     * Online reservation settings configuration
     */
    'settings': OnlineSettingsDto;
    /**
     * When the settings were last updated
     */
    'updated_at': string;
    /**
     * When the settings were created
     */
    'created_at': string;
}
/**
 * Purpose of the reservation
 */

export const ReservationPurposeEmum = {
    Food: 'food',
    Drink: 'drink',
} as const;

export type ReservationPurposeEmum = typeof ReservationPurposeEmum[keyof typeof ReservationPurposeEmum];


/**
 * Reservation source
 */

export const ReservationSourceEmum = {
    Walkin: 'walkin',
    Website: 'website',
    Email: 'email',
    Phone: 'phone',
    Google: 'google',
    Other: 'other',
} as const;

export type ReservationSourceEmum = typeof ReservationSourceEmum[keyof typeof ReservationSourceEmum];


export interface ReservationSpecialWorkingHourSettings {
    /**
     * Special reservation working hour settings unique identifier
     */
    'special_working_hour_uuid': string;
    /**
     * Store UUID these settings belong to
     */
    'store_uuid': string;
    /**
     * Settings for the reservation special working hours
     */
    'settings': WorkingHourSettingsDto;
    /**
     * When the settings were last updated
     */
    'updated_at': string;
    /**
     * When the settings were created
     */
    'created_at': string;
    /**
     * Areas associated with this special working hour settings
     */
    'areas'?: Array<Areas>;
}
/**
 * Current reservation status
 */

export const ReservationStatusEnum = {
    Seated: 'seated',
    Requested: 'requested',
    Accepted: 'accepted',
    Confirmed: 'confirmed',
    Pending: 'pending',
    Arrived: 'arrived',
    NotShown: 'not_shown',
    HasLeft: 'has_left',
    Cancelled: 'cancelled',
    Declined: 'declined',
} as const;

export type ReservationStatusEnum = typeof ReservationStatusEnum[keyof typeof ReservationStatusEnum];


export interface ReservationStoreInfoResponseDto {
    /**
     * Store name
     */
    'name': string;
    /**
     * Whether to show reservation duration to customers
     */
    'show_duration': boolean;
    /**
     * Whether to allow children in reservations
     */
    'allow_children': boolean;
    /**
     * Reservation widget settings
     */
    'widget_settings'?: WidgetSettingsDto | null;
    /**
     * UTC ISO timestamp until online reservations are paused
     */
    'pause_online_reservations_until'?: string | null;
}
export interface ReservationTag {
    /**
     * Reservation tag unique identifier
     */
    'uuid': string;
    /**
     * Reservation UUID this tag is associated with
     */
    'reservation_uuid': string;
    /**
     * Tag UUID this reservation tag is associated with
     */
    'tag_uuid': string;
}
export interface ReservationWidgetSettings {
    /**
     * Store UUID these settings belong to
     */
    'store_uuid': string;
    /**
     * URL to the logo image for the reservation widget
     */
    'logo_image_url'?: string | null;
    /**
     * URL to the background image for the reservation widget
     */
    'background_image_url'?: string | null;
    /**
     * Accent color for the reservation widget in HEX format (e.g., #FF5733)
     */
    'accent_color'?: string | null;
    /**
     * Maximum guest notice message displayed to users (locale map: en/el)
     */
    'max_guest_notice'?: LocalizedTextDto | null;
    /**
     * Booking notice message displayed to users (locale map: en/el)
     */
    'reservation_notice'?: LocalizedTextDto | null;
    /**
     * Message displayed when the restaurant is fully booked (locale map: en/el)
     */
    'fully_reserved_message'?: LocalizedTextDto | null;
    /**
     * Confirmation message shown after a successful booking (locale map: en/el)
     */
    'confirmation_message'?: LocalizedTextDto | null;
    /**
     * URL to redirect users after booking
     */
    'redirect_url'?: string | null;
    /**
     * URL to the reservation policy
     */
    'policy_url'?: string | null;
    /**
     * Inline reservation policy text (locale map: en/el). Clients prefer this over policy_url when any locale is set.
     */
    'policy_text'?: LocalizedTextDto | null;
}
export interface ReservationWorkingHourSettings {
    /**
     * Working hour UUID these settings belong to
     */
    'working_hour_uuid': string;
    /**
     * Store UUID these settings belong to
     */
    'store_uuid': string;
    /**
     * Settings for the reservation working hours
     */
    'settings': WorkingHourSettingsDto;
    /**
     * When the settings were last updated
     */
    'updated_at': string;
    /**
     * When the settings were created
     */
    'created_at': string;
    /**
     * Areas associated with this working hour settings
     */
    'areas'?: Array<Areas>;
}
export interface Reservations {
    /**
     * Reservation unique identifier
     */
    'uuid': string;
    /**
     * Store UUID this reservation belongs to
     */
    'store_uuid': string;
    /**
     * Customer UUID (optional for online reservations)
     */
    'customer_uuid'?: string;
    /**
     * Reservation start date and time
     */
    'reservation_starts': string;
    /**
     * Reservation end date and time
     */
    'reservation_ends': string;
    /**
     * Number of adults for the reservation
     */
    'adults': number;
    /**
     * Number of children for the reservation
     */
    'children': number;
    /**
     * Store/business notes about the reservation
     */
    'store_notes'?: string;
    /**
     * Customer notes about the reservation
     */
    'customer_notes'?: string;
    /**
     * Reservation source
     */
    'source': ReservationSourceEmum;
    /**
     * Purpose of the reservation
     */
    'purpose'?: ReservationPurposeEmum;
    /**
     * Current reservation status
     */
    'status': ReservationStatusEnum;
    /**
     * Language for notifications
     */
    'notification_language': LanguageEmum;
    /**
     * Whether email notifications are enabled
     */
    'email_notification': boolean;
    /**
     * Archived at timestamp
     */
    'archived_at'?: object;
    /**
     * When the reservation was last updated
     */
    'updated_at': string;
    /**
     * When the reservation was created
     */
    'created_at': string;
    /**
     * Customer details
     */
    'customer'?: Customers;
    /**
     * List of tables associated with the reservation
     */
    'reservation_tables'?: Array<object>;
    /**
     * List of tags associated with the reservation
     */
    'tags'?: Array<ReservationTag>;
}


export interface Roles {
    /**
     * Role assignment unique identifier
     */
    'uuid': string;
    /**
     * User UUID who has this role
     */
    'user_uuid': string;
    /**
     * Store UUID where this role is assigned
     */
    'store_uuid': string;
    /**
     * Role assigned to the user
     */
    'role': RolesEnum;
    /**
     * When the role was last updated
     */
    'updated_at': string;
    /**
     * When the role was created
     */
    'created_at': string;
    /**
     * User associated with this role
     */
    'user'?: Users;
}


/**
 * Role to assign to the user
 */

export const RolesEnum = {
    Owner: 'OWNER',
    Manager: 'MANAGER',
    Host: 'HOST',
    Waiter: 'WAITER',
} as const;

export type RolesEnum = typeof RolesEnum[keyof typeof RolesEnum];


export interface SalaResponseDto {
    /**
     * Timestamp when the error occurred
     */
    'timestamp': string;
    /**
     * HTTP status code
     */
    'status': number;
    /**
     * Error type or category
     */
    'error': string;
    /**
     * Error code for programmatic handling
     */
    'code'?: SalaResponseDtoCodeEnum;
    /**
     * Detailed error message
     */
    'message': string;
    /**
     * Additional error details and context
     */
    'details'?: object;
}

export const SalaResponseDtoCodeEnum = {
    ReservationNotFound: 'RESERVATION_NOT_FOUND',
    ReservationNoTablesAvailable: 'RESERVATION_NO_TABLES_AVAILABLE',
    ReservationMaxBookingsExceeded: 'RESERVATION_MAX_BOOKINGS_EXCEEDED',
    ReservationMinPeopleNotMet: 'RESERVATION_MIN_PEOPLE_NOT_MET',
    ReservationMaxPeopleExceeded: 'RESERVATION_MAX_PEOPLE_EXCEEDED',
    ReservationMaxBookingsPerIntervalExceeded: 'RESERVATION_MAX_BOOKINGS_PER_INTERVAL_EXCEEDED',
    ReservationMaxPeoplePerIntervalExceeded: 'RESERVATION_MAX_PEOPLE_PER_INTERVAL_EXCEEDED',
    ReservationMinTimeNotMet: 'RESERVATION_MIN_TIME_NOT_MET',
    ReservationMaxTimeExceeded: 'RESERVATION_MAX_TIME_EXCEEDED',
    ReservationInvalidDuration: 'RESERVATION_INVALID_DURATION',
    ReservationInvalidTimeInterval: 'RESERVATION_INVALID_TIME_INTERVAL',
    ReservationInvalidEndDate: 'RESERVATION_INVALID_END_DATE',
    ReservationNoWorkingHours: 'RESERVATION_NO_WORKING_HOURS',
    ReservationNoAreasAvailable: 'RESERVATION_NO_AREAS_AVAILABLE',
    ReservationAreaUuidRequired: 'RESERVATION_AREA_UUID_REQUIRED',
    ReservationAreaUuidNotAllowed: 'RESERVATION_AREA_UUID_NOT_ALLOWED',
    ReservationFullyBooked: 'RESERVATION_FULLY_BOOKED',
    ReservationInvalidNumberOfPeople: 'RESERVATION_INVALID_NUMBER_OF_PEOPLE',
    ReservationInvalidStatus: 'RESERVATION_INVALID_STATUS',
    ReservationCancellationFailed: 'RESERVATION_CANCELLATION_FAILED',
    ReservationPaused: 'RESERVATION_PAUSED',
    StoreNotFound: 'STORE_NOT_FOUND',
    StoreOnlineReservationsDisabled: 'STORE_ONLINE_RESERVATIONS_DISABLED',
    StoreDomainInvalid: 'STORE_DOMAIN_INVALID',
    StoreDomainExists: 'STORE_DOMAIN_EXISTS',
    StoreClosed: 'STORE_CLOSED',
    TableGroupsUnavailable: 'TABLE_GROUPS_UNAVAILABLE',
    TableGroupsHaveCommonTables: 'TABLE_GROUPS_HAVE_COMMON_TABLES',
    TablesUnavailable: 'TABLES_UNAVAILABLE',
    TablesAndGroupsConflict: 'TABLES_AND_GROUPS_CONFLICT',
    TableGroupNotFound: 'TABLE_GROUP_NOT_FOUND',
    TableGroupDuplicate: 'TABLE_GROUP_DUPLICATE',
    TableGroupTablesNotInArea: 'TABLE_GROUP_TABLES_NOT_IN_AREA',
    TableGroupInvalidCapacity: 'TABLE_GROUP_INVALID_CAPACITY',
    TableNotFound: 'TABLE_NOT_FOUND',
    TableInvalidCapacity: 'TABLE_INVALID_CAPACITY',
    TableNameExists: 'TABLE_NAME_EXISTS',
    TagNotFound: 'TAG_NOT_FOUND',
    AreaNotFound: 'AREA_NOT_FOUND',
    ZoneNotFound: 'ZONE_NOT_FOUND',
    ZoneNameExists: 'ZONE_NAME_EXISTS',
    CustomerNotFound: 'CUSTOMER_NOT_FOUND',
    FloorPlanNotFound: 'FLOOR_PLAN_NOT_FOUND',
    FloorPlanNameExists: 'FLOOR_PLAN_NAME_EXISTS',
    InviteUserAlreadyExists: 'INVITE_USER_ALREADY_EXISTS',
    InviteInvalidToken: 'INVITE_INVALID_TOKEN',
    UserNotFound: 'USER_NOT_FOUND',
    RoleUserNotFound: 'ROLE_USER_NOT_FOUND',
    RoleOwnerCannotBeModified: 'ROLE_OWNER_CANNOT_BE_MODIFIED',
    SettingsNotFound: 'SETTINGS_NOT_FOUND',
    SettingsGeneralNotFound: 'SETTINGS_GENERAL_NOT_FOUND',
    SettingsOnlineNotFound: 'SETTINGS_ONLINE_NOT_FOUND',
    SettingsWidgetNotFound: 'SETTINGS_WIDGET_NOT_FOUND',
    SettingsWorkingHourNotFound: 'SETTINGS_WORKING_HOUR_NOT_FOUND',
    SettingsSpecialWorkingHourNotFound: 'SETTINGS_SPECIAL_WORKING_HOUR_NOT_FOUND',
    SettingsSpecialWorkingHourDateRequired: 'SETTINGS_SPECIAL_WORKING_HOUR_DATE_REQUIRED',
    SettingsSpecialWorkingHourDateRangeRequired: 'SETTINGS_SPECIAL_WORKING_HOUR_DATE_RANGE_REQUIRED',
    SettingsAreasNotAvailable: 'SETTINGS_AREAS_NOT_AVAILABLE',
    SettingsTrackingIncomplete: 'SETTINGS_TRACKING_INCOMPLETE',
    ValidationFailed: 'VALIDATION_FAILED',
    ValidationInvalidEmail: 'VALIDATION_INVALID_EMAIL',
    ValidationInvalidPhone: 'VALIDATION_INVALID_PHONE',
    ValidationInvalidUuid: 'VALIDATION_INVALID_UUID',
    ValidationInvalidDate: 'VALIDATION_INVALID_DATE',
    ValidationInvalidTime: 'VALIDATION_INVALID_TIME',
    ValidationRequiredField: 'VALIDATION_REQUIRED_FIELD',
    ValidationOutOfRange: 'VALIDATION_OUT_OF_RANGE',
    AuthInsufficientPermissions: 'AUTH_INSUFFICIENT_PERMISSIONS',
    AuthUnauthorized: 'AUTH_UNAUTHORIZED',
    AuthInvalidToken: 'AUTH_INVALID_TOKEN',
    ResourceNotFound: 'RESOURCE_NOT_FOUND',
    ResourceConflict: 'RESOURCE_CONFLICT',
    ResourceBadRequest: 'RESOURCE_BAD_REQUEST',
    SystemInternalError: 'SYSTEM_INTERNAL_ERROR',
    SystemDatabaseError: 'SYSTEM_DATABASE_ERROR',
    SmsBadRequest: 'SMS_BAD_REQUEST',
    SmsUnauthorized: 'SMS_UNAUTHORIZED',
    SmsInsufficientCredits: 'SMS_INSUFFICIENT_CREDITS',
    SmsForbidden: 'SMS_FORBIDDEN',
    SmsMethodNotAllowed: 'SMS_METHOD_NOT_ALLOWED',
    SmsProviderError: 'SMS_PROVIDER_ERROR',
    SmsUnavailable: 'SMS_UNAVAILABLE',
    SmsTimeout: 'SMS_TIMEOUT',
    SmsNetworkError: 'SMS_NETWORK_ERROR',
    SmsResponseParseError: 'SMS_RESPONSE_PARSE_ERROR',
    SmsValidationFailed: 'SMS_VALIDATION_FAILED',
    SmsConfigMissing: 'SMS_CONFIG_MISSING',
    FileSizeExceeded: 'FILE_SIZE_EXCEEDED',
    FileTypeNotAllowed: 'FILE_TYPE_NOT_ALLOWED',
    FileUploadFailed: 'FILE_UPLOAD_FAILED',
} as const;

export type SalaResponseDtoCodeEnum = typeof SalaResponseDtoCodeEnum[keyof typeof SalaResponseDtoCodeEnum];

export interface SeatingDurationRuleDto {
    /**
     * Minimum number of people for this duration rule
     */
    'minPeople': number;
    /**
     * Maximum number of people for this duration rule
     */
    'maxPeople': number;
    /**
     * Seating duration in HH:MM format
     */
    'duration': string;
}
export interface SocialDto {
    /**
     * Facebook page URL
     */
    'facebook'?: string | null;
    /**
     * Instagram profile URL
     */
    'instagram'?: string | null;
    /**
     * TikTok profile URL
     */
    'tiktok'?: string | null;
    /**
     * TripAdvisor page URL
     */
    'tripadvisor'?: string | null;
}
export interface SourceBreakdownItemDto {
    /**
     * Reservation source name
     */
    'source': string;
    /**
     * Count of reservations from this source
     */
    'count': number;
    /**
     * Percentage of total reservations
     */
    'percentage': number;
}
/**
 * Type of special working hour
 */

export const SpecialWorkingHourTypeEnum = {
    SpecialClosedSingleDate: 'special_closed_single_date',
    SpecialClosedDateRange: 'special_closed_date_range',
    SpecialClosedTimeInterval: 'special_closed_time_interval',
    SpecialOpenSpecialWorkingHour: 'special_open_special_working_hour',
} as const;

export type SpecialWorkingHourTypeEnum = typeof SpecialWorkingHourTypeEnum[keyof typeof SpecialWorkingHourTypeEnum];


export interface SpecialWorkingHours {
    /**
     * Special working hour unique identifier
     */
    'uuid': string;
    /**
     * Store UUID this special working hour belongs to
     */
    'store_uuid': string;
    /**
     * Special working hour type
     */
    'type': SpecialWorkingHourTypeEnum;
    /**
     * Special working hour title
     */
    'title'?: string;
    /**
     * Start date and time of the special working hour
     */
    'from': string;
    /**
     * End date and time of the special working hour
     */
    'to': string;
    /**
     * Additional notes for this special working hour
     */
    'notes'?: string;
    /**
     * When the special working hour was last updated
     */
    'updated_at': string;
    /**
     * When the special working hour was created
     */
    'created_at': string;
    /**
     * Reservation settings for this special working hour
     */
    'reservation_settings'?: ReservationSpecialWorkingHourSettings;
}


export interface StatusBreakdownItemDto {
    /**
     * Reservation status
     */
    'status': string;
    /**
     * Count of reservations with this status
     */
    'count': number;
    /**
     * Percentage of total reservations
     */
    'percentage': number;
}
export interface StoreStatisticsResponseDto {
    'dateRange': StoreStatisticsResponseDtoDateRange;
    /**
     * Overview statistics
     */
    'overview': OverviewDto;
    /**
     * Percentage statistics
     */
    'percentages': PercentagesDto;
    /**
     * Breakdown by reservation source
     */
    'sourceBreakdown': Array<SourceBreakdownItemDto>;
    /**
     * Breakdown by reservation status
     */
    'statusBreakdown': Array<StatusBreakdownItemDto>;
}
/**
 * Date range for the statistics
 */
export interface StoreStatisticsResponseDtoDateRange {
    'start'?: string;
    'end'?: string;
}
export interface StoreTrackingSettingsDto {
    /**
     * Store UUID these tracking settings belong to
     */
    'store_uuid': string;
    /**
     * Meta Pixel and Conversions API configuration
     */
    'meta': MetaTrackingDto;
    /**
     * Google Analytics 4 configuration
     */
    'ga4': Ga4TrackingDto;
    /**
     * Google Ads conversion tracking configuration
     */
    'google_ads': GoogleAdsTrackingDto;
    /**
     * When the tracking settings were last updated
     */
    'updated_at'?: object | null;
    /**
     * When the tracking settings were created
     */
    'created_at'?: object | null;
}
/**
 * Store type
 */

export const StoreTypeEmum = {
    Restaurant: 'RESTAURANT',
    Bar: 'BAR',
    Club: 'CLUB',
    Coffee: 'COFFEE',
} as const;

export type StoreTypeEmum = typeof StoreTypeEmum[keyof typeof StoreTypeEmum];


export interface Stores {
    /**
     * Store unique identifier
     */
    'uuid': string;
    /**
     * Store name
     */
    'name': string;
    /**
     * Store country
     */
    'country': CountryEmum;
    /**
     * Store city
     */
    'city': string;
    /**
     * Store address
     */
    'address': string;
    /**
     * Store timezone
     */
    'timezone': TimeZonesEmum;
    /**
     * First day of the week (1-7). 1: Monday, 7: Sunday
     */
    'first_day_of_the_week': number;
    /**
     * Store language
     */
    'language': LanguageEmum;
    /**
     * Store phone number
     */
    'phone_number': string;
    /**
     * Store email address
     */
    'email': string;
    /**
     * Store type
     */
    'type': StoreTypeEmum;
    /**
     * Store domain name
     */
    'domain': string;
    /**
     * Store website URL
     */
    'website'?: string | null;
    /**
     * Social media links
     */
    'social'?: SocialDto | null;
    /**
     * When the store was last updated
     */
    'updated_at': string;
    /**
     * When the store was created
     */
    'created_at': string;
}


export interface TableGroups {
    /**
     * Table group unique identifier
     */
    'uuid': string;
    /**
     * Store UUID this table group belongs to
     */
    'store_uuid': string;
    /**
     * Area UUID this table group belongs to
     */
    'area_uuid': string;
    /**
     * Table group name
     */
    'name': string;
    /**
     * Minimum number of people for this table group
     */
    'min_people': number;
    /**
     * Maximum number of people for this table group
     */
    'max_people': number;
    /**
     * Table group priority (1-3). 1: LOW, 3: High
     */
    'priority': number;
    /**
     * Tables in this table group
     */
    'tables': Array<Tables>;
    /**
     * Store notes for this table group
     */
    'store_notes'?: string | null;
    /**
     * Customer notes for this table group
     */
    'customer_notes'?: string | null;
    /**
     * Whether table group is available for reservation
     */
    'available_for_reservation': boolean;
    /**
     * Whether table group is available for online reservation
     */
    'available_for_online_reservation': boolean;
    /**
     * Hash of the tables in this group for change detection
     */
    'tables_hash': string;
    /**
     * When the table group was last updated
     */
    'updated_at': string;
    /**
     * When the table group was created
     */
    'created_at': string;
    /**
     * Area of the table group
     */
    'area': Areas;
}
export interface Tables {
    /**
     * Table unique identifier
     */
    'uuid': string;
    /**
     * Store UUID this table belongs to
     */
    'store_uuid': string;
    /**
     * Area UUID this table belongs to
     */
    'area_uuid': string;
    /**
     * Zone UUID this table belongs to (optional)
     */
    'zone_uuid'?: string | null;
    /**
     * Table name
     */
    'name': string;
    /**
     * Table priority (1-3). 1: LOW, 3: High
     */
    'priority': number;
    /**
     * Table display order
     */
    'order': number;
    /**
     * Minimum number of people
     */
    'min_people': number;
    /**
     * Maximum number of people
     */
    'max_people': number;
    /**
     * Whether table is available for reservation
     */
    'available_for_reservation': boolean;
    /**
     * Whether table is available for online reservation
     */
    'available_for_online_reservation': boolean;
    /**
     * Additional notes about the table
     */
    'notes'?: string | null;
    /**
     * Archived at timestamp
     */
    'archived_at'?: object;
    /**
     * When the table was last updated
     */
    'updated_at': string;
    /**
     * When the table was created
     */
    'created_at': string;
}
/**
 * Store timezone
 */

export const TimeZonesEmum = {
    EuropeAmsterdam: 'Europe/Amsterdam',
    EuropeAndorra: 'Europe/Andorra',
    EuropeAstrakhan: 'Europe/Astrakhan',
    EuropeAthens: 'Europe/Athens',
    EuropeBelgrade: 'Europe/Belgrade',
    EuropeBerlin: 'Europe/Berlin',
    EuropeBratislava: 'Europe/Bratislava',
    EuropeBrussels: 'Europe/Brussels',
    EuropeBucharest: 'Europe/Bucharest',
    EuropeBudapest: 'Europe/Budapest',
    EuropeBusingen: 'Europe/Busingen',
    EuropeChisinau: 'Europe/Chisinau',
    EuropeCopenhagen: 'Europe/Copenhagen',
    EuropeDublin: 'Europe/Dublin',
    EuropeGibraltar: 'Europe/Gibraltar',
    EuropeGuernsey: 'Europe/Guernsey',
    EuropeHelsinki: 'Europe/Helsinki',
    EuropeIsleOfMan: 'Europe/Isle_of_Man',
    EuropeIstanbul: 'Europe/Istanbul',
    EuropeJersey: 'Europe/Jersey',
    EuropeKaliningrad: 'Europe/Kaliningrad',
    EuropeKiev: 'Europe/Kiev',
    EuropeKirov: 'Europe/Kirov',
    EuropeLisbon: 'Europe/Lisbon',
    EuropeLjubljana: 'Europe/Ljubljana',
    EuropeLondon: 'Europe/London',
    EuropeLuxembourg: 'Europe/Luxembourg',
    EuropeMadrid: 'Europe/Madrid',
    EuropeMalta: 'Europe/Malta',
    EuropeMariehamn: 'Europe/Mariehamn',
    EuropeMinsk: 'Europe/Minsk',
    EuropeMonaco: 'Europe/Monaco',
    EuropeMoscow: 'Europe/Moscow',
    EuropeOslo: 'Europe/Oslo',
    EuropeParis: 'Europe/Paris',
    EuropePodgorica: 'Europe/Podgorica',
    EuropePrague: 'Europe/Prague',
    EuropeRiga: 'Europe/Riga',
    EuropeRome: 'Europe/Rome',
    EuropeSamara: 'Europe/Samara',
    EuropeSanMarino: 'Europe/San_Marino',
    EuropeSarajevo: 'Europe/Sarajevo',
    EuropeSaratov: 'Europe/Saratov',
    EuropeSimferopol: 'Europe/Simferopol',
    EuropeSkopje: 'Europe/Skopje',
    EuropeSofia: 'Europe/Sofia',
    EuropeStockholm: 'Europe/Stockholm',
    EuropeTallinn: 'Europe/Tallinn',
    EuropeTirane: 'Europe/Tirane',
    EuropeUlyanovsk: 'Europe/Ulyanovsk',
    EuropeVaduz: 'Europe/Vaduz',
    EuropeVatican: 'Europe/Vatican',
    EuropeVienna: 'Europe/Vienna',
    EuropeVilnius: 'Europe/Vilnius',
    EuropeVolgograd: 'Europe/Volgograd',
    EuropeWarsaw: 'Europe/Warsaw',
    EuropeZagreb: 'Europe/Zagreb',
    EuropeZurich: 'Europe/Zurich',
} as const;

export type TimeZonesEmum = typeof TimeZonesEmum[keyof typeof TimeZonesEmum];


export interface UpdateAreaDto {
    /**
     * Area name
     */
    'name'?: string;
    /**
     * Area priority (1-3).  1: LOW, 3: High
     */
    'priority'?: number;
    /**
     * Area display order
     */
    'order'?: number;
    /**
     * Whether area is available for reservation
     */
    'available_for_reservation'?: boolean;
    /**
     * Whether area is available for online reservation
     */
    'available_for_online_reservation'?: boolean;
    /**
     * Store notes for the area
     */
    'store_notes'?: string | null;
    /**
     * Customer notes for the area
     */
    'customer_notes'?: string | null;
}
export interface UpdateCustomerDto {
    /**
     * Customer first name
     */
    'first_name'?: string;
    /**
     * Customer last name
     */
    'last_name'?: string;
    /**
     * Customer phone number
     */
    'phone_number'?: string | null;
    /**
     * Customer email address
     */
    'email'?: string | null;
    /**
     * Customer gender
     */
    'sex'?: CustomerSexEmum | null;
    /**
     * Customer birth date
     */
    'birth_date'?: string | null;
    /**
     * Customer anniversary date
     */
    'anniversary_date'?: string | null;
    /**
     * Customer tags
     */
    'tags'?: Array<string> | null;
    /**
     * Customer addresses
     */
    'addresses'?: Array<AddressDto> | null;
    /**
     * Customer notes
     */
    'notes'?: string;
}


export interface UpdateFloorPlanDto {
    /**
     * Floor plan name
     */
    'name'?: string;
    /**
     * Floor plan layout configuration as JSON object
     */
    'layout'?: object;
    /**
     * Whether this floor plan is currently active
     */
    'is_active'?: boolean;
}
export interface UpdateGa4TrackingDto {
    /**
     * Whether Google Analytics 4 tracking is enabled
     */
    'enabled'?: boolean;
    /**
     * GA4 Measurement ID. Set to null to clear.
     */
    'measurement_id'?: string | null;
    /**
     * GA4 Measurement Protocol API secret. Send the full secret to replace it, omit or send the truncated value to keep the stored secret, or null to clear.
     */
    'api_secret'?: string | null;
}
export interface UpdateGoogleAdsTrackingDto {
    /**
     * Whether Google Ads conversion tracking is enabled
     */
    'enabled'?: boolean;
    /**
     * Google Ads conversion ID. Set to null to clear.
     */
    'conversion_id'?: string | null;
    /**
     * Google Ads conversion label. Set to null to clear.
     */
    'conversion_label'?: string | null;
}
export interface UpdateMetaTrackingDto {
    /**
     * Whether Meta Pixel / Conversions API tracking is enabled
     */
    'enabled'?: boolean;
    /**
     * Meta Pixel ID (Dataset ID). Set to null to clear.
     */
    'pixel_id'?: string | null;
    /**
     * Meta Conversions API access token. Send the full token to replace it, omit or send the truncated value to keep the stored token, or null to clear.
     */
    'access_token'?: string | null;
    /**
     * Optional Meta test event code. Set to null to clear.
     */
    'test_event_code'?: string | null;
}
export interface UpdateReservationDto {
    /**
     * Array of table UUIDs
     */
    'tables_uuid'?: Array<string> | null;
    /**
     * Array of table group UUIDs
     */
    'table_groups_uuid'?: Array<string> | null;
    /**
     * Customer UUID
     */
    'customer_uuid'?: string | null;
    /**
     * Reservation start date and time
     */
    'reservation_starts'?: string;
    /**
     * Reservation end date and time
     */
    'reservation_ends'?: string;
    /**
     * Number of adults for the reservation
     */
    'adults'?: number;
    /**
     * Number of children for the reservation
     */
    'children'?: number;
    /**
     * Store/business notes
     */
    'store_notes'?: string | null;
    /**
     * Reservation source
     */
    'source'?: ReservationSourceEmum;
    /**
     * Purpose of the reservation
     */
    'purpose'?: ReservationPurposeEmum | null;
    /**
     * Reservation status
     */
    'status'?: ReservationStatusEnum;
    /**
     * Tags for the reservation
     */
    'tags'?: Array<string> | null;
    /**
     * Notification language
     */
    'notification_language'?: LanguageEmum;
    /**
     * Email notification preference
     */
    'email_notification'?: boolean;
}


export interface UpdateSpecialWorkingHourDto {
    /**
     * Optional title for this working hour period
     */
    'title'?: string | null;
    /**
     * Optional note for this working hour period
     */
    'notes'?: string | null;
    /**
     * Type of special working hour
     */
    'type'?: SpecialWorkingHourTypeEnum;
    /**
     * Date when the store will be closed (for SPECIAL_CLOSED_SINGLE_DATE)
     */
    'date'?: string;
    /**
     * Start date/time (for date ranges, intervals, and special open hours)
     */
    'from'?: string;
    /**
     * End date/time (for date ranges, intervals, and special open hours)
     */
    'to'?: string;
    /**
     * Reservation settings
     */
    'reservationSettings'?: WorkingHourSettingsDto;
}


export interface UpdateStoreDto {
    /**
     * Store name
     */
    'name'?: string;
    /**
     * Store country
     */
    'country'?: CountryEmum;
    /**
     * Store city
     */
    'city'?: string;
    /**
     * Store address
     */
    'address'?: string;
    /**
     * Store timezone
     */
    'timezone'?: TimeZonesEmum;
    /**
     * First day of the week (1-7). 1: Monday, 7: Sunday
     */
    'first_day_of_the_week'?: number;
    /**
     * Store language
     */
    'language'?: LanguageEmum;
    /**
     * Store phone number. Must contains a valid country code
     */
    'phone_number'?: string;
    /**
     * Store email address
     */
    'email'?: string;
    /**
     * Store domain name
     */
    'domain'?: string | null;
    /**
     * Store website URL
     */
    'website'?: string | null;
    /**
     * Social media links
     */
    'social'?: SocialDto | null;
}


export interface UpdateStoreTrackingDto {
    /**
     * Meta Pixel and Conversions API fields to create or update
     */
    'meta'?: UpdateMetaTrackingDto;
    /**
     * Google Analytics 4 fields to create or update
     */
    'ga4'?: UpdateGa4TrackingDto;
    /**
     * Google Ads conversion tracking fields to create or update
     */
    'google_ads'?: UpdateGoogleAdsTrackingDto;
}
export interface UpdateTableDto {
    /**
     * Table name
     */
    'name'?: string;
    /**
     * Table priority (1-3).  1: LOW, 3: High
     */
    'priority'?: number;
    /**
     * Table display order
     */
    'order'?: number;
    /**
     * Minimum number of people
     */
    'min_people'?: number;
    /**
     * Maximum number of people
     */
    'max_people'?: number;
    /**
     * Whether table is available for reservation
     */
    'available_for_reservation'?: boolean;
    /**
     * Whether table is available for online reservation
     */
    'available_for_online_reservation'?: boolean;
    /**
     * Zone UUID (optional)
     */
    'zone_uuid'?: string | null;
    /**
     * Additional notes
     */
    'notes'?: string | null;
}
export interface UpdateTableGroupDto {
    /**
     * Table group name
     */
    'name'?: string;
    /**
     * Minimum number of people
     */
    'min_people'?: number;
    /**
     * Maximum number of people
     */
    'max_people'?: number;
    /**
     * Table group priority (1-3). 1: LOW, 3: High
     */
    'priority'?: number;
    /**
     * Store notes for the table group
     */
    'store_notes'?: string | null;
    /**
     * Customer notes for the table group
     */
    'customer_notes'?: string | null;
    /**
     * Whether table group is available for reservation
     */
    'available_for_reservation'?: boolean;
    /**
     * Whether table group is available for online reservation
     */
    'available_for_online_reservation'?: boolean;
    /**
     * Array of table UUIDs to group together (minimum 2 tables)
     */
    'tables'?: Array<string>;
}
export interface UpdateUserDto {
    /**
     * User email address
     */
    'email'?: string;
    /**
     * User password (8-50 chars, must contain uppercase, lowercase, number, symbol)
     */
    'password'?: string;
    /**
     * User first name
     */
    'first_name'?: string;
    /**
     * User last name
     */
    'last_name'?: string;
    /**
     * User settings
     */
    'settings'?: UserSettingsDto;
}
export interface UpdateWorkingHourDto {
    /**
     * Day of the week (1-7, where 1 is Monday)
     */
    'day'?: number;
    /**
     * Working hour start time in HH:MM format
     */
    'from'?: string;
    /**
     * Working hour end time in HH:MM format (must be at least 2 hours after start)
     */
    'to'?: string;
    /**
     * Optional title for this working hour period
     */
    'title'?: string;
    /**
     * Optional note for this working hour period
     */
    'notes'?: string | null;
    /**
     * Reservation settings
     */
    'reservationSettings'?: WorkingHourSettingsDto | null;
}
export interface UserDto {
    /**
     * Unique identifier for the user
     */
    'user_id': string;
    /**
     * Email address of the user
     */
    'email': string;
    /**
     * Display name of the user
     */
    'display_name': string;
}
export interface UserProfileDto {
    /**
     * User email address
     */
    'email': string;
    /**
     * User first name
     */
    'first_name': string;
    /**
     * User last name
     */
    'last_name': string;
    /**
     * User settings
     */
    'settings'?: UserSettingsDto | null;
}
export interface UserRoleDto {
    /**
     * User UUID to assign role to
     */
    'user_uuid': string;
    /**
     * Role to assign to the user
     */
    'role': RolesEnum;
}


export interface UserSettingsDto {
    /**
     * Preferred language of the user
     */
    'language': LanguageEmum | null;
    /**
     * Whether the user prefers dark mode
     */
    'dark_mode': boolean | null;
}


export interface Users {
    /**
     * User unique identifier
     */
    'uuid': string;
    /**
     * User first name
     */
    'first_name': string;
    /**
     * User last name
     */
    'last_name': string;
    /**
     * User email address
     */
    'email': string;
    /**
     * User settings
     */
    'settings': UserSettingsDto | null;
    /**
     * When the user was last updated
     */
    'updated_at': string;
    /**
     * When the user was created
     */
    'created_at': string;
}
export interface WidgetSettingsDto {
    /**
     * URL to the logo image for the reservation widget
     */
    'logo_image_url'?: string | null;
    /**
     * URL to the background image for the reservation widget
     */
    'background_image_url'?: string | null;
    /**
     * Accent color for the reservation widget in HEX format (e.g., #FF5733)
     */
    'accent_color'?: string | null;
    /**
     * Shown when guests exceed the maximum party size (locale map: en/el; max 1000 chars per locale)
     */
    'max_guest_notice'?: LocalizedTextDto | null;
    /**
     * Booking notice message displayed to users (locale map: en/el; max 1000 chars per locale)
     */
    'reservation_notice'?: LocalizedTextDto | null;
    /**
     * Message displayed when the restaurant is fully booked (locale map: en/el; max 1000 chars per locale)
     */
    'fully_reserved_message'?: LocalizedTextDto | null;
    /**
     * Confirmation message shown after a successful booking (locale map: en/el; max 1000 chars per locale)
     */
    'confirmation_message'?: LocalizedTextDto | null;
    /**
     * URL to redirect users after booking
     */
    'redirect_url'?: string | null;
    /**
     * URL to the reservation policy
     */
    'policy_url'?: string | null;
    /**
     * Inline reservation policy text (locale map: en/el; max 5000 chars per locale). Prefer over policy_url when any locale is set.
     */
    'policy_text'?: LocalizedTextDto | null;
}
export interface WidgetSettingsFormDataDto {
    /**
     * Logo image file (jpg, jpeg, png, max 2MB)
     */
    'logo_image'?: File;
    /**
     * Background image file (jpg, jpeg, png, max 2MB)
     */
    'background_image'?: File;
    /**
     * Accent color for the reservation widget in HEX format (e.g., #FF5733)
     */
    'accent_color'?: string | null;
    /**
     * Max guest notice (max 1000 chars per locale). JSON string of LocalizedTextDto ({\"en\"?:string,\"el\"?:string}).
     */
    'max_guest_notice'?: string | null;
    /**
     * Reservation notice (max 1000 chars per locale). JSON string of LocalizedTextDto ({\"en\"?:string,\"el\"?:string}).
     */
    'reservation_notice'?: string | null;
    /**
     * Fully reserved message (max 1000 chars per locale). JSON string of LocalizedTextDto ({\"en\"?:string,\"el\"?:string}).
     */
    'fully_reserved_message'?: string | null;
    /**
     * Confirmation message (max 1000 chars per locale). JSON string of LocalizedTextDto ({\"en\"?:string,\"el\"?:string}).
     */
    'confirmation_message'?: string | null;
    /**
     * URL to redirect users after booking
     */
    'redirect_url'?: string | null;
    /**
     * URL to the reservation policy
     */
    'policy_url'?: string | null;
    /**
     * Inline reservation policy text (max 5000 chars per locale). JSON string of LocalizedTextDto ({\"en\"?:string,\"el\"?:string}).
     */
    'policy_text'?: string | null;
    /**
     * Set to \"true\" to remove the current logo image
     */
    'remove_logo_image'?: string;
    /**
     * Set to \"true\" to remove the current background image
     */
    'remove_background_image'?: string;
}
export interface WorkingHourSettingsDto {
    /**
     * Active status
     */
    'is_active': boolean;
    /**
     * Whether these settings apply to all areas
     */
    'apply_to_all_areas': boolean;
    /**
     * Array of area UUIDs to apply these settings to
     */
    'areas'?: Array<string> | null;
    /**
     * Seating configuration for this working hour
     */
    'seatings': WorkingHoursSeatingsDto;
    /**
     * Booking limits for this working hour
     */
    'limits': WorkingHoursLimitsDto;
    /**
     * Optional notes about this working hour
     */
    'notes'?: string | null;
}
export interface WorkingHours {
    /**
     * Working hour unique identifier
     */
    'uuid': string;
    /**
     * Store UUID this working hour belongs to
     */
    'store_uuid': string;
    /**
     * Day of the week (1-7, where 1=Monday)
     */
    'day': number;
    /**
     * Opening time
     */
    'from': string;
    /**
     * Closing time
     */
    'to': string;
    /**
     * Working hour title
     */
    'title': string;
    /**
     * Additional notes for this working hour
     */
    'notes'?: string | null;
    /**
     * When the working hour was last updated
     */
    'updated_at': string;
    /**
     * When the working hour was created
     */
    'created_at': string;
    /**
     * Reservation settings for this working hour
     */
    'reservation_settings'?: ReservationWorkingHourSettings;
}
export interface WorkingHoursLimitsDto {
    /**
     * Maximum number of bookings (0 for unlimited)
     */
    'maxBookings': number;
    /**
     * Minimum number of people (0 for no minimum)
     */
    'minPeople': number;
    /**
     * Maximum number of people (0 for unlimited)
     */
    'maxPeople': number;
    /**
     * Maximum bookings per time interval (0 for unlimited)
     */
    'maxBookingsPerInterval': number;
    /**
     * Maximum people per time interval (0 for unlimited)
     */
    'maxPeoplePerInterval': number;
    /**
     * Whether to count only online bookings for limits
     */
    'onlyCountOnlineBookings': boolean;
}
export interface WorkingHoursSeatingsDto {
    /**
     * Time interval between seatings in HH:MM format
     */
    'timeInterval': string;
    /**
     * Default seating duration in HH:MM format
     */
    'duration': string;
    /**
     * Custom duration rules based on party size
     */
    'durationRules'?: Array<SeatingDurationRuleDto> | null;
}
export interface ZoneDto {
    /**
     * Zone name
     */
    'name': string;
}
export interface Zones {
    /**
     * Zone unique identifier
     */
    'uuid': string;
    /**
     * Store UUID this zone belongs to
     */
    'store_uuid': string;
    /**
     * Zone name
     */
    'name': string;
    /**
     * Archived at timestamp
     */
    'archived_at'?: object;
    /**
     * When the zone was created
     */
    'created_at': string;
    /**
     * When the zone was last updated
     */
    'updated_at': string;
}

/**
 * AdminApi - axios parameter creator
 */
export const AdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminControllerGetAllUsersV1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/admin/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sign in as a user
         * @param {string} userUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminControllerSignInAsUserV1: async (userUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userUuid' is not null or undefined
            assertParamExists('adminControllerSignInAsUserV1', 'userUuid', userUuid)
            const localVarPath = `/v1/admin/sign-in-as-user/{user_uuid}`
                .replace('{user_uuid}', encodeURIComponent(String(userUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminApi - functional programming interface
 */
export const AdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminControllerGetAllUsersV1(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminControllerGetAllUsersV1(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.adminControllerGetAllUsersV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sign in as a user
         * @param {string} userUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminControllerSignInAsUserV1(userUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminControllerSignInAsUserV1(userUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.adminControllerSignInAsUserV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminApi - factory interface
 */
export const AdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminControllerGetAllUsersV1(options?: RawAxiosRequestConfig): AxiosPromise<Array<UserDto>> {
            return localVarFp.adminControllerGetAllUsersV1(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sign in as a user
         * @param {AdminApiAdminControllerSignInAsUserV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminControllerSignInAsUserV1(requestParameters: AdminApiAdminControllerSignInAsUserV1Request, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.adminControllerSignInAsUserV1(requestParameters.userUuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for adminControllerSignInAsUserV1 operation in AdminApi.
 */
export interface AdminApiAdminControllerSignInAsUserV1Request {
    readonly userUuid: string
}

/**
 * AdminApi - object-oriented interface
 */
export class AdminApi extends BaseAPI {
    /**
     * 
     * @summary Get all users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminControllerGetAllUsersV1(options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminControllerGetAllUsersV1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sign in as a user
     * @param {AdminApiAdminControllerSignInAsUserV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public adminControllerSignInAsUserV1(requestParameters: AdminApiAdminControllerSignInAsUserV1Request, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).adminControllerSignInAsUserV1(requestParameters.userUuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ArchivedReservationsApi - axios parameter creator
 */
export const ArchivedReservationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get an archived reservation details for the store
         * @param {string} storeUuid 
         * @param {string} reservationUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archivedReservationsControllerGetArchivedReservationV1: async (storeUuid: string, reservationUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('archivedReservationsControllerGetArchivedReservationV1', 'storeUuid', storeUuid)
            // verify required parameter 'reservationUuid' is not null or undefined
            assertParamExists('archivedReservationsControllerGetArchivedReservationV1', 'reservationUuid', reservationUuid)
            const localVarPath = `/v1/stores/{store_uuid}/archived-reservations/{reservation_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{reservation_uuid}', encodeURIComponent(String(reservationUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all archived reservations for the store based on filters
         * @param {string} storeUuid 
         * @param {number} page Page number for pagination
         * @param {string} [customerUuid] Customer UUID to filter by
         * @param {ArchivedReservationsControllerGetArchivedReservationsByFiltersV1StatusEnum} [status] Archived reservation status to filter by
         * @param {string} [date] Start date to filter from (inclusive) in DD-MM-YYYY format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archivedReservationsControllerGetArchivedReservationsByFiltersV1: async (storeUuid: string, page: number, customerUuid?: string, status?: ArchivedReservationsControllerGetArchivedReservationsByFiltersV1StatusEnum, date?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('archivedReservationsControllerGetArchivedReservationsByFiltersV1', 'storeUuid', storeUuid)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('archivedReservationsControllerGetArchivedReservationsByFiltersV1', 'page', page)
            const localVarPath = `/v1/stores/{store_uuid}/archived-reservations`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (customerUuid !== undefined) {
                localVarQueryParameter['customer_uuid'] = customerUuid;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArchivedReservationsApi - functional programming interface
 */
export const ArchivedReservationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ArchivedReservationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get an archived reservation details for the store
         * @param {string} storeUuid 
         * @param {string} reservationUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archivedReservationsControllerGetArchivedReservationV1(storeUuid: string, reservationUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Reservations>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archivedReservationsControllerGetArchivedReservationV1(storeUuid, reservationUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArchivedReservationsApi.archivedReservationsControllerGetArchivedReservationV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all archived reservations for the store based on filters
         * @param {string} storeUuid 
         * @param {number} page Page number for pagination
         * @param {string} [customerUuid] Customer UUID to filter by
         * @param {ArchivedReservationsControllerGetArchivedReservationsByFiltersV1StatusEnum} [status] Archived reservation status to filter by
         * @param {string} [date] Start date to filter from (inclusive) in DD-MM-YYYY format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archivedReservationsControllerGetArchivedReservationsByFiltersV1(storeUuid: string, page: number, customerUuid?: string, status?: ArchivedReservationsControllerGetArchivedReservationsByFiltersV1StatusEnum, date?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Reservations>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archivedReservationsControllerGetArchivedReservationsByFiltersV1(storeUuid, page, customerUuid, status, date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArchivedReservationsApi.archivedReservationsControllerGetArchivedReservationsByFiltersV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ArchivedReservationsApi - factory interface
 */
export const ArchivedReservationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ArchivedReservationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get an archived reservation details for the store
         * @param {ArchivedReservationsApiArchivedReservationsControllerGetArchivedReservationV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archivedReservationsControllerGetArchivedReservationV1(requestParameters: ArchivedReservationsApiArchivedReservationsControllerGetArchivedReservationV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Reservations> {
            return localVarFp.archivedReservationsControllerGetArchivedReservationV1(requestParameters.storeUuid, requestParameters.reservationUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all archived reservations for the store based on filters
         * @param {ArchivedReservationsApiArchivedReservationsControllerGetArchivedReservationsByFiltersV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archivedReservationsControllerGetArchivedReservationsByFiltersV1(requestParameters: ArchivedReservationsApiArchivedReservationsControllerGetArchivedReservationsByFiltersV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<Reservations>> {
            return localVarFp.archivedReservationsControllerGetArchivedReservationsByFiltersV1(requestParameters.storeUuid, requestParameters.page, requestParameters.customerUuid, requestParameters.status, requestParameters.date, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for archivedReservationsControllerGetArchivedReservationV1 operation in ArchivedReservationsApi.
 */
export interface ArchivedReservationsApiArchivedReservationsControllerGetArchivedReservationV1Request {
    readonly storeUuid: string

    readonly reservationUuid: string
}

/**
 * Request parameters for archivedReservationsControllerGetArchivedReservationsByFiltersV1 operation in ArchivedReservationsApi.
 */
export interface ArchivedReservationsApiArchivedReservationsControllerGetArchivedReservationsByFiltersV1Request {
    readonly storeUuid: string

    /**
     * Page number for pagination
     */
    readonly page: number

    /**
     * Customer UUID to filter by
     */
    readonly customerUuid?: string

    /**
     * Archived reservation status to filter by
     */
    readonly status?: ArchivedReservationsControllerGetArchivedReservationsByFiltersV1StatusEnum

    /**
     * Start date to filter from (inclusive) in DD-MM-YYYY format
     */
    readonly date?: string
}

/**
 * ArchivedReservationsApi - object-oriented interface
 */
export class ArchivedReservationsApi extends BaseAPI {
    /**
     * 
     * @summary Get an archived reservation details for the store
     * @param {ArchivedReservationsApiArchivedReservationsControllerGetArchivedReservationV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public archivedReservationsControllerGetArchivedReservationV1(requestParameters: ArchivedReservationsApiArchivedReservationsControllerGetArchivedReservationV1Request, options?: RawAxiosRequestConfig) {
        return ArchivedReservationsApiFp(this.configuration).archivedReservationsControllerGetArchivedReservationV1(requestParameters.storeUuid, requestParameters.reservationUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all archived reservations for the store based on filters
     * @param {ArchivedReservationsApiArchivedReservationsControllerGetArchivedReservationsByFiltersV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public archivedReservationsControllerGetArchivedReservationsByFiltersV1(requestParameters: ArchivedReservationsApiArchivedReservationsControllerGetArchivedReservationsByFiltersV1Request, options?: RawAxiosRequestConfig) {
        return ArchivedReservationsApiFp(this.configuration).archivedReservationsControllerGetArchivedReservationsByFiltersV1(requestParameters.storeUuid, requestParameters.page, requestParameters.customerUuid, requestParameters.status, requestParameters.date, options).then((request) => request(this.axios, this.basePath));
    }
}

export const ArchivedReservationsControllerGetArchivedReservationsByFiltersV1StatusEnum = {
    NotShown: 'not_shown',
    HasLeft: 'has_left',
    Cancelled: 'cancelled',
    Declined: 'declined',
} as const;
export type ArchivedReservationsControllerGetArchivedReservationsByFiltersV1StatusEnum = typeof ArchivedReservationsControllerGetArchivedReservationsByFiltersV1StatusEnum[keyof typeof ArchivedReservationsControllerGetArchivedReservationsByFiltersV1StatusEnum];


/**
 * AreasApi - axios parameter creator
 */
export const AreasApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new area for the store
         * @param {string} storeUuid 
         * @param {CreateAreaDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasControllerCreateAreaV1: async (storeUuid: string, body: CreateAreaDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('areasControllerCreateAreaV1', 'storeUuid', storeUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('areasControllerCreateAreaV1', 'body', body)
            const localVarPath = `/v1/stores/{store_uuid}/areas`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an area from the store
         * @param {string} storeUuid 
         * @param {string} areaUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasControllerDeleteAreaV1: async (storeUuid: string, areaUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('areasControllerDeleteAreaV1', 'storeUuid', storeUuid)
            // verify required parameter 'areaUuid' is not null or undefined
            assertParamExists('areasControllerDeleteAreaV1', 'areaUuid', areaUuid)
            const localVarPath = `/v1/stores/{store_uuid}/areas/{area_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{area_uuid}', encodeURIComponent(String(areaUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get details of a specific area in the store
         * @param {string} storeUuid 
         * @param {string} areaUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasControllerGetAreaV1: async (storeUuid: string, areaUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('areasControllerGetAreaV1', 'storeUuid', storeUuid)
            // verify required parameter 'areaUuid' is not null or undefined
            assertParamExists('areasControllerGetAreaV1', 'areaUuid', areaUuid)
            const localVarPath = `/v1/stores/{store_uuid}/areas/{area_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{area_uuid}', encodeURIComponent(String(areaUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all areas for the store
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasControllerGetAreasV1: async (storeUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('areasControllerGetAreasV1', 'storeUuid', storeUuid)
            const localVarPath = `/v1/stores/{store_uuid}/areas`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reorder areas in the store
         * @param {string} storeUuid 
         * @param {ReorderAreasDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasControllerReorderAreasV1: async (storeUuid: string, body: ReorderAreasDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('areasControllerReorderAreasV1', 'storeUuid', storeUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('areasControllerReorderAreasV1', 'body', body)
            const localVarPath = `/v1/stores/{store_uuid}/areas/reorder`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing area in the store
         * @param {string} storeUuid 
         * @param {string} areaUuid 
         * @param {UpdateAreaDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasControllerUpdateAreaV1: async (storeUuid: string, areaUuid: string, body: UpdateAreaDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('areasControllerUpdateAreaV1', 'storeUuid', storeUuid)
            // verify required parameter 'areaUuid' is not null or undefined
            assertParamExists('areasControllerUpdateAreaV1', 'areaUuid', areaUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('areasControllerUpdateAreaV1', 'body', body)
            const localVarPath = `/v1/stores/{store_uuid}/areas/{area_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{area_uuid}', encodeURIComponent(String(areaUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AreasApi - functional programming interface
 */
export const AreasApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AreasApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new area for the store
         * @param {string} storeUuid 
         * @param {CreateAreaDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async areasControllerCreateAreaV1(storeUuid: string, body: CreateAreaDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Areas>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.areasControllerCreateAreaV1(storeUuid, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AreasApi.areasControllerCreateAreaV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an area from the store
         * @param {string} storeUuid 
         * @param {string} areaUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async areasControllerDeleteAreaV1(storeUuid: string, areaUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.areasControllerDeleteAreaV1(storeUuid, areaUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AreasApi.areasControllerDeleteAreaV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get details of a specific area in the store
         * @param {string} storeUuid 
         * @param {string} areaUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async areasControllerGetAreaV1(storeUuid: string, areaUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Areas>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.areasControllerGetAreaV1(storeUuid, areaUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AreasApi.areasControllerGetAreaV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all areas for the store
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async areasControllerGetAreasV1(storeUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Areas>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.areasControllerGetAreasV1(storeUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AreasApi.areasControllerGetAreasV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reorder areas in the store
         * @param {string} storeUuid 
         * @param {ReorderAreasDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async areasControllerReorderAreasV1(storeUuid: string, body: ReorderAreasDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Areas>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.areasControllerReorderAreasV1(storeUuid, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AreasApi.areasControllerReorderAreasV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an existing area in the store
         * @param {string} storeUuid 
         * @param {string} areaUuid 
         * @param {UpdateAreaDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async areasControllerUpdateAreaV1(storeUuid: string, areaUuid: string, body: UpdateAreaDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Areas>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.areasControllerUpdateAreaV1(storeUuid, areaUuid, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AreasApi.areasControllerUpdateAreaV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AreasApi - factory interface
 */
export const AreasApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AreasApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new area for the store
         * @param {AreasApiAreasControllerCreateAreaV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasControllerCreateAreaV1(requestParameters: AreasApiAreasControllerCreateAreaV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Areas> {
            return localVarFp.areasControllerCreateAreaV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an area from the store
         * @param {AreasApiAreasControllerDeleteAreaV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasControllerDeleteAreaV1(requestParameters: AreasApiAreasControllerDeleteAreaV1Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.areasControllerDeleteAreaV1(requestParameters.storeUuid, requestParameters.areaUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get details of a specific area in the store
         * @param {AreasApiAreasControllerGetAreaV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasControllerGetAreaV1(requestParameters: AreasApiAreasControllerGetAreaV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Areas> {
            return localVarFp.areasControllerGetAreaV1(requestParameters.storeUuid, requestParameters.areaUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all areas for the store
         * @param {AreasApiAreasControllerGetAreasV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasControllerGetAreasV1(requestParameters: AreasApiAreasControllerGetAreasV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<Areas>> {
            return localVarFp.areasControllerGetAreasV1(requestParameters.storeUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reorder areas in the store
         * @param {AreasApiAreasControllerReorderAreasV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasControllerReorderAreasV1(requestParameters: AreasApiAreasControllerReorderAreasV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<Areas>> {
            return localVarFp.areasControllerReorderAreasV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing area in the store
         * @param {AreasApiAreasControllerUpdateAreaV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        areasControllerUpdateAreaV1(requestParameters: AreasApiAreasControllerUpdateAreaV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Areas> {
            return localVarFp.areasControllerUpdateAreaV1(requestParameters.storeUuid, requestParameters.areaUuid, requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for areasControllerCreateAreaV1 operation in AreasApi.
 */
export interface AreasApiAreasControllerCreateAreaV1Request {
    readonly storeUuid: string

    readonly body: CreateAreaDto
}

/**
 * Request parameters for areasControllerDeleteAreaV1 operation in AreasApi.
 */
export interface AreasApiAreasControllerDeleteAreaV1Request {
    readonly storeUuid: string

    readonly areaUuid: string
}

/**
 * Request parameters for areasControllerGetAreaV1 operation in AreasApi.
 */
export interface AreasApiAreasControllerGetAreaV1Request {
    readonly storeUuid: string

    readonly areaUuid: string
}

/**
 * Request parameters for areasControllerGetAreasV1 operation in AreasApi.
 */
export interface AreasApiAreasControllerGetAreasV1Request {
    readonly storeUuid: string
}

/**
 * Request parameters for areasControllerReorderAreasV1 operation in AreasApi.
 */
export interface AreasApiAreasControllerReorderAreasV1Request {
    readonly storeUuid: string

    readonly body: ReorderAreasDto
}

/**
 * Request parameters for areasControllerUpdateAreaV1 operation in AreasApi.
 */
export interface AreasApiAreasControllerUpdateAreaV1Request {
    readonly storeUuid: string

    readonly areaUuid: string

    readonly body: UpdateAreaDto
}

/**
 * AreasApi - object-oriented interface
 */
export class AreasApi extends BaseAPI {
    /**
     * 
     * @summary Create a new area for the store
     * @param {AreasApiAreasControllerCreateAreaV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public areasControllerCreateAreaV1(requestParameters: AreasApiAreasControllerCreateAreaV1Request, options?: RawAxiosRequestConfig) {
        return AreasApiFp(this.configuration).areasControllerCreateAreaV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an area from the store
     * @param {AreasApiAreasControllerDeleteAreaV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public areasControllerDeleteAreaV1(requestParameters: AreasApiAreasControllerDeleteAreaV1Request, options?: RawAxiosRequestConfig) {
        return AreasApiFp(this.configuration).areasControllerDeleteAreaV1(requestParameters.storeUuid, requestParameters.areaUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get details of a specific area in the store
     * @param {AreasApiAreasControllerGetAreaV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public areasControllerGetAreaV1(requestParameters: AreasApiAreasControllerGetAreaV1Request, options?: RawAxiosRequestConfig) {
        return AreasApiFp(this.configuration).areasControllerGetAreaV1(requestParameters.storeUuid, requestParameters.areaUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all areas for the store
     * @param {AreasApiAreasControllerGetAreasV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public areasControllerGetAreasV1(requestParameters: AreasApiAreasControllerGetAreasV1Request, options?: RawAxiosRequestConfig) {
        return AreasApiFp(this.configuration).areasControllerGetAreasV1(requestParameters.storeUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reorder areas in the store
     * @param {AreasApiAreasControllerReorderAreasV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public areasControllerReorderAreasV1(requestParameters: AreasApiAreasControllerReorderAreasV1Request, options?: RawAxiosRequestConfig) {
        return AreasApiFp(this.configuration).areasControllerReorderAreasV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing area in the store
     * @param {AreasApiAreasControllerUpdateAreaV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public areasControllerUpdateAreaV1(requestParameters: AreasApiAreasControllerUpdateAreaV1Request, options?: RawAxiosRequestConfig) {
        return AreasApiFp(this.configuration).areasControllerUpdateAreaV1(requestParameters.storeUuid, requestParameters.areaUuid, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomersApi - axios parameter creator
 */
export const CustomersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new customer for the store
         * @param {string} storeUuid 
         * @param {CreateCustomerDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersControllerCreateCustomerV1: async (storeUuid: string, body: CreateCustomerDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('customersControllerCreateCustomerV1', 'storeUuid', storeUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('customersControllerCreateCustomerV1', 'body', body)
            const localVarPath = `/v1/stores/{store_uuid}/customers`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a customer from the store
         * @param {string} storeUuid 
         * @param {string} customerUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersControllerDeleteCustomerV1: async (storeUuid: string, customerUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('customersControllerDeleteCustomerV1', 'storeUuid', storeUuid)
            // verify required parameter 'customerUuid' is not null or undefined
            assertParamExists('customersControllerDeleteCustomerV1', 'customerUuid', customerUuid)
            const localVarPath = `/v1/stores/{store_uuid}/customers/{customer_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{customer_uuid}', encodeURIComponent(String(customerUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get details of a specific customer in the store
         * @param {string} storeUuid 
         * @param {string} customerUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersControllerGetCustomerV1: async (storeUuid: string, customerUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('customersControllerGetCustomerV1', 'storeUuid', storeUuid)
            // verify required parameter 'customerUuid' is not null or undefined
            assertParamExists('customersControllerGetCustomerV1', 'customerUuid', customerUuid)
            const localVarPath = `/v1/stores/{store_uuid}/customers/{customer_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{customer_uuid}', encodeURIComponent(String(customerUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all customers for the store
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersControllerGetCustomersV1: async (storeUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('customersControllerGetCustomersV1', 'storeUuid', storeUuid)
            const localVarPath = `/v1/stores/{store_uuid}/customers`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing customer in the store
         * @param {string} storeUuid 
         * @param {string} customerUuid 
         * @param {UpdateCustomerDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersControllerUpdateCustomerV1: async (storeUuid: string, customerUuid: string, body: UpdateCustomerDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('customersControllerUpdateCustomerV1', 'storeUuid', storeUuid)
            // verify required parameter 'customerUuid' is not null or undefined
            assertParamExists('customersControllerUpdateCustomerV1', 'customerUuid', customerUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('customersControllerUpdateCustomerV1', 'body', body)
            const localVarPath = `/v1/stores/{store_uuid}/customers/{customer_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{customer_uuid}', encodeURIComponent(String(customerUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomersApi - functional programming interface
 */
export const CustomersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new customer for the store
         * @param {string} storeUuid 
         * @param {CreateCustomerDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customersControllerCreateCustomerV1(storeUuid: string, body: CreateCustomerDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Customers>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customersControllerCreateCustomerV1(storeUuid, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.customersControllerCreateCustomerV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a customer from the store
         * @param {string} storeUuid 
         * @param {string} customerUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customersControllerDeleteCustomerV1(storeUuid: string, customerUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customersControllerDeleteCustomerV1(storeUuid, customerUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.customersControllerDeleteCustomerV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get details of a specific customer in the store
         * @param {string} storeUuid 
         * @param {string} customerUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customersControllerGetCustomerV1(storeUuid: string, customerUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Customers>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customersControllerGetCustomerV1(storeUuid, customerUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.customersControllerGetCustomerV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all customers for the store
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customersControllerGetCustomersV1(storeUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Customers>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customersControllerGetCustomersV1(storeUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.customersControllerGetCustomersV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an existing customer in the store
         * @param {string} storeUuid 
         * @param {string} customerUuid 
         * @param {UpdateCustomerDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async customersControllerUpdateCustomerV1(storeUuid: string, customerUuid: string, body: UpdateCustomerDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Customers>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.customersControllerUpdateCustomerV1(storeUuid, customerUuid, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CustomersApi.customersControllerUpdateCustomerV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CustomersApi - factory interface
 */
export const CustomersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomersApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new customer for the store
         * @param {CustomersApiCustomersControllerCreateCustomerV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersControllerCreateCustomerV1(requestParameters: CustomersApiCustomersControllerCreateCustomerV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Customers> {
            return localVarFp.customersControllerCreateCustomerV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a customer from the store
         * @param {CustomersApiCustomersControllerDeleteCustomerV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersControllerDeleteCustomerV1(requestParameters: CustomersApiCustomersControllerDeleteCustomerV1Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.customersControllerDeleteCustomerV1(requestParameters.storeUuid, requestParameters.customerUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get details of a specific customer in the store
         * @param {CustomersApiCustomersControllerGetCustomerV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersControllerGetCustomerV1(requestParameters: CustomersApiCustomersControllerGetCustomerV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Customers> {
            return localVarFp.customersControllerGetCustomerV1(requestParameters.storeUuid, requestParameters.customerUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all customers for the store
         * @param {CustomersApiCustomersControllerGetCustomersV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersControllerGetCustomersV1(requestParameters: CustomersApiCustomersControllerGetCustomersV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<Customers>> {
            return localVarFp.customersControllerGetCustomersV1(requestParameters.storeUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing customer in the store
         * @param {CustomersApiCustomersControllerUpdateCustomerV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        customersControllerUpdateCustomerV1(requestParameters: CustomersApiCustomersControllerUpdateCustomerV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Customers> {
            return localVarFp.customersControllerUpdateCustomerV1(requestParameters.storeUuid, requestParameters.customerUuid, requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for customersControllerCreateCustomerV1 operation in CustomersApi.
 */
export interface CustomersApiCustomersControllerCreateCustomerV1Request {
    readonly storeUuid: string

    readonly body: CreateCustomerDto
}

/**
 * Request parameters for customersControllerDeleteCustomerV1 operation in CustomersApi.
 */
export interface CustomersApiCustomersControllerDeleteCustomerV1Request {
    readonly storeUuid: string

    readonly customerUuid: string
}

/**
 * Request parameters for customersControllerGetCustomerV1 operation in CustomersApi.
 */
export interface CustomersApiCustomersControllerGetCustomerV1Request {
    readonly storeUuid: string

    readonly customerUuid: string
}

/**
 * Request parameters for customersControllerGetCustomersV1 operation in CustomersApi.
 */
export interface CustomersApiCustomersControllerGetCustomersV1Request {
    readonly storeUuid: string
}

/**
 * Request parameters for customersControllerUpdateCustomerV1 operation in CustomersApi.
 */
export interface CustomersApiCustomersControllerUpdateCustomerV1Request {
    readonly storeUuid: string

    readonly customerUuid: string

    readonly body: UpdateCustomerDto
}

/**
 * CustomersApi - object-oriented interface
 */
export class CustomersApi extends BaseAPI {
    /**
     * 
     * @summary Create a new customer for the store
     * @param {CustomersApiCustomersControllerCreateCustomerV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public customersControllerCreateCustomerV1(requestParameters: CustomersApiCustomersControllerCreateCustomerV1Request, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).customersControllerCreateCustomerV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a customer from the store
     * @param {CustomersApiCustomersControllerDeleteCustomerV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public customersControllerDeleteCustomerV1(requestParameters: CustomersApiCustomersControllerDeleteCustomerV1Request, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).customersControllerDeleteCustomerV1(requestParameters.storeUuid, requestParameters.customerUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get details of a specific customer in the store
     * @param {CustomersApiCustomersControllerGetCustomerV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public customersControllerGetCustomerV1(requestParameters: CustomersApiCustomersControllerGetCustomerV1Request, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).customersControllerGetCustomerV1(requestParameters.storeUuid, requestParameters.customerUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all customers for the store
     * @param {CustomersApiCustomersControllerGetCustomersV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public customersControllerGetCustomersV1(requestParameters: CustomersApiCustomersControllerGetCustomersV1Request, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).customersControllerGetCustomersV1(requestParameters.storeUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing customer in the store
     * @param {CustomersApiCustomersControllerUpdateCustomerV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public customersControllerUpdateCustomerV1(requestParameters: CustomersApiCustomersControllerUpdateCustomerV1Request, options?: RawAxiosRequestConfig) {
        return CustomersApiFp(this.configuration).customersControllerUpdateCustomerV1(requestParameters.storeUuid, requestParameters.customerUuid, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FloorPlansApi - axios parameter creator
 */
export const FloorPlansApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new floor plan for the store
         * @param {string} storeUuid 
         * @param {CreateFloorPlanDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        floorPlanControllerCreateFloorPlanV1: async (storeUuid: string, body: CreateFloorPlanDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('floorPlanControllerCreateFloorPlanV1', 'storeUuid', storeUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('floorPlanControllerCreateFloorPlanV1', 'body', body)
            const localVarPath = `/v1/stores/{store_uuid}/floor-plans`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a floor plan from the store
         * @param {string} storeUuid 
         * @param {string} floorPlanUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        floorPlanControllerDeleteFloorPlanV1: async (storeUuid: string, floorPlanUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('floorPlanControllerDeleteFloorPlanV1', 'storeUuid', storeUuid)
            // verify required parameter 'floorPlanUuid' is not null or undefined
            assertParamExists('floorPlanControllerDeleteFloorPlanV1', 'floorPlanUuid', floorPlanUuid)
            const localVarPath = `/v1/stores/{store_uuid}/floor-plans/{floor_plan_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{floor_plan_uuid}', encodeURIComponent(String(floorPlanUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get details of a specific floor plan for the store
         * @param {string} storeUuid 
         * @param {string} floorPlanUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        floorPlanControllerGetFloorPlanV1: async (storeUuid: string, floorPlanUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('floorPlanControllerGetFloorPlanV1', 'storeUuid', storeUuid)
            // verify required parameter 'floorPlanUuid' is not null or undefined
            assertParamExists('floorPlanControllerGetFloorPlanV1', 'floorPlanUuid', floorPlanUuid)
            const localVarPath = `/v1/stores/{store_uuid}/floor-plans/{floor_plan_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{floor_plan_uuid}', encodeURIComponent(String(floorPlanUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all floor plans for the store
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        floorPlanControllerGetFloorPlansV1: async (storeUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('floorPlanControllerGetFloorPlansV1', 'storeUuid', storeUuid)
            const localVarPath = `/v1/stores/{store_uuid}/floor-plans`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing floor plan for the store
         * @param {string} storeUuid 
         * @param {string} floorPlanUuid 
         * @param {UpdateFloorPlanDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        floorPlanControllerUpdateFloorPlanV1: async (storeUuid: string, floorPlanUuid: string, body: UpdateFloorPlanDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('floorPlanControllerUpdateFloorPlanV1', 'storeUuid', storeUuid)
            // verify required parameter 'floorPlanUuid' is not null or undefined
            assertParamExists('floorPlanControllerUpdateFloorPlanV1', 'floorPlanUuid', floorPlanUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('floorPlanControllerUpdateFloorPlanV1', 'body', body)
            const localVarPath = `/v1/stores/{store_uuid}/floor-plans/{floor_plan_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{floor_plan_uuid}', encodeURIComponent(String(floorPlanUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FloorPlansApi - functional programming interface
 */
export const FloorPlansApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FloorPlansApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new floor plan for the store
         * @param {string} storeUuid 
         * @param {CreateFloorPlanDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async floorPlanControllerCreateFloorPlanV1(storeUuid: string, body: CreateFloorPlanDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FloorPlans>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.floorPlanControllerCreateFloorPlanV1(storeUuid, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FloorPlansApi.floorPlanControllerCreateFloorPlanV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a floor plan from the store
         * @param {string} storeUuid 
         * @param {string} floorPlanUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async floorPlanControllerDeleteFloorPlanV1(storeUuid: string, floorPlanUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.floorPlanControllerDeleteFloorPlanV1(storeUuid, floorPlanUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FloorPlansApi.floorPlanControllerDeleteFloorPlanV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get details of a specific floor plan for the store
         * @param {string} storeUuid 
         * @param {string} floorPlanUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async floorPlanControllerGetFloorPlanV1(storeUuid: string, floorPlanUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FloorPlans>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.floorPlanControllerGetFloorPlanV1(storeUuid, floorPlanUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FloorPlansApi.floorPlanControllerGetFloorPlanV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all floor plans for the store
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async floorPlanControllerGetFloorPlansV1(storeUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FloorPlans>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.floorPlanControllerGetFloorPlansV1(storeUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FloorPlansApi.floorPlanControllerGetFloorPlansV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an existing floor plan for the store
         * @param {string} storeUuid 
         * @param {string} floorPlanUuid 
         * @param {UpdateFloorPlanDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async floorPlanControllerUpdateFloorPlanV1(storeUuid: string, floorPlanUuid: string, body: UpdateFloorPlanDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FloorPlans>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.floorPlanControllerUpdateFloorPlanV1(storeUuid, floorPlanUuid, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FloorPlansApi.floorPlanControllerUpdateFloorPlanV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FloorPlansApi - factory interface
 */
export const FloorPlansApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FloorPlansApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new floor plan for the store
         * @param {FloorPlansApiFloorPlanControllerCreateFloorPlanV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        floorPlanControllerCreateFloorPlanV1(requestParameters: FloorPlansApiFloorPlanControllerCreateFloorPlanV1Request, options?: RawAxiosRequestConfig): AxiosPromise<FloorPlans> {
            return localVarFp.floorPlanControllerCreateFloorPlanV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a floor plan from the store
         * @param {FloorPlansApiFloorPlanControllerDeleteFloorPlanV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        floorPlanControllerDeleteFloorPlanV1(requestParameters: FloorPlansApiFloorPlanControllerDeleteFloorPlanV1Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.floorPlanControllerDeleteFloorPlanV1(requestParameters.storeUuid, requestParameters.floorPlanUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get details of a specific floor plan for the store
         * @param {FloorPlansApiFloorPlanControllerGetFloorPlanV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        floorPlanControllerGetFloorPlanV1(requestParameters: FloorPlansApiFloorPlanControllerGetFloorPlanV1Request, options?: RawAxiosRequestConfig): AxiosPromise<FloorPlans> {
            return localVarFp.floorPlanControllerGetFloorPlanV1(requestParameters.storeUuid, requestParameters.floorPlanUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all floor plans for the store
         * @param {FloorPlansApiFloorPlanControllerGetFloorPlansV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        floorPlanControllerGetFloorPlansV1(requestParameters: FloorPlansApiFloorPlanControllerGetFloorPlansV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<FloorPlans>> {
            return localVarFp.floorPlanControllerGetFloorPlansV1(requestParameters.storeUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing floor plan for the store
         * @param {FloorPlansApiFloorPlanControllerUpdateFloorPlanV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        floorPlanControllerUpdateFloorPlanV1(requestParameters: FloorPlansApiFloorPlanControllerUpdateFloorPlanV1Request, options?: RawAxiosRequestConfig): AxiosPromise<FloorPlans> {
            return localVarFp.floorPlanControllerUpdateFloorPlanV1(requestParameters.storeUuid, requestParameters.floorPlanUuid, requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for floorPlanControllerCreateFloorPlanV1 operation in FloorPlansApi.
 */
export interface FloorPlansApiFloorPlanControllerCreateFloorPlanV1Request {
    readonly storeUuid: string

    readonly body: CreateFloorPlanDto
}

/**
 * Request parameters for floorPlanControllerDeleteFloorPlanV1 operation in FloorPlansApi.
 */
export interface FloorPlansApiFloorPlanControllerDeleteFloorPlanV1Request {
    readonly storeUuid: string

    readonly floorPlanUuid: string
}

/**
 * Request parameters for floorPlanControllerGetFloorPlanV1 operation in FloorPlansApi.
 */
export interface FloorPlansApiFloorPlanControllerGetFloorPlanV1Request {
    readonly storeUuid: string

    readonly floorPlanUuid: string
}

/**
 * Request parameters for floorPlanControllerGetFloorPlansV1 operation in FloorPlansApi.
 */
export interface FloorPlansApiFloorPlanControllerGetFloorPlansV1Request {
    readonly storeUuid: string
}

/**
 * Request parameters for floorPlanControllerUpdateFloorPlanV1 operation in FloorPlansApi.
 */
export interface FloorPlansApiFloorPlanControllerUpdateFloorPlanV1Request {
    readonly storeUuid: string

    readonly floorPlanUuid: string

    readonly body: UpdateFloorPlanDto
}

/**
 * FloorPlansApi - object-oriented interface
 */
export class FloorPlansApi extends BaseAPI {
    /**
     * 
     * @summary Create a new floor plan for the store
     * @param {FloorPlansApiFloorPlanControllerCreateFloorPlanV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public floorPlanControllerCreateFloorPlanV1(requestParameters: FloorPlansApiFloorPlanControllerCreateFloorPlanV1Request, options?: RawAxiosRequestConfig) {
        return FloorPlansApiFp(this.configuration).floorPlanControllerCreateFloorPlanV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a floor plan from the store
     * @param {FloorPlansApiFloorPlanControllerDeleteFloorPlanV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public floorPlanControllerDeleteFloorPlanV1(requestParameters: FloorPlansApiFloorPlanControllerDeleteFloorPlanV1Request, options?: RawAxiosRequestConfig) {
        return FloorPlansApiFp(this.configuration).floorPlanControllerDeleteFloorPlanV1(requestParameters.storeUuid, requestParameters.floorPlanUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get details of a specific floor plan for the store
     * @param {FloorPlansApiFloorPlanControllerGetFloorPlanV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public floorPlanControllerGetFloorPlanV1(requestParameters: FloorPlansApiFloorPlanControllerGetFloorPlanV1Request, options?: RawAxiosRequestConfig) {
        return FloorPlansApiFp(this.configuration).floorPlanControllerGetFloorPlanV1(requestParameters.storeUuid, requestParameters.floorPlanUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all floor plans for the store
     * @param {FloorPlansApiFloorPlanControllerGetFloorPlansV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public floorPlanControllerGetFloorPlansV1(requestParameters: FloorPlansApiFloorPlanControllerGetFloorPlansV1Request, options?: RawAxiosRequestConfig) {
        return FloorPlansApiFp(this.configuration).floorPlanControllerGetFloorPlansV1(requestParameters.storeUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing floor plan for the store
     * @param {FloorPlansApiFloorPlanControllerUpdateFloorPlanV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public floorPlanControllerUpdateFloorPlanV1(requestParameters: FloorPlansApiFloorPlanControllerUpdateFloorPlanV1Request, options?: RawAxiosRequestConfig) {
        return FloorPlansApiFp(this.configuration).floorPlanControllerUpdateFloorPlanV1(requestParameters.storeUuid, requestParameters.floorPlanUuid, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HealthApi - axios parameter creator
 */
export const HealthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Health check endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthControllerCheck: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthApi - functional programming interface
 */
export const HealthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Health check endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthControllerCheck(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HealthControllerCheck200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthControllerCheck(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HealthApi.healthControllerCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HealthApi - factory interface
 */
export const HealthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthApiFp(configuration)
    return {
        /**
         * 
         * @summary Health check endpoint
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthControllerCheck(options?: RawAxiosRequestConfig): AxiosPromise<HealthControllerCheck200Response> {
            return localVarFp.healthControllerCheck(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HealthApi - object-oriented interface
 */
export class HealthApi extends BaseAPI {
    /**
     * 
     * @summary Health check endpoint
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public healthControllerCheck(options?: RawAxiosRequestConfig) {
        return HealthApiFp(this.configuration).healthControllerCheck(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InvitesApi - axios parameter creator
 */
export const InvitesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Accept an invite to the store
         * @param {string} storeUuid 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteControllerAcceptInviteV1: async (storeUuid: string, token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('inviteControllerAcceptInviteV1', 'storeUuid', storeUuid)
            // verify required parameter 'token' is not null or undefined
            assertParamExists('inviteControllerAcceptInviteV1', 'token', token)
            const localVarPath = `/v1/stores/{store_uuid}/invite/accept/{token}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{token}', encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all invites for the store
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteControllerGetInvitesV1: async (storeUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('inviteControllerGetInvitesV1', 'storeUuid', storeUuid)
            const localVarPath = `/v1/stores/{store_uuid}/invite`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Invite a new user to the store
         * @param {string} storeUuid 
         * @param {InviteDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteControllerInviteUserV1: async (storeUuid: string, body: InviteDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('inviteControllerInviteUserV1', 'storeUuid', storeUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('inviteControllerInviteUserV1', 'body', body)
            const localVarPath = `/v1/stores/{store_uuid}/invite`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Revoke an invite for the store
         * @param {string} storeUuid 
         * @param {string} inviteUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteControllerRevokeInviteV1: async (storeUuid: string, inviteUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('inviteControllerRevokeInviteV1', 'storeUuid', storeUuid)
            // verify required parameter 'inviteUuid' is not null or undefined
            assertParamExists('inviteControllerRevokeInviteV1', 'inviteUuid', inviteUuid)
            const localVarPath = `/v1/stores/{store_uuid}/invite/{invite_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{invite_uuid}', encodeURIComponent(String(inviteUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvitesApi - functional programming interface
 */
export const InvitesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvitesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Accept an invite to the store
         * @param {string} storeUuid 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteControllerAcceptInviteV1(storeUuid: string, token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inviteControllerAcceptInviteV1(storeUuid, token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitesApi.inviteControllerAcceptInviteV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all invites for the store
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteControllerGetInvitesV1(storeUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Invites>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inviteControllerGetInvitesV1(storeUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitesApi.inviteControllerGetInvitesV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Invite a new user to the store
         * @param {string} storeUuid 
         * @param {InviteDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteControllerInviteUserV1(storeUuid: string, body: InviteDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inviteControllerInviteUserV1(storeUuid, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitesApi.inviteControllerInviteUserV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Revoke an invite for the store
         * @param {string} storeUuid 
         * @param {string} inviteUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteControllerRevokeInviteV1(storeUuid: string, inviteUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inviteControllerRevokeInviteV1(storeUuid, inviteUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InvitesApi.inviteControllerRevokeInviteV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InvitesApi - factory interface
 */
export const InvitesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvitesApiFp(configuration)
    return {
        /**
         * 
         * @summary Accept an invite to the store
         * @param {InvitesApiInviteControllerAcceptInviteV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteControllerAcceptInviteV1(requestParameters: InvitesApiInviteControllerAcceptInviteV1Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.inviteControllerAcceptInviteV1(requestParameters.storeUuid, requestParameters.token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all invites for the store
         * @param {InvitesApiInviteControllerGetInvitesV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteControllerGetInvitesV1(requestParameters: InvitesApiInviteControllerGetInvitesV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<Invites>> {
            return localVarFp.inviteControllerGetInvitesV1(requestParameters.storeUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Invite a new user to the store
         * @param {InvitesApiInviteControllerInviteUserV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteControllerInviteUserV1(requestParameters: InvitesApiInviteControllerInviteUserV1Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.inviteControllerInviteUserV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Revoke an invite for the store
         * @param {InvitesApiInviteControllerRevokeInviteV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteControllerRevokeInviteV1(requestParameters: InvitesApiInviteControllerRevokeInviteV1Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.inviteControllerRevokeInviteV1(requestParameters.storeUuid, requestParameters.inviteUuid, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for inviteControllerAcceptInviteV1 operation in InvitesApi.
 */
export interface InvitesApiInviteControllerAcceptInviteV1Request {
    readonly storeUuid: string

    readonly token: string
}

/**
 * Request parameters for inviteControllerGetInvitesV1 operation in InvitesApi.
 */
export interface InvitesApiInviteControllerGetInvitesV1Request {
    readonly storeUuid: string
}

/**
 * Request parameters for inviteControllerInviteUserV1 operation in InvitesApi.
 */
export interface InvitesApiInviteControllerInviteUserV1Request {
    readonly storeUuid: string

    readonly body: InviteDto
}

/**
 * Request parameters for inviteControllerRevokeInviteV1 operation in InvitesApi.
 */
export interface InvitesApiInviteControllerRevokeInviteV1Request {
    readonly storeUuid: string

    readonly inviteUuid: string
}

/**
 * InvitesApi - object-oriented interface
 */
export class InvitesApi extends BaseAPI {
    /**
     * 
     * @summary Accept an invite to the store
     * @param {InvitesApiInviteControllerAcceptInviteV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inviteControllerAcceptInviteV1(requestParameters: InvitesApiInviteControllerAcceptInviteV1Request, options?: RawAxiosRequestConfig) {
        return InvitesApiFp(this.configuration).inviteControllerAcceptInviteV1(requestParameters.storeUuid, requestParameters.token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all invites for the store
     * @param {InvitesApiInviteControllerGetInvitesV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inviteControllerGetInvitesV1(requestParameters: InvitesApiInviteControllerGetInvitesV1Request, options?: RawAxiosRequestConfig) {
        return InvitesApiFp(this.configuration).inviteControllerGetInvitesV1(requestParameters.storeUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Invite a new user to the store
     * @param {InvitesApiInviteControllerInviteUserV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inviteControllerInviteUserV1(requestParameters: InvitesApiInviteControllerInviteUserV1Request, options?: RawAxiosRequestConfig) {
        return InvitesApiFp(this.configuration).inviteControllerInviteUserV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Revoke an invite for the store
     * @param {InvitesApiInviteControllerRevokeInviteV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inviteControllerRevokeInviteV1(requestParameters: InvitesApiInviteControllerRevokeInviteV1Request, options?: RawAxiosRequestConfig) {
        return InvitesApiFp(this.configuration).inviteControllerRevokeInviteV1(requestParameters.storeUuid, requestParameters.inviteUuid, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PublicAPIEndpointsApi - axios parameter creator
 */
export const PublicAPIEndpointsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cancel online reservation for the store
         * @param {string} storeDomain 
         * @param {string} reservationUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsPublicControllerCancelOnlineReservationV1: async (storeDomain: string, reservationUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeDomain' is not null or undefined
            assertParamExists('reservationsPublicControllerCancelOnlineReservationV1', 'storeDomain', storeDomain)
            // verify required parameter 'reservationUuid' is not null or undefined
            assertParamExists('reservationsPublicControllerCancelOnlineReservationV1', 'reservationUuid', reservationUuid)
            const localVarPath = `/v1/public/stores/{store_domain}/reservations/cancel/{reservation_uuid}`
                .replace('{store_domain}', encodeURIComponent(String(storeDomain)))
                .replace('{reservation_uuid}', encodeURIComponent(String(reservationUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Confirm online reservation for the store
         * @param {string} storeDomain 
         * @param {string} reservationUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsPublicControllerConfirmOnlineReservationV1: async (storeDomain: string, reservationUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeDomain' is not null or undefined
            assertParamExists('reservationsPublicControllerConfirmOnlineReservationV1', 'storeDomain', storeDomain)
            // verify required parameter 'reservationUuid' is not null or undefined
            assertParamExists('reservationsPublicControllerConfirmOnlineReservationV1', 'reservationUuid', reservationUuid)
            const localVarPath = `/v1/public/stores/{store_domain}/reservations/confirm/{reservation_uuid}`
                .replace('{store_domain}', encodeURIComponent(String(storeDomain)))
                .replace('{reservation_uuid}', encodeURIComponent(String(reservationUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new online reservation for the store
         * @param {string} storeDomain 
         * @param {OnlineReservationDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsPublicControllerCreateOnlineReservationV1: async (storeDomain: string, body: OnlineReservationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeDomain' is not null or undefined
            assertParamExists('reservationsPublicControllerCreateOnlineReservationV1', 'storeDomain', storeDomain)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('reservationsPublicControllerCreateOnlineReservationV1', 'body', body)
            const localVarPath = `/v1/public/stores/{store_domain}/reservations`
                .replace('{store_domain}', encodeURIComponent(String(storeDomain)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get online reservation for the store
         * @param {string} storeDomain 
         * @param {string} reservationUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsPublicControllerGetOnlineReservationV1: async (storeDomain: string, reservationUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeDomain' is not null or undefined
            assertParamExists('reservationsPublicControllerGetOnlineReservationV1', 'storeDomain', storeDomain)
            // verify required parameter 'reservationUuid' is not null or undefined
            assertParamExists('reservationsPublicControllerGetOnlineReservationV1', 'reservationUuid', reservationUuid)
            const localVarPath = `/v1/public/stores/{store_domain}/reservations/{reservation_uuid}`
                .replace('{store_domain}', encodeURIComponent(String(storeDomain)))
                .replace('{reservation_uuid}', encodeURIComponent(String(reservationUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get public online reservation time slots for the store
         * @param {string} storeDomain 
         * @param {string} date Requested reservation date
         * @param {number} adults Number of adults for the reservation
         * @param {number} children Number of children for the reservation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsPublicControllerGetPublicOnlineReservationTimeSlotsV1: async (storeDomain: string, date: string, adults: number, children: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeDomain' is not null or undefined
            assertParamExists('reservationsPublicControllerGetPublicOnlineReservationTimeSlotsV1', 'storeDomain', storeDomain)
            // verify required parameter 'date' is not null or undefined
            assertParamExists('reservationsPublicControllerGetPublicOnlineReservationTimeSlotsV1', 'date', date)
            // verify required parameter 'adults' is not null or undefined
            assertParamExists('reservationsPublicControllerGetPublicOnlineReservationTimeSlotsV1', 'adults', adults)
            // verify required parameter 'children' is not null or undefined
            assertParamExists('reservationsPublicControllerGetPublicOnlineReservationTimeSlotsV1', 'children', children)
            const localVarPath = `/v1/public/stores/{store_domain}/reservations/time-slots`
                .replace('{store_domain}', encodeURIComponent(String(storeDomain)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString().substring(0,10) :
                    date;
            }

            if (adults !== undefined) {
                localVarQueryParameter['adults'] = adults;
            }

            if (children !== undefined) {
                localVarQueryParameter['children'] = children;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get reservation store info and widget settings
         * @param {string} storeDomain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsPublicControllerGetReservationInfoV1: async (storeDomain: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeDomain' is not null or undefined
            assertParamExists('reservationsPublicControllerGetReservationInfoV1', 'storeDomain', storeDomain)
            const localVarPath = `/v1/public/stores/{store_domain}/reservations/info`
                .replace('{store_domain}', encodeURIComponent(String(storeDomain)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get public tracking identifiers for the store widget
         * @param {string} storeDomain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeTrackingPublicControllerGetPublicTrackingSettingsV1: async (storeDomain: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeDomain' is not null or undefined
            assertParamExists('storeTrackingPublicControllerGetPublicTrackingSettingsV1', 'storeDomain', storeDomain)
            const localVarPath = `/v1/public/stores/{store_domain}/tracking`
                .replace('{store_domain}', encodeURIComponent(String(storeDomain)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary User sign up
         * @param {CreateUserDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPublicControllerSignupV1: async (body: CreateUserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('usersPublicControllerSignupV1', 'body', body)
            const localVarPath = `/v1/public/users/signup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicAPIEndpointsApi - functional programming interface
 */
export const PublicAPIEndpointsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicAPIEndpointsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Cancel online reservation for the store
         * @param {string} storeDomain 
         * @param {string} reservationUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reservationsPublicControllerCancelOnlineReservationV1(storeDomain: string, reservationUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reservationsPublicControllerCancelOnlineReservationV1(storeDomain, reservationUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicAPIEndpointsApi.reservationsPublicControllerCancelOnlineReservationV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Confirm online reservation for the store
         * @param {string} storeDomain 
         * @param {string} reservationUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reservationsPublicControllerConfirmOnlineReservationV1(storeDomain: string, reservationUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reservationsPublicControllerConfirmOnlineReservationV1(storeDomain, reservationUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicAPIEndpointsApi.reservationsPublicControllerConfirmOnlineReservationV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new online reservation for the store
         * @param {string} storeDomain 
         * @param {OnlineReservationDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reservationsPublicControllerCreateOnlineReservationV1(storeDomain: string, body: OnlineReservationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Reservations>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reservationsPublicControllerCreateOnlineReservationV1(storeDomain, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicAPIEndpointsApi.reservationsPublicControllerCreateOnlineReservationV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get online reservation for the store
         * @param {string} storeDomain 
         * @param {string} reservationUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reservationsPublicControllerGetOnlineReservationV1(storeDomain: string, reservationUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Reservations>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reservationsPublicControllerGetOnlineReservationV1(storeDomain, reservationUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicAPIEndpointsApi.reservationsPublicControllerGetOnlineReservationV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get public online reservation time slots for the store
         * @param {string} storeDomain 
         * @param {string} date Requested reservation date
         * @param {number} adults Number of adults for the reservation
         * @param {number} children Number of children for the reservation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reservationsPublicControllerGetPublicOnlineReservationTimeSlotsV1(storeDomain: string, date: string, adults: number, children: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<OnlineReservationRequestResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reservationsPublicControllerGetPublicOnlineReservationTimeSlotsV1(storeDomain, date, adults, children, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicAPIEndpointsApi.reservationsPublicControllerGetPublicOnlineReservationTimeSlotsV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get reservation store info and widget settings
         * @param {string} storeDomain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reservationsPublicControllerGetReservationInfoV1(storeDomain: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReservationStoreInfoResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reservationsPublicControllerGetReservationInfoV1(storeDomain, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicAPIEndpointsApi.reservationsPublicControllerGetReservationInfoV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get public tracking identifiers for the store widget
         * @param {string} storeDomain 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeTrackingPublicControllerGetPublicTrackingSettingsV1(storeDomain: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PublicStoreTrackingDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeTrackingPublicControllerGetPublicTrackingSettingsV1(storeDomain, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicAPIEndpointsApi.storeTrackingPublicControllerGetPublicTrackingSettingsV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary User sign up
         * @param {CreateUserDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersPublicControllerSignupV1(body: CreateUserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Users>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersPublicControllerSignupV1(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicAPIEndpointsApi.usersPublicControllerSignupV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PublicAPIEndpointsApi - factory interface
 */
export const PublicAPIEndpointsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicAPIEndpointsApiFp(configuration)
    return {
        /**
         * 
         * @summary Cancel online reservation for the store
         * @param {PublicAPIEndpointsApiReservationsPublicControllerCancelOnlineReservationV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsPublicControllerCancelOnlineReservationV1(requestParameters: PublicAPIEndpointsApiReservationsPublicControllerCancelOnlineReservationV1Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reservationsPublicControllerCancelOnlineReservationV1(requestParameters.storeDomain, requestParameters.reservationUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Confirm online reservation for the store
         * @param {PublicAPIEndpointsApiReservationsPublicControllerConfirmOnlineReservationV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsPublicControllerConfirmOnlineReservationV1(requestParameters: PublicAPIEndpointsApiReservationsPublicControllerConfirmOnlineReservationV1Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reservationsPublicControllerConfirmOnlineReservationV1(requestParameters.storeDomain, requestParameters.reservationUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new online reservation for the store
         * @param {PublicAPIEndpointsApiReservationsPublicControllerCreateOnlineReservationV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsPublicControllerCreateOnlineReservationV1(requestParameters: PublicAPIEndpointsApiReservationsPublicControllerCreateOnlineReservationV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Reservations> {
            return localVarFp.reservationsPublicControllerCreateOnlineReservationV1(requestParameters.storeDomain, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get online reservation for the store
         * @param {PublicAPIEndpointsApiReservationsPublicControllerGetOnlineReservationV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsPublicControllerGetOnlineReservationV1(requestParameters: PublicAPIEndpointsApiReservationsPublicControllerGetOnlineReservationV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Reservations> {
            return localVarFp.reservationsPublicControllerGetOnlineReservationV1(requestParameters.storeDomain, requestParameters.reservationUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get public online reservation time slots for the store
         * @param {PublicAPIEndpointsApiReservationsPublicControllerGetPublicOnlineReservationTimeSlotsV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsPublicControllerGetPublicOnlineReservationTimeSlotsV1(requestParameters: PublicAPIEndpointsApiReservationsPublicControllerGetPublicOnlineReservationTimeSlotsV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<OnlineReservationRequestResponseDto>> {
            return localVarFp.reservationsPublicControllerGetPublicOnlineReservationTimeSlotsV1(requestParameters.storeDomain, requestParameters.date, requestParameters.adults, requestParameters.children, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get reservation store info and widget settings
         * @param {PublicAPIEndpointsApiReservationsPublicControllerGetReservationInfoV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsPublicControllerGetReservationInfoV1(requestParameters: PublicAPIEndpointsApiReservationsPublicControllerGetReservationInfoV1Request, options?: RawAxiosRequestConfig): AxiosPromise<ReservationStoreInfoResponseDto> {
            return localVarFp.reservationsPublicControllerGetReservationInfoV1(requestParameters.storeDomain, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get public tracking identifiers for the store widget
         * @param {PublicAPIEndpointsApiStoreTrackingPublicControllerGetPublicTrackingSettingsV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeTrackingPublicControllerGetPublicTrackingSettingsV1(requestParameters: PublicAPIEndpointsApiStoreTrackingPublicControllerGetPublicTrackingSettingsV1Request, options?: RawAxiosRequestConfig): AxiosPromise<PublicStoreTrackingDto> {
            return localVarFp.storeTrackingPublicControllerGetPublicTrackingSettingsV1(requestParameters.storeDomain, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary User sign up
         * @param {PublicAPIEndpointsApiUsersPublicControllerSignupV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersPublicControllerSignupV1(requestParameters: PublicAPIEndpointsApiUsersPublicControllerSignupV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Users> {
            return localVarFp.usersPublicControllerSignupV1(requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for reservationsPublicControllerCancelOnlineReservationV1 operation in PublicAPIEndpointsApi.
 */
export interface PublicAPIEndpointsApiReservationsPublicControllerCancelOnlineReservationV1Request {
    readonly storeDomain: string

    readonly reservationUuid: string
}

/**
 * Request parameters for reservationsPublicControllerConfirmOnlineReservationV1 operation in PublicAPIEndpointsApi.
 */
export interface PublicAPIEndpointsApiReservationsPublicControllerConfirmOnlineReservationV1Request {
    readonly storeDomain: string

    readonly reservationUuid: string
}

/**
 * Request parameters for reservationsPublicControllerCreateOnlineReservationV1 operation in PublicAPIEndpointsApi.
 */
export interface PublicAPIEndpointsApiReservationsPublicControllerCreateOnlineReservationV1Request {
    readonly storeDomain: string

    readonly body: OnlineReservationDto
}

/**
 * Request parameters for reservationsPublicControllerGetOnlineReservationV1 operation in PublicAPIEndpointsApi.
 */
export interface PublicAPIEndpointsApiReservationsPublicControllerGetOnlineReservationV1Request {
    readonly storeDomain: string

    readonly reservationUuid: string
}

/**
 * Request parameters for reservationsPublicControllerGetPublicOnlineReservationTimeSlotsV1 operation in PublicAPIEndpointsApi.
 */
export interface PublicAPIEndpointsApiReservationsPublicControllerGetPublicOnlineReservationTimeSlotsV1Request {
    readonly storeDomain: string

    /**
     * Requested reservation date
     */
    readonly date: string

    /**
     * Number of adults for the reservation
     */
    readonly adults: number

    /**
     * Number of children for the reservation
     */
    readonly children: number
}

/**
 * Request parameters for reservationsPublicControllerGetReservationInfoV1 operation in PublicAPIEndpointsApi.
 */
export interface PublicAPIEndpointsApiReservationsPublicControllerGetReservationInfoV1Request {
    readonly storeDomain: string
}

/**
 * Request parameters for storeTrackingPublicControllerGetPublicTrackingSettingsV1 operation in PublicAPIEndpointsApi.
 */
export interface PublicAPIEndpointsApiStoreTrackingPublicControllerGetPublicTrackingSettingsV1Request {
    readonly storeDomain: string
}

/**
 * Request parameters for usersPublicControllerSignupV1 operation in PublicAPIEndpointsApi.
 */
export interface PublicAPIEndpointsApiUsersPublicControllerSignupV1Request {
    readonly body: CreateUserDto
}

/**
 * PublicAPIEndpointsApi - object-oriented interface
 */
export class PublicAPIEndpointsApi extends BaseAPI {
    /**
     * 
     * @summary Cancel online reservation for the store
     * @param {PublicAPIEndpointsApiReservationsPublicControllerCancelOnlineReservationV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reservationsPublicControllerCancelOnlineReservationV1(requestParameters: PublicAPIEndpointsApiReservationsPublicControllerCancelOnlineReservationV1Request, options?: RawAxiosRequestConfig) {
        return PublicAPIEndpointsApiFp(this.configuration).reservationsPublicControllerCancelOnlineReservationV1(requestParameters.storeDomain, requestParameters.reservationUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Confirm online reservation for the store
     * @param {PublicAPIEndpointsApiReservationsPublicControllerConfirmOnlineReservationV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reservationsPublicControllerConfirmOnlineReservationV1(requestParameters: PublicAPIEndpointsApiReservationsPublicControllerConfirmOnlineReservationV1Request, options?: RawAxiosRequestConfig) {
        return PublicAPIEndpointsApiFp(this.configuration).reservationsPublicControllerConfirmOnlineReservationV1(requestParameters.storeDomain, requestParameters.reservationUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new online reservation for the store
     * @param {PublicAPIEndpointsApiReservationsPublicControllerCreateOnlineReservationV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reservationsPublicControllerCreateOnlineReservationV1(requestParameters: PublicAPIEndpointsApiReservationsPublicControllerCreateOnlineReservationV1Request, options?: RawAxiosRequestConfig) {
        return PublicAPIEndpointsApiFp(this.configuration).reservationsPublicControllerCreateOnlineReservationV1(requestParameters.storeDomain, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get online reservation for the store
     * @param {PublicAPIEndpointsApiReservationsPublicControllerGetOnlineReservationV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reservationsPublicControllerGetOnlineReservationV1(requestParameters: PublicAPIEndpointsApiReservationsPublicControllerGetOnlineReservationV1Request, options?: RawAxiosRequestConfig) {
        return PublicAPIEndpointsApiFp(this.configuration).reservationsPublicControllerGetOnlineReservationV1(requestParameters.storeDomain, requestParameters.reservationUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get public online reservation time slots for the store
     * @param {PublicAPIEndpointsApiReservationsPublicControllerGetPublicOnlineReservationTimeSlotsV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reservationsPublicControllerGetPublicOnlineReservationTimeSlotsV1(requestParameters: PublicAPIEndpointsApiReservationsPublicControllerGetPublicOnlineReservationTimeSlotsV1Request, options?: RawAxiosRequestConfig) {
        return PublicAPIEndpointsApiFp(this.configuration).reservationsPublicControllerGetPublicOnlineReservationTimeSlotsV1(requestParameters.storeDomain, requestParameters.date, requestParameters.adults, requestParameters.children, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get reservation store info and widget settings
     * @param {PublicAPIEndpointsApiReservationsPublicControllerGetReservationInfoV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reservationsPublicControllerGetReservationInfoV1(requestParameters: PublicAPIEndpointsApiReservationsPublicControllerGetReservationInfoV1Request, options?: RawAxiosRequestConfig) {
        return PublicAPIEndpointsApiFp(this.configuration).reservationsPublicControllerGetReservationInfoV1(requestParameters.storeDomain, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get public tracking identifiers for the store widget
     * @param {PublicAPIEndpointsApiStoreTrackingPublicControllerGetPublicTrackingSettingsV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storeTrackingPublicControllerGetPublicTrackingSettingsV1(requestParameters: PublicAPIEndpointsApiStoreTrackingPublicControllerGetPublicTrackingSettingsV1Request, options?: RawAxiosRequestConfig) {
        return PublicAPIEndpointsApiFp(this.configuration).storeTrackingPublicControllerGetPublicTrackingSettingsV1(requestParameters.storeDomain, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary User sign up
     * @param {PublicAPIEndpointsApiUsersPublicControllerSignupV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public usersPublicControllerSignupV1(requestParameters: PublicAPIEndpointsApiUsersPublicControllerSignupV1Request, options?: RawAxiosRequestConfig) {
        return PublicAPIEndpointsApiFp(this.configuration).usersPublicControllerSignupV1(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReservationSettingsApi - axios parameter creator
 */
export const ReservationSettingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get general reservation settings for the store
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsSettingsControllerGetGeneralSettingsV1: async (storeUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('reservationsSettingsControllerGetGeneralSettingsV1', 'storeUuid', storeUuid)
            const localVarPath = `/v1/stores/{store_uuid}/reservations/settings/general`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get reservation online settings for the store
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsSettingsControllerGetOnlineSettingsV1: async (storeUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('reservationsSettingsControllerGetOnlineSettingsV1', 'storeUuid', storeUuid)
            const localVarPath = `/v1/stores/{store_uuid}/reservations/settings/online`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get reservation widget settings
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsSettingsControllerGetReservationWidgetSettingsV1: async (storeUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('reservationsSettingsControllerGetReservationWidgetSettingsV1', 'storeUuid', storeUuid)
            const localVarPath = `/v1/stores/{store_uuid}/reservations/settings/widget`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set general reservation settings for the store
         * @param {string} storeUuid 
         * @param {GeneralSettingsDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsSettingsControllerSetGeneralSettingsV1: async (storeUuid: string, body: GeneralSettingsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('reservationsSettingsControllerSetGeneralSettingsV1', 'storeUuid', storeUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('reservationsSettingsControllerSetGeneralSettingsV1', 'body', body)
            const localVarPath = `/v1/stores/{store_uuid}/reservations/settings/general`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set online reservation settings for the store
         * @param {string} storeUuid 
         * @param {OnlineSettingsDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsSettingsControllerSetOnlineSettingsV1: async (storeUuid: string, body: OnlineSettingsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('reservationsSettingsControllerSetOnlineSettingsV1', 'storeUuid', storeUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('reservationsSettingsControllerSetOnlineSettingsV1', 'body', body)
            const localVarPath = `/v1/stores/{store_uuid}/reservations/settings/online`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Pause online reservations for the current day
         * @param {string} storeUuid 
         * @param {PauseOnlineSettingsDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsSettingsControllerSetPauseOnlineReservationsV1: async (storeUuid: string, body: PauseOnlineSettingsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('reservationsSettingsControllerSetPauseOnlineReservationsV1', 'storeUuid', storeUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('reservationsSettingsControllerSetPauseOnlineReservationsV1', 'body', body)
            const localVarPath = `/v1/stores/{store_uuid}/reservations/settings/online/pause`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set reservation widget settings with file uploads for the store
         * @param {string} storeUuid 
         * @param {string} [logoImage] Logo image file (jpg, jpeg, png, max 2MB)
         * @param {string} [backgroundImage] Background image file (jpg, jpeg, png, max 2MB)
         * @param {string} [accentColor] Accent color for the reservation widget in HEX format (e.g., #FF5733)
         * @param {string} [maxGuestNotice] Max guest notice (max 1000 chars per locale). JSON string of LocalizedTextDto ({\\\&quot;en\\\&quot;?:string,\\\&quot;el\\\&quot;?:string}).
         * @param {string} [reservationNotice] Reservation notice (max 1000 chars per locale). JSON string of LocalizedTextDto ({\\\&quot;en\\\&quot;?:string,\\\&quot;el\\\&quot;?:string}).
         * @param {string} [fullyReservedMessage] Fully reserved message (max 1000 chars per locale). JSON string of LocalizedTextDto ({\\\&quot;en\\\&quot;?:string,\\\&quot;el\\\&quot;?:string}).
         * @param {string} [confirmationMessage] Confirmation message (max 1000 chars per locale). JSON string of LocalizedTextDto ({\\\&quot;en\\\&quot;?:string,\\\&quot;el\\\&quot;?:string}).
         * @param {string} [redirectUrl] URL to redirect users after booking
         * @param {string} [policyUrl] URL to the reservation policy
         * @param {string} [policyText] Inline reservation policy text (max 5000 chars per locale). JSON string of LocalizedTextDto ({\\\&quot;en\\\&quot;?:string,\\\&quot;el\\\&quot;?:string}).
         * @param {string} [removeLogoImage] Set to \\\&quot;true\\\&quot; to remove the current logo image
         * @param {string} [removeBackgroundImage] Set to \\\&quot;true\\\&quot; to remove the current background image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsSettingsControllerSetReservationWidgetSettingsV1: async (storeUuid: string, logoImage?: string, backgroundImage?: string, accentColor?: string, maxGuestNotice?: string, reservationNotice?: string, fullyReservedMessage?: string, confirmationMessage?: string, redirectUrl?: string, policyUrl?: string, policyText?: string, removeLogoImage?: string, removeBackgroundImage?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('reservationsSettingsControllerSetReservationWidgetSettingsV1', 'storeUuid', storeUuid)
            const localVarPath = `/v1/stores/{store_uuid}/reservations/settings/widget`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)


            if (logoImage !== undefined) { 
                localVarFormParams.append('logo_image', logoImage as any);
            }

            if (backgroundImage !== undefined) { 
                localVarFormParams.append('background_image', backgroundImage as any);
            }

            if (accentColor !== undefined) { 
                localVarFormParams.append('accent_color', accentColor as any);
            }

            if (maxGuestNotice !== undefined) { 
                localVarFormParams.append('max_guest_notice', maxGuestNotice as any);
            }

            if (reservationNotice !== undefined) { 
                localVarFormParams.append('reservation_notice', reservationNotice as any);
            }

            if (fullyReservedMessage !== undefined) { 
                localVarFormParams.append('fully_reserved_message', fullyReservedMessage as any);
            }

            if (confirmationMessage !== undefined) { 
                localVarFormParams.append('confirmation_message', confirmationMessage as any);
            }

            if (redirectUrl !== undefined) { 
                localVarFormParams.append('redirect_url', redirectUrl as any);
            }

            if (policyUrl !== undefined) { 
                localVarFormParams.append('policy_url', policyUrl as any);
            }

            if (policyText !== undefined) { 
                localVarFormParams.append('policy_text', policyText as any);
            }

            if (removeLogoImage !== undefined) { 
                localVarFormParams.append('remove_logo_image', removeLogoImage as any);
            }

            if (removeBackgroundImage !== undefined) { 
                localVarFormParams.append('remove_background_image', removeBackgroundImage as any);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReservationSettingsApi - functional programming interface
 */
export const ReservationSettingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReservationSettingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get general reservation settings for the store
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reservationsSettingsControllerGetGeneralSettingsV1(storeUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReservationGeneralSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reservationsSettingsControllerGetGeneralSettingsV1(storeUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReservationSettingsApi.reservationsSettingsControllerGetGeneralSettingsV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get reservation online settings for the store
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reservationsSettingsControllerGetOnlineSettingsV1(storeUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReservationOnlineSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reservationsSettingsControllerGetOnlineSettingsV1(storeUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReservationSettingsApi.reservationsSettingsControllerGetOnlineSettingsV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get reservation widget settings
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reservationsSettingsControllerGetReservationWidgetSettingsV1(storeUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReservationWidgetSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reservationsSettingsControllerGetReservationWidgetSettingsV1(storeUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReservationSettingsApi.reservationsSettingsControllerGetReservationWidgetSettingsV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set general reservation settings for the store
         * @param {string} storeUuid 
         * @param {GeneralSettingsDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reservationsSettingsControllerSetGeneralSettingsV1(storeUuid: string, body: GeneralSettingsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReservationGeneralSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reservationsSettingsControllerSetGeneralSettingsV1(storeUuid, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReservationSettingsApi.reservationsSettingsControllerSetGeneralSettingsV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set online reservation settings for the store
         * @param {string} storeUuid 
         * @param {OnlineSettingsDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reservationsSettingsControllerSetOnlineSettingsV1(storeUuid: string, body: OnlineSettingsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReservationOnlineSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reservationsSettingsControllerSetOnlineSettingsV1(storeUuid, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReservationSettingsApi.reservationsSettingsControllerSetOnlineSettingsV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Pause online reservations for the current day
         * @param {string} storeUuid 
         * @param {PauseOnlineSettingsDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reservationsSettingsControllerSetPauseOnlineReservationsV1(storeUuid: string, body: PauseOnlineSettingsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReservationOnlineSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reservationsSettingsControllerSetPauseOnlineReservationsV1(storeUuid, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReservationSettingsApi.reservationsSettingsControllerSetPauseOnlineReservationsV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set reservation widget settings with file uploads for the store
         * @param {string} storeUuid 
         * @param {string} [logoImage] Logo image file (jpg, jpeg, png, max 2MB)
         * @param {string} [backgroundImage] Background image file (jpg, jpeg, png, max 2MB)
         * @param {string} [accentColor] Accent color for the reservation widget in HEX format (e.g., #FF5733)
         * @param {string} [maxGuestNotice] Max guest notice (max 1000 chars per locale). JSON string of LocalizedTextDto ({\\\&quot;en\\\&quot;?:string,\\\&quot;el\\\&quot;?:string}).
         * @param {string} [reservationNotice] Reservation notice (max 1000 chars per locale). JSON string of LocalizedTextDto ({\\\&quot;en\\\&quot;?:string,\\\&quot;el\\\&quot;?:string}).
         * @param {string} [fullyReservedMessage] Fully reserved message (max 1000 chars per locale). JSON string of LocalizedTextDto ({\\\&quot;en\\\&quot;?:string,\\\&quot;el\\\&quot;?:string}).
         * @param {string} [confirmationMessage] Confirmation message (max 1000 chars per locale). JSON string of LocalizedTextDto ({\\\&quot;en\\\&quot;?:string,\\\&quot;el\\\&quot;?:string}).
         * @param {string} [redirectUrl] URL to redirect users after booking
         * @param {string} [policyUrl] URL to the reservation policy
         * @param {string} [policyText] Inline reservation policy text (max 5000 chars per locale). JSON string of LocalizedTextDto ({\\\&quot;en\\\&quot;?:string,\\\&quot;el\\\&quot;?:string}).
         * @param {string} [removeLogoImage] Set to \\\&quot;true\\\&quot; to remove the current logo image
         * @param {string} [removeBackgroundImage] Set to \\\&quot;true\\\&quot; to remove the current background image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reservationsSettingsControllerSetReservationWidgetSettingsV1(storeUuid: string, logoImage?: string, backgroundImage?: string, accentColor?: string, maxGuestNotice?: string, reservationNotice?: string, fullyReservedMessage?: string, confirmationMessage?: string, redirectUrl?: string, policyUrl?: string, policyText?: string, removeLogoImage?: string, removeBackgroundImage?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReservationWidgetSettings>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reservationsSettingsControllerSetReservationWidgetSettingsV1(storeUuid, logoImage, backgroundImage, accentColor, maxGuestNotice, reservationNotice, fullyReservedMessage, confirmationMessage, redirectUrl, policyUrl, policyText, removeLogoImage, removeBackgroundImage, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReservationSettingsApi.reservationsSettingsControllerSetReservationWidgetSettingsV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReservationSettingsApi - factory interface
 */
export const ReservationSettingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReservationSettingsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get general reservation settings for the store
         * @param {ReservationSettingsApiReservationsSettingsControllerGetGeneralSettingsV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsSettingsControllerGetGeneralSettingsV1(requestParameters: ReservationSettingsApiReservationsSettingsControllerGetGeneralSettingsV1Request, options?: RawAxiosRequestConfig): AxiosPromise<ReservationGeneralSettings> {
            return localVarFp.reservationsSettingsControllerGetGeneralSettingsV1(requestParameters.storeUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get reservation online settings for the store
         * @param {ReservationSettingsApiReservationsSettingsControllerGetOnlineSettingsV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsSettingsControllerGetOnlineSettingsV1(requestParameters: ReservationSettingsApiReservationsSettingsControllerGetOnlineSettingsV1Request, options?: RawAxiosRequestConfig): AxiosPromise<ReservationOnlineSettings> {
            return localVarFp.reservationsSettingsControllerGetOnlineSettingsV1(requestParameters.storeUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get reservation widget settings
         * @param {ReservationSettingsApiReservationsSettingsControllerGetReservationWidgetSettingsV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsSettingsControllerGetReservationWidgetSettingsV1(requestParameters: ReservationSettingsApiReservationsSettingsControllerGetReservationWidgetSettingsV1Request, options?: RawAxiosRequestConfig): AxiosPromise<ReservationWidgetSettings> {
            return localVarFp.reservationsSettingsControllerGetReservationWidgetSettingsV1(requestParameters.storeUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set general reservation settings for the store
         * @param {ReservationSettingsApiReservationsSettingsControllerSetGeneralSettingsV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsSettingsControllerSetGeneralSettingsV1(requestParameters: ReservationSettingsApiReservationsSettingsControllerSetGeneralSettingsV1Request, options?: RawAxiosRequestConfig): AxiosPromise<ReservationGeneralSettings> {
            return localVarFp.reservationsSettingsControllerSetGeneralSettingsV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set online reservation settings for the store
         * @param {ReservationSettingsApiReservationsSettingsControllerSetOnlineSettingsV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsSettingsControllerSetOnlineSettingsV1(requestParameters: ReservationSettingsApiReservationsSettingsControllerSetOnlineSettingsV1Request, options?: RawAxiosRequestConfig): AxiosPromise<ReservationOnlineSettings> {
            return localVarFp.reservationsSettingsControllerSetOnlineSettingsV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Pause online reservations for the current day
         * @param {ReservationSettingsApiReservationsSettingsControllerSetPauseOnlineReservationsV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsSettingsControllerSetPauseOnlineReservationsV1(requestParameters: ReservationSettingsApiReservationsSettingsControllerSetPauseOnlineReservationsV1Request, options?: RawAxiosRequestConfig): AxiosPromise<ReservationOnlineSettings> {
            return localVarFp.reservationsSettingsControllerSetPauseOnlineReservationsV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set reservation widget settings with file uploads for the store
         * @param {ReservationSettingsApiReservationsSettingsControllerSetReservationWidgetSettingsV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsSettingsControllerSetReservationWidgetSettingsV1(requestParameters: ReservationSettingsApiReservationsSettingsControllerSetReservationWidgetSettingsV1Request, options?: RawAxiosRequestConfig): AxiosPromise<ReservationWidgetSettings> {
            return localVarFp.reservationsSettingsControllerSetReservationWidgetSettingsV1(requestParameters.storeUuid, requestParameters.logoImage, requestParameters.backgroundImage, requestParameters.accentColor, requestParameters.maxGuestNotice, requestParameters.reservationNotice, requestParameters.fullyReservedMessage, requestParameters.confirmationMessage, requestParameters.redirectUrl, requestParameters.policyUrl, requestParameters.policyText, requestParameters.removeLogoImage, requestParameters.removeBackgroundImage, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for reservationsSettingsControllerGetGeneralSettingsV1 operation in ReservationSettingsApi.
 */
export interface ReservationSettingsApiReservationsSettingsControllerGetGeneralSettingsV1Request {
    readonly storeUuid: string
}

/**
 * Request parameters for reservationsSettingsControllerGetOnlineSettingsV1 operation in ReservationSettingsApi.
 */
export interface ReservationSettingsApiReservationsSettingsControllerGetOnlineSettingsV1Request {
    readonly storeUuid: string
}

/**
 * Request parameters for reservationsSettingsControllerGetReservationWidgetSettingsV1 operation in ReservationSettingsApi.
 */
export interface ReservationSettingsApiReservationsSettingsControllerGetReservationWidgetSettingsV1Request {
    readonly storeUuid: string
}

/**
 * Request parameters for reservationsSettingsControllerSetGeneralSettingsV1 operation in ReservationSettingsApi.
 */
export interface ReservationSettingsApiReservationsSettingsControllerSetGeneralSettingsV1Request {
    readonly storeUuid: string

    readonly body: GeneralSettingsDto
}

/**
 * Request parameters for reservationsSettingsControllerSetOnlineSettingsV1 operation in ReservationSettingsApi.
 */
export interface ReservationSettingsApiReservationsSettingsControllerSetOnlineSettingsV1Request {
    readonly storeUuid: string

    readonly body: OnlineSettingsDto
}

/**
 * Request parameters for reservationsSettingsControllerSetPauseOnlineReservationsV1 operation in ReservationSettingsApi.
 */
export interface ReservationSettingsApiReservationsSettingsControllerSetPauseOnlineReservationsV1Request {
    readonly storeUuid: string

    readonly body: PauseOnlineSettingsDto
}

/**
 * Request parameters for reservationsSettingsControllerSetReservationWidgetSettingsV1 operation in ReservationSettingsApi.
 */
export interface ReservationSettingsApiReservationsSettingsControllerSetReservationWidgetSettingsV1Request {
    readonly storeUuid: string

    /**
     * Logo image file (jpg, jpeg, png, max 2MB)
     */
    readonly logoImage?: string

    /**
     * Background image file (jpg, jpeg, png, max 2MB)
     */
    readonly backgroundImage?: string

    /**
     * Accent color for the reservation widget in HEX format (e.g., #FF5733)
     */
    readonly accentColor?: string

    /**
     * Max guest notice (max 1000 chars per locale). JSON string of LocalizedTextDto ({\\\&quot;en\\\&quot;?:string,\\\&quot;el\\\&quot;?:string}).
     */
    readonly maxGuestNotice?: string

    /**
     * Reservation notice (max 1000 chars per locale). JSON string of LocalizedTextDto ({\\\&quot;en\\\&quot;?:string,\\\&quot;el\\\&quot;?:string}).
     */
    readonly reservationNotice?: string

    /**
     * Fully reserved message (max 1000 chars per locale). JSON string of LocalizedTextDto ({\\\&quot;en\\\&quot;?:string,\\\&quot;el\\\&quot;?:string}).
     */
    readonly fullyReservedMessage?: string

    /**
     * Confirmation message (max 1000 chars per locale). JSON string of LocalizedTextDto ({\\\&quot;en\\\&quot;?:string,\\\&quot;el\\\&quot;?:string}).
     */
    readonly confirmationMessage?: string

    /**
     * URL to redirect users after booking
     */
    readonly redirectUrl?: string

    /**
     * URL to the reservation policy
     */
    readonly policyUrl?: string

    /**
     * Inline reservation policy text (max 5000 chars per locale). JSON string of LocalizedTextDto ({\\\&quot;en\\\&quot;?:string,\\\&quot;el\\\&quot;?:string}).
     */
    readonly policyText?: string

    /**
     * Set to \\\&quot;true\\\&quot; to remove the current logo image
     */
    readonly removeLogoImage?: string

    /**
     * Set to \\\&quot;true\\\&quot; to remove the current background image
     */
    readonly removeBackgroundImage?: string
}

/**
 * ReservationSettingsApi - object-oriented interface
 */
export class ReservationSettingsApi extends BaseAPI {
    /**
     * 
     * @summary Get general reservation settings for the store
     * @param {ReservationSettingsApiReservationsSettingsControllerGetGeneralSettingsV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reservationsSettingsControllerGetGeneralSettingsV1(requestParameters: ReservationSettingsApiReservationsSettingsControllerGetGeneralSettingsV1Request, options?: RawAxiosRequestConfig) {
        return ReservationSettingsApiFp(this.configuration).reservationsSettingsControllerGetGeneralSettingsV1(requestParameters.storeUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get reservation online settings for the store
     * @param {ReservationSettingsApiReservationsSettingsControllerGetOnlineSettingsV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reservationsSettingsControllerGetOnlineSettingsV1(requestParameters: ReservationSettingsApiReservationsSettingsControllerGetOnlineSettingsV1Request, options?: RawAxiosRequestConfig) {
        return ReservationSettingsApiFp(this.configuration).reservationsSettingsControllerGetOnlineSettingsV1(requestParameters.storeUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get reservation widget settings
     * @param {ReservationSettingsApiReservationsSettingsControllerGetReservationWidgetSettingsV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reservationsSettingsControllerGetReservationWidgetSettingsV1(requestParameters: ReservationSettingsApiReservationsSettingsControllerGetReservationWidgetSettingsV1Request, options?: RawAxiosRequestConfig) {
        return ReservationSettingsApiFp(this.configuration).reservationsSettingsControllerGetReservationWidgetSettingsV1(requestParameters.storeUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set general reservation settings for the store
     * @param {ReservationSettingsApiReservationsSettingsControllerSetGeneralSettingsV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reservationsSettingsControllerSetGeneralSettingsV1(requestParameters: ReservationSettingsApiReservationsSettingsControllerSetGeneralSettingsV1Request, options?: RawAxiosRequestConfig) {
        return ReservationSettingsApiFp(this.configuration).reservationsSettingsControllerSetGeneralSettingsV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set online reservation settings for the store
     * @param {ReservationSettingsApiReservationsSettingsControllerSetOnlineSettingsV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reservationsSettingsControllerSetOnlineSettingsV1(requestParameters: ReservationSettingsApiReservationsSettingsControllerSetOnlineSettingsV1Request, options?: RawAxiosRequestConfig) {
        return ReservationSettingsApiFp(this.configuration).reservationsSettingsControllerSetOnlineSettingsV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Pause online reservations for the current day
     * @param {ReservationSettingsApiReservationsSettingsControllerSetPauseOnlineReservationsV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reservationsSettingsControllerSetPauseOnlineReservationsV1(requestParameters: ReservationSettingsApiReservationsSettingsControllerSetPauseOnlineReservationsV1Request, options?: RawAxiosRequestConfig) {
        return ReservationSettingsApiFp(this.configuration).reservationsSettingsControllerSetPauseOnlineReservationsV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set reservation widget settings with file uploads for the store
     * @param {ReservationSettingsApiReservationsSettingsControllerSetReservationWidgetSettingsV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reservationsSettingsControllerSetReservationWidgetSettingsV1(requestParameters: ReservationSettingsApiReservationsSettingsControllerSetReservationWidgetSettingsV1Request, options?: RawAxiosRequestConfig) {
        return ReservationSettingsApiFp(this.configuration).reservationsSettingsControllerSetReservationWidgetSettingsV1(requestParameters.storeUuid, requestParameters.logoImage, requestParameters.backgroundImage, requestParameters.accentColor, requestParameters.maxGuestNotice, requestParameters.reservationNotice, requestParameters.fullyReservedMessage, requestParameters.confirmationMessage, requestParameters.redirectUrl, requestParameters.policyUrl, requestParameters.policyText, requestParameters.removeLogoImage, requestParameters.removeBackgroundImage, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReservationsApi - axios parameter creator
 */
export const ReservationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new reservation for the store
         * @param {string} storeUuid 
         * @param {CreateReservationDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsControllerCreateReservationV1: async (storeUuid: string, body: CreateReservationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('reservationsControllerCreateReservationV1', 'storeUuid', storeUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('reservationsControllerCreateReservationV1', 'body', body)
            const localVarPath = `/v1/stores/{store_uuid}/reservations`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get reservation change history
         * @param {string} storeUuid 
         * @param {string} reservationUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsControllerGetReservationHistoryV1: async (storeUuid: string, reservationUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('reservationsControllerGetReservationHistoryV1', 'storeUuid', storeUuid)
            // verify required parameter 'reservationUuid' is not null or undefined
            assertParamExists('reservationsControllerGetReservationHistoryV1', 'reservationUuid', reservationUuid)
            const localVarPath = `/v1/stores/{store_uuid}/reservations/{reservation_uuid}/history`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{reservation_uuid}', encodeURIComponent(String(reservationUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get reservation details
         * @param {string} storeUuid 
         * @param {string} reservationUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsControllerGetReservationV1: async (storeUuid: string, reservationUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('reservationsControllerGetReservationV1', 'storeUuid', storeUuid)
            // verify required parameter 'reservationUuid' is not null or undefined
            assertParamExists('reservationsControllerGetReservationV1', 'reservationUuid', reservationUuid)
            const localVarPath = `/v1/stores/{store_uuid}/reservations/{reservation_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{reservation_uuid}', encodeURIComponent(String(reservationUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all reservations for the store
         * @param {string} storeUuid 
         * @param {number} page Page number for pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsControllerGetReservationsV1: async (storeUuid: string, page: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('reservationsControllerGetReservationsV1', 'storeUuid', storeUuid)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('reservationsControllerGetReservationsV1', 'page', page)
            const localVarPath = `/v1/stores/{store_uuid}/reservations`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update reservation
         * @param {string} storeUuid 
         * @param {string} reservationUuid 
         * @param {UpdateReservationDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsControllerUpdateReservationV1: async (storeUuid: string, reservationUuid: string, body: UpdateReservationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('reservationsControllerUpdateReservationV1', 'storeUuid', storeUuid)
            // verify required parameter 'reservationUuid' is not null or undefined
            assertParamExists('reservationsControllerUpdateReservationV1', 'reservationUuid', reservationUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('reservationsControllerUpdateReservationV1', 'body', body)
            const localVarPath = `/v1/stores/{store_uuid}/reservations/{reservation_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{reservation_uuid}', encodeURIComponent(String(reservationUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReservationsApi - functional programming interface
 */
export const ReservationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReservationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new reservation for the store
         * @param {string} storeUuid 
         * @param {CreateReservationDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reservationsControllerCreateReservationV1(storeUuid: string, body: CreateReservationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Reservations>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reservationsControllerCreateReservationV1(storeUuid, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReservationsApi.reservationsControllerCreateReservationV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get reservation change history
         * @param {string} storeUuid 
         * @param {string} reservationUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reservationsControllerGetReservationHistoryV1(storeUuid: string, reservationUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReservationHistoryEntryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reservationsControllerGetReservationHistoryV1(storeUuid, reservationUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReservationsApi.reservationsControllerGetReservationHistoryV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get reservation details
         * @param {string} storeUuid 
         * @param {string} reservationUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reservationsControllerGetReservationV1(storeUuid: string, reservationUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Reservations>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reservationsControllerGetReservationV1(storeUuid, reservationUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReservationsApi.reservationsControllerGetReservationV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all reservations for the store
         * @param {string} storeUuid 
         * @param {number} page Page number for pagination
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reservationsControllerGetReservationsV1(storeUuid: string, page: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Reservations>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reservationsControllerGetReservationsV1(storeUuid, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReservationsApi.reservationsControllerGetReservationsV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update reservation
         * @param {string} storeUuid 
         * @param {string} reservationUuid 
         * @param {UpdateReservationDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reservationsControllerUpdateReservationV1(storeUuid: string, reservationUuid: string, body: UpdateReservationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Reservations>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reservationsControllerUpdateReservationV1(storeUuid, reservationUuid, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReservationsApi.reservationsControllerUpdateReservationV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReservationsApi - factory interface
 */
export const ReservationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReservationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new reservation for the store
         * @param {ReservationsApiReservationsControllerCreateReservationV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsControllerCreateReservationV1(requestParameters: ReservationsApiReservationsControllerCreateReservationV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Reservations> {
            return localVarFp.reservationsControllerCreateReservationV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get reservation change history
         * @param {ReservationsApiReservationsControllerGetReservationHistoryV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsControllerGetReservationHistoryV1(requestParameters: ReservationsApiReservationsControllerGetReservationHistoryV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<ReservationHistoryEntryDto>> {
            return localVarFp.reservationsControllerGetReservationHistoryV1(requestParameters.storeUuid, requestParameters.reservationUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get reservation details
         * @param {ReservationsApiReservationsControllerGetReservationV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsControllerGetReservationV1(requestParameters: ReservationsApiReservationsControllerGetReservationV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Reservations> {
            return localVarFp.reservationsControllerGetReservationV1(requestParameters.storeUuid, requestParameters.reservationUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all reservations for the store
         * @param {ReservationsApiReservationsControllerGetReservationsV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsControllerGetReservationsV1(requestParameters: ReservationsApiReservationsControllerGetReservationsV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<Reservations>> {
            return localVarFp.reservationsControllerGetReservationsV1(requestParameters.storeUuid, requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update reservation
         * @param {ReservationsApiReservationsControllerUpdateReservationV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reservationsControllerUpdateReservationV1(requestParameters: ReservationsApiReservationsControllerUpdateReservationV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Reservations> {
            return localVarFp.reservationsControllerUpdateReservationV1(requestParameters.storeUuid, requestParameters.reservationUuid, requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for reservationsControllerCreateReservationV1 operation in ReservationsApi.
 */
export interface ReservationsApiReservationsControllerCreateReservationV1Request {
    readonly storeUuid: string

    readonly body: CreateReservationDto
}

/**
 * Request parameters for reservationsControllerGetReservationHistoryV1 operation in ReservationsApi.
 */
export interface ReservationsApiReservationsControllerGetReservationHistoryV1Request {
    readonly storeUuid: string

    readonly reservationUuid: string
}

/**
 * Request parameters for reservationsControllerGetReservationV1 operation in ReservationsApi.
 */
export interface ReservationsApiReservationsControllerGetReservationV1Request {
    readonly storeUuid: string

    readonly reservationUuid: string
}

/**
 * Request parameters for reservationsControllerGetReservationsV1 operation in ReservationsApi.
 */
export interface ReservationsApiReservationsControllerGetReservationsV1Request {
    readonly storeUuid: string

    /**
     * Page number for pagination
     */
    readonly page: number
}

/**
 * Request parameters for reservationsControllerUpdateReservationV1 operation in ReservationsApi.
 */
export interface ReservationsApiReservationsControllerUpdateReservationV1Request {
    readonly storeUuid: string

    readonly reservationUuid: string

    readonly body: UpdateReservationDto
}

/**
 * ReservationsApi - object-oriented interface
 */
export class ReservationsApi extends BaseAPI {
    /**
     * 
     * @summary Create a new reservation for the store
     * @param {ReservationsApiReservationsControllerCreateReservationV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reservationsControllerCreateReservationV1(requestParameters: ReservationsApiReservationsControllerCreateReservationV1Request, options?: RawAxiosRequestConfig) {
        return ReservationsApiFp(this.configuration).reservationsControllerCreateReservationV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get reservation change history
     * @param {ReservationsApiReservationsControllerGetReservationHistoryV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reservationsControllerGetReservationHistoryV1(requestParameters: ReservationsApiReservationsControllerGetReservationHistoryV1Request, options?: RawAxiosRequestConfig) {
        return ReservationsApiFp(this.configuration).reservationsControllerGetReservationHistoryV1(requestParameters.storeUuid, requestParameters.reservationUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get reservation details
     * @param {ReservationsApiReservationsControllerGetReservationV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reservationsControllerGetReservationV1(requestParameters: ReservationsApiReservationsControllerGetReservationV1Request, options?: RawAxiosRequestConfig) {
        return ReservationsApiFp(this.configuration).reservationsControllerGetReservationV1(requestParameters.storeUuid, requestParameters.reservationUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all reservations for the store
     * @param {ReservationsApiReservationsControllerGetReservationsV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reservationsControllerGetReservationsV1(requestParameters: ReservationsApiReservationsControllerGetReservationsV1Request, options?: RawAxiosRequestConfig) {
        return ReservationsApiFp(this.configuration).reservationsControllerGetReservationsV1(requestParameters.storeUuid, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update reservation
     * @param {ReservationsApiReservationsControllerUpdateReservationV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public reservationsControllerUpdateReservationV1(requestParameters: ReservationsApiReservationsControllerUpdateReservationV1Request, options?: RawAxiosRequestConfig) {
        return ReservationsApiFp(this.configuration).reservationsControllerUpdateReservationV1(requestParameters.storeUuid, requestParameters.reservationUuid, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RolesApi - axios parameter creator
 */
export const RolesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get all users with their roles in the store
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerGetStoreUsersV1: async (storeUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('rolesControllerGetStoreUsersV1', 'storeUuid', storeUuid)
            const localVarPath = `/v1/stores/{store_uuid}/roles`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the role of a specific user in the store
         * @param {string} storeUuid 
         * @param {string} userUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerGetUserRoleV1: async (storeUuid: string, userUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('rolesControllerGetUserRoleV1', 'storeUuid', storeUuid)
            // verify required parameter 'userUuid' is not null or undefined
            assertParamExists('rolesControllerGetUserRoleV1', 'userUuid', userUuid)
            const localVarPath = `/v1/stores/{store_uuid}/roles/{user_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{user_uuid}', encodeURIComponent(String(userUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Revoke a user\'s role in the store
         * @param {string} storeUuid 
         * @param {string} userUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerRevokeRoleV1: async (storeUuid: string, userUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('rolesControllerRevokeRoleV1', 'storeUuid', storeUuid)
            // verify required parameter 'userUuid' is not null or undefined
            assertParamExists('rolesControllerRevokeRoleV1', 'userUuid', userUuid)
            const localVarPath = `/v1/stores/{store_uuid}/roles/{user_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{user_uuid}', encodeURIComponent(String(userUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Assign a role to a user in the store
         * @param {string} storeUuid 
         * @param {UserRoleDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerUpdateRoleV1: async (storeUuid: string, body: UserRoleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('rolesControllerUpdateRoleV1', 'storeUuid', storeUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('rolesControllerUpdateRoleV1', 'body', body)
            const localVarPath = `/v1/stores/{store_uuid}/roles`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RolesApi - functional programming interface
 */
export const RolesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RolesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get all users with their roles in the store
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rolesControllerGetStoreUsersV1(storeUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Roles>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rolesControllerGetStoreUsersV1(storeUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.rolesControllerGetStoreUsersV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the role of a specific user in the store
         * @param {string} storeUuid 
         * @param {string} userUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rolesControllerGetUserRoleV1(storeUuid: string, userUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rolesControllerGetUserRoleV1(storeUuid, userUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.rolesControllerGetUserRoleV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Revoke a user\'s role in the store
         * @param {string} storeUuid 
         * @param {string} userUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rolesControllerRevokeRoleV1(storeUuid: string, userUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rolesControllerRevokeRoleV1(storeUuid, userUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.rolesControllerRevokeRoleV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Assign a role to a user in the store
         * @param {string} storeUuid 
         * @param {UserRoleDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rolesControllerUpdateRoleV1(storeUuid: string, body: UserRoleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Roles>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rolesControllerUpdateRoleV1(storeUuid, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RolesApi.rolesControllerUpdateRoleV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RolesApi - factory interface
 */
export const RolesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RolesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get all users with their roles in the store
         * @param {RolesApiRolesControllerGetStoreUsersV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerGetStoreUsersV1(requestParameters: RolesApiRolesControllerGetStoreUsersV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<Roles>> {
            return localVarFp.rolesControllerGetStoreUsersV1(requestParameters.storeUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the role of a specific user in the store
         * @param {RolesApiRolesControllerGetUserRoleV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerGetUserRoleV1(requestParameters: RolesApiRolesControllerGetUserRoleV1Request, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.rolesControllerGetUserRoleV1(requestParameters.storeUuid, requestParameters.userUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Revoke a user\'s role in the store
         * @param {RolesApiRolesControllerRevokeRoleV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerRevokeRoleV1(requestParameters: RolesApiRolesControllerRevokeRoleV1Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.rolesControllerRevokeRoleV1(requestParameters.storeUuid, requestParameters.userUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Assign a role to a user in the store
         * @param {RolesApiRolesControllerUpdateRoleV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rolesControllerUpdateRoleV1(requestParameters: RolesApiRolesControllerUpdateRoleV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Roles> {
            return localVarFp.rolesControllerUpdateRoleV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for rolesControllerGetStoreUsersV1 operation in RolesApi.
 */
export interface RolesApiRolesControllerGetStoreUsersV1Request {
    readonly storeUuid: string
}

/**
 * Request parameters for rolesControllerGetUserRoleV1 operation in RolesApi.
 */
export interface RolesApiRolesControllerGetUserRoleV1Request {
    readonly storeUuid: string

    readonly userUuid: string
}

/**
 * Request parameters for rolesControllerRevokeRoleV1 operation in RolesApi.
 */
export interface RolesApiRolesControllerRevokeRoleV1Request {
    readonly storeUuid: string

    readonly userUuid: string
}

/**
 * Request parameters for rolesControllerUpdateRoleV1 operation in RolesApi.
 */
export interface RolesApiRolesControllerUpdateRoleV1Request {
    readonly storeUuid: string

    readonly body: UserRoleDto
}

/**
 * RolesApi - object-oriented interface
 */
export class RolesApi extends BaseAPI {
    /**
     * 
     * @summary Get all users with their roles in the store
     * @param {RolesApiRolesControllerGetStoreUsersV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rolesControllerGetStoreUsersV1(requestParameters: RolesApiRolesControllerGetStoreUsersV1Request, options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).rolesControllerGetStoreUsersV1(requestParameters.storeUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the role of a specific user in the store
     * @param {RolesApiRolesControllerGetUserRoleV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rolesControllerGetUserRoleV1(requestParameters: RolesApiRolesControllerGetUserRoleV1Request, options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).rolesControllerGetUserRoleV1(requestParameters.storeUuid, requestParameters.userUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Revoke a user\'s role in the store
     * @param {RolesApiRolesControllerRevokeRoleV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rolesControllerRevokeRoleV1(requestParameters: RolesApiRolesControllerRevokeRoleV1Request, options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).rolesControllerRevokeRoleV1(requestParameters.storeUuid, requestParameters.userUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Assign a role to a user in the store
     * @param {RolesApiRolesControllerUpdateRoleV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public rolesControllerUpdateRoleV1(requestParameters: RolesApiRolesControllerUpdateRoleV1Request, options?: RawAxiosRequestConfig) {
        return RolesApiFp(this.configuration).rolesControllerUpdateRoleV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SpecialWorkingHoursApi - axios parameter creator
 */
export const SpecialWorkingHoursApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new special working hour for the store
         * @param {string} storeUuid 
         * @param {CreateSpecialWorkingHourDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specialWorkingHoursControllerCreateSpecialWorkingHourV1: async (storeUuid: string, body: CreateSpecialWorkingHourDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('specialWorkingHoursControllerCreateSpecialWorkingHourV1', 'storeUuid', storeUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('specialWorkingHoursControllerCreateSpecialWorkingHourV1', 'body', body)
            const localVarPath = `/v1/stores/{store_uuid}/special-working-hours`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a special working hour from the store
         * @param {string} storeUuid 
         * @param {string} specialWorkingHourUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specialWorkingHoursControllerDeleteSpecialWorkingHourV1: async (storeUuid: string, specialWorkingHourUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('specialWorkingHoursControllerDeleteSpecialWorkingHourV1', 'storeUuid', storeUuid)
            // verify required parameter 'specialWorkingHourUuid' is not null or undefined
            assertParamExists('specialWorkingHoursControllerDeleteSpecialWorkingHourV1', 'specialWorkingHourUuid', specialWorkingHourUuid)
            const localVarPath = `/v1/stores/{store_uuid}/special-working-hours/{special_working_hour_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{special_working_hour_uuid}', encodeURIComponent(String(specialWorkingHourUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get details of a specific special working hour for the store
         * @param {string} storeUuid 
         * @param {string} specialWorkingHourUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specialWorkingHoursControllerGetSpecialWorkingHourV1: async (storeUuid: string, specialWorkingHourUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('specialWorkingHoursControllerGetSpecialWorkingHourV1', 'storeUuid', storeUuid)
            // verify required parameter 'specialWorkingHourUuid' is not null or undefined
            assertParamExists('specialWorkingHoursControllerGetSpecialWorkingHourV1', 'specialWorkingHourUuid', specialWorkingHourUuid)
            const localVarPath = `/v1/stores/{store_uuid}/special-working-hours/{special_working_hour_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{special_working_hour_uuid}', encodeURIComponent(String(specialWorkingHourUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all special working hours for the store
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specialWorkingHoursControllerGetSpecialWorkingHoursV1: async (storeUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('specialWorkingHoursControllerGetSpecialWorkingHoursV1', 'storeUuid', storeUuid)
            const localVarPath = `/v1/stores/{store_uuid}/special-working-hours`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing special working hour for the store
         * @param {string} storeUuid 
         * @param {string} specialWorkingHourUuid 
         * @param {UpdateSpecialWorkingHourDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specialWorkingHoursControllerUpdateSpecialWorkingHourV1: async (storeUuid: string, specialWorkingHourUuid: string, body: UpdateSpecialWorkingHourDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('specialWorkingHoursControllerUpdateSpecialWorkingHourV1', 'storeUuid', storeUuid)
            // verify required parameter 'specialWorkingHourUuid' is not null or undefined
            assertParamExists('specialWorkingHoursControllerUpdateSpecialWorkingHourV1', 'specialWorkingHourUuid', specialWorkingHourUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('specialWorkingHoursControllerUpdateSpecialWorkingHourV1', 'body', body)
            const localVarPath = `/v1/stores/{store_uuid}/special-working-hours/{special_working_hour_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{special_working_hour_uuid}', encodeURIComponent(String(specialWorkingHourUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SpecialWorkingHoursApi - functional programming interface
 */
export const SpecialWorkingHoursApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SpecialWorkingHoursApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new special working hour for the store
         * @param {string} storeUuid 
         * @param {CreateSpecialWorkingHourDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async specialWorkingHoursControllerCreateSpecialWorkingHourV1(storeUuid: string, body: CreateSpecialWorkingHourDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpecialWorkingHours>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.specialWorkingHoursControllerCreateSpecialWorkingHourV1(storeUuid, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpecialWorkingHoursApi.specialWorkingHoursControllerCreateSpecialWorkingHourV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a special working hour from the store
         * @param {string} storeUuid 
         * @param {string} specialWorkingHourUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async specialWorkingHoursControllerDeleteSpecialWorkingHourV1(storeUuid: string, specialWorkingHourUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.specialWorkingHoursControllerDeleteSpecialWorkingHourV1(storeUuid, specialWorkingHourUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpecialWorkingHoursApi.specialWorkingHoursControllerDeleteSpecialWorkingHourV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get details of a specific special working hour for the store
         * @param {string} storeUuid 
         * @param {string} specialWorkingHourUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async specialWorkingHoursControllerGetSpecialWorkingHourV1(storeUuid: string, specialWorkingHourUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpecialWorkingHours>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.specialWorkingHoursControllerGetSpecialWorkingHourV1(storeUuid, specialWorkingHourUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpecialWorkingHoursApi.specialWorkingHoursControllerGetSpecialWorkingHourV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all special working hours for the store
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async specialWorkingHoursControllerGetSpecialWorkingHoursV1(storeUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SpecialWorkingHours>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.specialWorkingHoursControllerGetSpecialWorkingHoursV1(storeUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpecialWorkingHoursApi.specialWorkingHoursControllerGetSpecialWorkingHoursV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an existing special working hour for the store
         * @param {string} storeUuid 
         * @param {string} specialWorkingHourUuid 
         * @param {UpdateSpecialWorkingHourDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async specialWorkingHoursControllerUpdateSpecialWorkingHourV1(storeUuid: string, specialWorkingHourUuid: string, body: UpdateSpecialWorkingHourDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SpecialWorkingHours>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.specialWorkingHoursControllerUpdateSpecialWorkingHourV1(storeUuid, specialWorkingHourUuid, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SpecialWorkingHoursApi.specialWorkingHoursControllerUpdateSpecialWorkingHourV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SpecialWorkingHoursApi - factory interface
 */
export const SpecialWorkingHoursApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SpecialWorkingHoursApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new special working hour for the store
         * @param {SpecialWorkingHoursApiSpecialWorkingHoursControllerCreateSpecialWorkingHourV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specialWorkingHoursControllerCreateSpecialWorkingHourV1(requestParameters: SpecialWorkingHoursApiSpecialWorkingHoursControllerCreateSpecialWorkingHourV1Request, options?: RawAxiosRequestConfig): AxiosPromise<SpecialWorkingHours> {
            return localVarFp.specialWorkingHoursControllerCreateSpecialWorkingHourV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a special working hour from the store
         * @param {SpecialWorkingHoursApiSpecialWorkingHoursControllerDeleteSpecialWorkingHourV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specialWorkingHoursControllerDeleteSpecialWorkingHourV1(requestParameters: SpecialWorkingHoursApiSpecialWorkingHoursControllerDeleteSpecialWorkingHourV1Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.specialWorkingHoursControllerDeleteSpecialWorkingHourV1(requestParameters.storeUuid, requestParameters.specialWorkingHourUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get details of a specific special working hour for the store
         * @param {SpecialWorkingHoursApiSpecialWorkingHoursControllerGetSpecialWorkingHourV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specialWorkingHoursControllerGetSpecialWorkingHourV1(requestParameters: SpecialWorkingHoursApiSpecialWorkingHoursControllerGetSpecialWorkingHourV1Request, options?: RawAxiosRequestConfig): AxiosPromise<SpecialWorkingHours> {
            return localVarFp.specialWorkingHoursControllerGetSpecialWorkingHourV1(requestParameters.storeUuid, requestParameters.specialWorkingHourUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all special working hours for the store
         * @param {SpecialWorkingHoursApiSpecialWorkingHoursControllerGetSpecialWorkingHoursV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specialWorkingHoursControllerGetSpecialWorkingHoursV1(requestParameters: SpecialWorkingHoursApiSpecialWorkingHoursControllerGetSpecialWorkingHoursV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<SpecialWorkingHours>> {
            return localVarFp.specialWorkingHoursControllerGetSpecialWorkingHoursV1(requestParameters.storeUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing special working hour for the store
         * @param {SpecialWorkingHoursApiSpecialWorkingHoursControllerUpdateSpecialWorkingHourV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        specialWorkingHoursControllerUpdateSpecialWorkingHourV1(requestParameters: SpecialWorkingHoursApiSpecialWorkingHoursControllerUpdateSpecialWorkingHourV1Request, options?: RawAxiosRequestConfig): AxiosPromise<SpecialWorkingHours> {
            return localVarFp.specialWorkingHoursControllerUpdateSpecialWorkingHourV1(requestParameters.storeUuid, requestParameters.specialWorkingHourUuid, requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for specialWorkingHoursControllerCreateSpecialWorkingHourV1 operation in SpecialWorkingHoursApi.
 */
export interface SpecialWorkingHoursApiSpecialWorkingHoursControllerCreateSpecialWorkingHourV1Request {
    readonly storeUuid: string

    readonly body: CreateSpecialWorkingHourDto
}

/**
 * Request parameters for specialWorkingHoursControllerDeleteSpecialWorkingHourV1 operation in SpecialWorkingHoursApi.
 */
export interface SpecialWorkingHoursApiSpecialWorkingHoursControllerDeleteSpecialWorkingHourV1Request {
    readonly storeUuid: string

    readonly specialWorkingHourUuid: string
}

/**
 * Request parameters for specialWorkingHoursControllerGetSpecialWorkingHourV1 operation in SpecialWorkingHoursApi.
 */
export interface SpecialWorkingHoursApiSpecialWorkingHoursControllerGetSpecialWorkingHourV1Request {
    readonly storeUuid: string

    readonly specialWorkingHourUuid: string
}

/**
 * Request parameters for specialWorkingHoursControllerGetSpecialWorkingHoursV1 operation in SpecialWorkingHoursApi.
 */
export interface SpecialWorkingHoursApiSpecialWorkingHoursControllerGetSpecialWorkingHoursV1Request {
    readonly storeUuid: string
}

/**
 * Request parameters for specialWorkingHoursControllerUpdateSpecialWorkingHourV1 operation in SpecialWorkingHoursApi.
 */
export interface SpecialWorkingHoursApiSpecialWorkingHoursControllerUpdateSpecialWorkingHourV1Request {
    readonly storeUuid: string

    readonly specialWorkingHourUuid: string

    readonly body: UpdateSpecialWorkingHourDto
}

/**
 * SpecialWorkingHoursApi - object-oriented interface
 */
export class SpecialWorkingHoursApi extends BaseAPI {
    /**
     * 
     * @summary Create a new special working hour for the store
     * @param {SpecialWorkingHoursApiSpecialWorkingHoursControllerCreateSpecialWorkingHourV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public specialWorkingHoursControllerCreateSpecialWorkingHourV1(requestParameters: SpecialWorkingHoursApiSpecialWorkingHoursControllerCreateSpecialWorkingHourV1Request, options?: RawAxiosRequestConfig) {
        return SpecialWorkingHoursApiFp(this.configuration).specialWorkingHoursControllerCreateSpecialWorkingHourV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a special working hour from the store
     * @param {SpecialWorkingHoursApiSpecialWorkingHoursControllerDeleteSpecialWorkingHourV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public specialWorkingHoursControllerDeleteSpecialWorkingHourV1(requestParameters: SpecialWorkingHoursApiSpecialWorkingHoursControllerDeleteSpecialWorkingHourV1Request, options?: RawAxiosRequestConfig) {
        return SpecialWorkingHoursApiFp(this.configuration).specialWorkingHoursControllerDeleteSpecialWorkingHourV1(requestParameters.storeUuid, requestParameters.specialWorkingHourUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get details of a specific special working hour for the store
     * @param {SpecialWorkingHoursApiSpecialWorkingHoursControllerGetSpecialWorkingHourV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public specialWorkingHoursControllerGetSpecialWorkingHourV1(requestParameters: SpecialWorkingHoursApiSpecialWorkingHoursControllerGetSpecialWorkingHourV1Request, options?: RawAxiosRequestConfig) {
        return SpecialWorkingHoursApiFp(this.configuration).specialWorkingHoursControllerGetSpecialWorkingHourV1(requestParameters.storeUuid, requestParameters.specialWorkingHourUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all special working hours for the store
     * @param {SpecialWorkingHoursApiSpecialWorkingHoursControllerGetSpecialWorkingHoursV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public specialWorkingHoursControllerGetSpecialWorkingHoursV1(requestParameters: SpecialWorkingHoursApiSpecialWorkingHoursControllerGetSpecialWorkingHoursV1Request, options?: RawAxiosRequestConfig) {
        return SpecialWorkingHoursApiFp(this.configuration).specialWorkingHoursControllerGetSpecialWorkingHoursV1(requestParameters.storeUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing special working hour for the store
     * @param {SpecialWorkingHoursApiSpecialWorkingHoursControllerUpdateSpecialWorkingHourV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public specialWorkingHoursControllerUpdateSpecialWorkingHourV1(requestParameters: SpecialWorkingHoursApiSpecialWorkingHoursControllerUpdateSpecialWorkingHourV1Request, options?: RawAxiosRequestConfig) {
        return SpecialWorkingHoursApiFp(this.configuration).specialWorkingHoursControllerUpdateSpecialWorkingHourV1(requestParameters.storeUuid, requestParameters.specialWorkingHourUuid, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StatisticsApi - axios parameter creator
 */
export const StatisticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get customer-specific statistics
         * @param {string} storeUuid 
         * @param {string} customerUuid 
         * @param {number} page Page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsControllerGetCustomerStatisticsV1: async (storeUuid: string, customerUuid: string, page: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('statisticsControllerGetCustomerStatisticsV1', 'storeUuid', storeUuid)
            // verify required parameter 'customerUuid' is not null or undefined
            assertParamExists('statisticsControllerGetCustomerStatisticsV1', 'customerUuid', customerUuid)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('statisticsControllerGetCustomerStatisticsV1', 'page', page)
            const localVarPath = `/v1/stores/{store_uuid}/statistics/customer/{customer_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{customer_uuid}', encodeURIComponent(String(customerUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get comprehensive statistics for a date range
         * @param {string} storeUuid 
         * @param {string} start Start date for statistics range
         * @param {string} end End date for statistics range
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsControllerGetStatisticsV1: async (storeUuid: string, start: string, end: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('statisticsControllerGetStatisticsV1', 'storeUuid', storeUuid)
            // verify required parameter 'start' is not null or undefined
            assertParamExists('statisticsControllerGetStatisticsV1', 'start', start)
            // verify required parameter 'end' is not null or undefined
            assertParamExists('statisticsControllerGetStatisticsV1', 'end', end)
            const localVarPath = `/v1/stores/{store_uuid}/statistics`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            if (start !== undefined) {
                localVarQueryParameter['start'] = (start as any instanceof Date) ?
                    (start as any).toISOString().substring(0,10) :
                    start;
            }

            if (end !== undefined) {
                localVarQueryParameter['end'] = (end as any instanceof Date) ?
                    (end as any).toISOString().substring(0,10) :
                    end;
            }

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatisticsApi - functional programming interface
 */
export const StatisticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StatisticsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get customer-specific statistics
         * @param {string} storeUuid 
         * @param {string} customerUuid 
         * @param {number} page Page number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsControllerGetCustomerStatisticsV1(storeUuid: string, customerUuid: string, page: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomerStatisticsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsControllerGetCustomerStatisticsV1(storeUuid, customerUuid, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApi.statisticsControllerGetCustomerStatisticsV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get comprehensive statistics for a date range
         * @param {string} storeUuid 
         * @param {string} start Start date for statistics range
         * @param {string} end End date for statistics range
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async statisticsControllerGetStatisticsV1(storeUuid: string, start: string, end: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StoreStatisticsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.statisticsControllerGetStatisticsV1(storeUuid, start, end, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StatisticsApi.statisticsControllerGetStatisticsV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StatisticsApi - factory interface
 */
export const StatisticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StatisticsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get customer-specific statistics
         * @param {StatisticsApiStatisticsControllerGetCustomerStatisticsV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsControllerGetCustomerStatisticsV1(requestParameters: StatisticsApiStatisticsControllerGetCustomerStatisticsV1Request, options?: RawAxiosRequestConfig): AxiosPromise<CustomerStatisticsResponseDto> {
            return localVarFp.statisticsControllerGetCustomerStatisticsV1(requestParameters.storeUuid, requestParameters.customerUuid, requestParameters.page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get comprehensive statistics for a date range
         * @param {StatisticsApiStatisticsControllerGetStatisticsV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        statisticsControllerGetStatisticsV1(requestParameters: StatisticsApiStatisticsControllerGetStatisticsV1Request, options?: RawAxiosRequestConfig): AxiosPromise<StoreStatisticsResponseDto> {
            return localVarFp.statisticsControllerGetStatisticsV1(requestParameters.storeUuid, requestParameters.start, requestParameters.end, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for statisticsControllerGetCustomerStatisticsV1 operation in StatisticsApi.
 */
export interface StatisticsApiStatisticsControllerGetCustomerStatisticsV1Request {
    readonly storeUuid: string

    readonly customerUuid: string

    /**
     * Page number
     */
    readonly page: number
}

/**
 * Request parameters for statisticsControllerGetStatisticsV1 operation in StatisticsApi.
 */
export interface StatisticsApiStatisticsControllerGetStatisticsV1Request {
    readonly storeUuid: string

    /**
     * Start date for statistics range
     */
    readonly start: string

    /**
     * End date for statistics range
     */
    readonly end: string
}

/**
 * StatisticsApi - object-oriented interface
 */
export class StatisticsApi extends BaseAPI {
    /**
     * 
     * @summary Get customer-specific statistics
     * @param {StatisticsApiStatisticsControllerGetCustomerStatisticsV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsControllerGetCustomerStatisticsV1(requestParameters: StatisticsApiStatisticsControllerGetCustomerStatisticsV1Request, options?: RawAxiosRequestConfig) {
        return StatisticsApiFp(this.configuration).statisticsControllerGetCustomerStatisticsV1(requestParameters.storeUuid, requestParameters.customerUuid, requestParameters.page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get comprehensive statistics for a date range
     * @param {StatisticsApiStatisticsControllerGetStatisticsV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public statisticsControllerGetStatisticsV1(requestParameters: StatisticsApiStatisticsControllerGetStatisticsV1Request, options?: RawAxiosRequestConfig) {
        return StatisticsApiFp(this.configuration).statisticsControllerGetStatisticsV1(requestParameters.storeUuid, requestParameters.start, requestParameters.end, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StoreTrackingApi - axios parameter creator
 */
export const StoreTrackingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Meta Pixel, GA4 and Google Ads tracking settings for the store
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeTrackingControllerGetTrackingSettingsV1: async (storeUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('storeTrackingControllerGetTrackingSettingsV1', 'storeUuid', storeUuid)
            const localVarPath = `/v1/stores/{store_uuid}/tracking`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create or update Meta Pixel, GA4 and Google Ads tracking settings for the store
         * @param {string} storeUuid 
         * @param {UpdateStoreTrackingDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeTrackingControllerUpsertTrackingSettingsV1: async (storeUuid: string, body: UpdateStoreTrackingDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('storeTrackingControllerUpsertTrackingSettingsV1', 'storeUuid', storeUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('storeTrackingControllerUpsertTrackingSettingsV1', 'body', body)
            const localVarPath = `/v1/stores/{store_uuid}/tracking`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StoreTrackingApi - functional programming interface
 */
export const StoreTrackingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StoreTrackingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Meta Pixel, GA4 and Google Ads tracking settings for the store
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeTrackingControllerGetTrackingSettingsV1(storeUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StoreTrackingSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeTrackingControllerGetTrackingSettingsV1(storeUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoreTrackingApi.storeTrackingControllerGetTrackingSettingsV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create or update Meta Pixel, GA4 and Google Ads tracking settings for the store
         * @param {string} storeUuid 
         * @param {UpdateStoreTrackingDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storeTrackingControllerUpsertTrackingSettingsV1(storeUuid: string, body: UpdateStoreTrackingDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StoreTrackingSettingsDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storeTrackingControllerUpsertTrackingSettingsV1(storeUuid, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoreTrackingApi.storeTrackingControllerUpsertTrackingSettingsV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StoreTrackingApi - factory interface
 */
export const StoreTrackingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StoreTrackingApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Meta Pixel, GA4 and Google Ads tracking settings for the store
         * @param {StoreTrackingApiStoreTrackingControllerGetTrackingSettingsV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeTrackingControllerGetTrackingSettingsV1(requestParameters: StoreTrackingApiStoreTrackingControllerGetTrackingSettingsV1Request, options?: RawAxiosRequestConfig): AxiosPromise<StoreTrackingSettingsDto> {
            return localVarFp.storeTrackingControllerGetTrackingSettingsV1(requestParameters.storeUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create or update Meta Pixel, GA4 and Google Ads tracking settings for the store
         * @param {StoreTrackingApiStoreTrackingControllerUpsertTrackingSettingsV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storeTrackingControllerUpsertTrackingSettingsV1(requestParameters: StoreTrackingApiStoreTrackingControllerUpsertTrackingSettingsV1Request, options?: RawAxiosRequestConfig): AxiosPromise<StoreTrackingSettingsDto> {
            return localVarFp.storeTrackingControllerUpsertTrackingSettingsV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for storeTrackingControllerGetTrackingSettingsV1 operation in StoreTrackingApi.
 */
export interface StoreTrackingApiStoreTrackingControllerGetTrackingSettingsV1Request {
    readonly storeUuid: string
}

/**
 * Request parameters for storeTrackingControllerUpsertTrackingSettingsV1 operation in StoreTrackingApi.
 */
export interface StoreTrackingApiStoreTrackingControllerUpsertTrackingSettingsV1Request {
    readonly storeUuid: string

    readonly body: UpdateStoreTrackingDto
}

/**
 * StoreTrackingApi - object-oriented interface
 */
export class StoreTrackingApi extends BaseAPI {
    /**
     * 
     * @summary Get Meta Pixel, GA4 and Google Ads tracking settings for the store
     * @param {StoreTrackingApiStoreTrackingControllerGetTrackingSettingsV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storeTrackingControllerGetTrackingSettingsV1(requestParameters: StoreTrackingApiStoreTrackingControllerGetTrackingSettingsV1Request, options?: RawAxiosRequestConfig) {
        return StoreTrackingApiFp(this.configuration).storeTrackingControllerGetTrackingSettingsV1(requestParameters.storeUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create or update Meta Pixel, GA4 and Google Ads tracking settings for the store
     * @param {StoreTrackingApiStoreTrackingControllerUpsertTrackingSettingsV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storeTrackingControllerUpsertTrackingSettingsV1(requestParameters: StoreTrackingApiStoreTrackingControllerUpsertTrackingSettingsV1Request, options?: RawAxiosRequestConfig) {
        return StoreTrackingApiFp(this.configuration).storeTrackingControllerUpsertTrackingSettingsV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StoresApi - axios parameter creator
 */
export const StoresApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new store
         * @param {CreateStoreDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storesControllerCreateStoreV1: async (body: CreateStoreDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('storesControllerCreateStoreV1', 'body', body)
            const localVarPath = `/v1/stores`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a store
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storesControllerDeleteStoreV1: async (storeUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('storesControllerDeleteStoreV1', 'storeUuid', storeUuid)
            const localVarPath = `/v1/stores/{store_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get details of a specific store
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storesControllerGetStoreV1: async (storeUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('storesControllerGetStoreV1', 'storeUuid', storeUuid)
            const localVarPath = `/v1/stores/{store_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all stores for the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storesControllerGetStoresV1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/stores`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing store
         * @param {string} storeUuid 
         * @param {UpdateStoreDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storesControllerUpdateStoreV1: async (storeUuid: string, body: UpdateStoreDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('storesControllerUpdateStoreV1', 'storeUuid', storeUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('storesControllerUpdateStoreV1', 'body', body)
            const localVarPath = `/v1/stores/{store_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StoresApi - functional programming interface
 */
export const StoresApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StoresApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new store
         * @param {CreateStoreDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storesControllerCreateStoreV1(body: CreateStoreDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Stores>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storesControllerCreateStoreV1(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoresApi.storesControllerCreateStoreV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a store
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storesControllerDeleteStoreV1(storeUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storesControllerDeleteStoreV1(storeUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoresApi.storesControllerDeleteStoreV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get details of a specific store
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storesControllerGetStoreV1(storeUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Stores>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storesControllerGetStoreV1(storeUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoresApi.storesControllerGetStoreV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all stores for the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storesControllerGetStoresV1(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Stores>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storesControllerGetStoresV1(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoresApi.storesControllerGetStoresV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an existing store
         * @param {string} storeUuid 
         * @param {UpdateStoreDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async storesControllerUpdateStoreV1(storeUuid: string, body: UpdateStoreDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Stores>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.storesControllerUpdateStoreV1(storeUuid, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StoresApi.storesControllerUpdateStoreV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StoresApi - factory interface
 */
export const StoresApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StoresApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new store
         * @param {StoresApiStoresControllerCreateStoreV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storesControllerCreateStoreV1(requestParameters: StoresApiStoresControllerCreateStoreV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Stores> {
            return localVarFp.storesControllerCreateStoreV1(requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a store
         * @param {StoresApiStoresControllerDeleteStoreV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storesControllerDeleteStoreV1(requestParameters: StoresApiStoresControllerDeleteStoreV1Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.storesControllerDeleteStoreV1(requestParameters.storeUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get details of a specific store
         * @param {StoresApiStoresControllerGetStoreV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storesControllerGetStoreV1(requestParameters: StoresApiStoresControllerGetStoreV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Stores> {
            return localVarFp.storesControllerGetStoreV1(requestParameters.storeUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all stores for the user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storesControllerGetStoresV1(options?: RawAxiosRequestConfig): AxiosPromise<Array<Stores>> {
            return localVarFp.storesControllerGetStoresV1(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing store
         * @param {StoresApiStoresControllerUpdateStoreV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        storesControllerUpdateStoreV1(requestParameters: StoresApiStoresControllerUpdateStoreV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Stores> {
            return localVarFp.storesControllerUpdateStoreV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for storesControllerCreateStoreV1 operation in StoresApi.
 */
export interface StoresApiStoresControllerCreateStoreV1Request {
    readonly body: CreateStoreDto
}

/**
 * Request parameters for storesControllerDeleteStoreV1 operation in StoresApi.
 */
export interface StoresApiStoresControllerDeleteStoreV1Request {
    readonly storeUuid: string
}

/**
 * Request parameters for storesControllerGetStoreV1 operation in StoresApi.
 */
export interface StoresApiStoresControllerGetStoreV1Request {
    readonly storeUuid: string
}

/**
 * Request parameters for storesControllerUpdateStoreV1 operation in StoresApi.
 */
export interface StoresApiStoresControllerUpdateStoreV1Request {
    readonly storeUuid: string

    readonly body: UpdateStoreDto
}

/**
 * StoresApi - object-oriented interface
 */
export class StoresApi extends BaseAPI {
    /**
     * 
     * @summary Create a new store
     * @param {StoresApiStoresControllerCreateStoreV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storesControllerCreateStoreV1(requestParameters: StoresApiStoresControllerCreateStoreV1Request, options?: RawAxiosRequestConfig) {
        return StoresApiFp(this.configuration).storesControllerCreateStoreV1(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a store
     * @param {StoresApiStoresControllerDeleteStoreV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storesControllerDeleteStoreV1(requestParameters: StoresApiStoresControllerDeleteStoreV1Request, options?: RawAxiosRequestConfig) {
        return StoresApiFp(this.configuration).storesControllerDeleteStoreV1(requestParameters.storeUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get details of a specific store
     * @param {StoresApiStoresControllerGetStoreV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storesControllerGetStoreV1(requestParameters: StoresApiStoresControllerGetStoreV1Request, options?: RawAxiosRequestConfig) {
        return StoresApiFp(this.configuration).storesControllerGetStoreV1(requestParameters.storeUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all stores for the user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storesControllerGetStoresV1(options?: RawAxiosRequestConfig) {
        return StoresApiFp(this.configuration).storesControllerGetStoresV1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing store
     * @param {StoresApiStoresControllerUpdateStoreV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public storesControllerUpdateStoreV1(requestParameters: StoresApiStoresControllerUpdateStoreV1Request, options?: RawAxiosRequestConfig) {
        return StoresApiFp(this.configuration).storesControllerUpdateStoreV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TableGroupsApi - axios parameter creator
 */
export const TableGroupsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new table group for the store
         * @param {string} storeUuid 
         * @param {CreateTableGroupDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tableGroupsControllerCreateTableGroupV1: async (storeUuid: string, body: CreateTableGroupDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('tableGroupsControllerCreateTableGroupV1', 'storeUuid', storeUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('tableGroupsControllerCreateTableGroupV1', 'body', body)
            const localVarPath = `/v1/stores/{store_uuid}/table-groups`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a table group from the store
         * @param {string} storeUuid 
         * @param {string} tableGroupUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tableGroupsControllerDeleteTableGroupV1: async (storeUuid: string, tableGroupUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('tableGroupsControllerDeleteTableGroupV1', 'storeUuid', storeUuid)
            // verify required parameter 'tableGroupUuid' is not null or undefined
            assertParamExists('tableGroupsControllerDeleteTableGroupV1', 'tableGroupUuid', tableGroupUuid)
            const localVarPath = `/v1/stores/{store_uuid}/table-groups/{table_group_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{table_group_uuid}', encodeURIComponent(String(tableGroupUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get details of a specific table group in the store
         * @param {string} storeUuid 
         * @param {string} tableGroupUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tableGroupsControllerGetTableGroupV1: async (storeUuid: string, tableGroupUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('tableGroupsControllerGetTableGroupV1', 'storeUuid', storeUuid)
            // verify required parameter 'tableGroupUuid' is not null or undefined
            assertParamExists('tableGroupsControllerGetTableGroupV1', 'tableGroupUuid', tableGroupUuid)
            const localVarPath = `/v1/stores/{store_uuid}/table-groups/{table_group_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{table_group_uuid}', encodeURIComponent(String(tableGroupUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all table groups for the store
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tableGroupsControllerGetTableGroupsV1: async (storeUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('tableGroupsControllerGetTableGroupsV1', 'storeUuid', storeUuid)
            const localVarPath = `/v1/stores/{store_uuid}/table-groups`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing table group in the store
         * @param {string} storeUuid 
         * @param {string} tableGroupUuid 
         * @param {UpdateTableGroupDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tableGroupsControllerUpdateTableGroupV1: async (storeUuid: string, tableGroupUuid: string, body: UpdateTableGroupDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('tableGroupsControllerUpdateTableGroupV1', 'storeUuid', storeUuid)
            // verify required parameter 'tableGroupUuid' is not null or undefined
            assertParamExists('tableGroupsControllerUpdateTableGroupV1', 'tableGroupUuid', tableGroupUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('tableGroupsControllerUpdateTableGroupV1', 'body', body)
            const localVarPath = `/v1/stores/{store_uuid}/table-groups/{table_group_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{table_group_uuid}', encodeURIComponent(String(tableGroupUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TableGroupsApi - functional programming interface
 */
export const TableGroupsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TableGroupsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new table group for the store
         * @param {string} storeUuid 
         * @param {CreateTableGroupDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tableGroupsControllerCreateTableGroupV1(storeUuid: string, body: CreateTableGroupDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TableGroups>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tableGroupsControllerCreateTableGroupV1(storeUuid, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TableGroupsApi.tableGroupsControllerCreateTableGroupV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a table group from the store
         * @param {string} storeUuid 
         * @param {string} tableGroupUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tableGroupsControllerDeleteTableGroupV1(storeUuid: string, tableGroupUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tableGroupsControllerDeleteTableGroupV1(storeUuid, tableGroupUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TableGroupsApi.tableGroupsControllerDeleteTableGroupV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get details of a specific table group in the store
         * @param {string} storeUuid 
         * @param {string} tableGroupUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tableGroupsControllerGetTableGroupV1(storeUuid: string, tableGroupUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TableGroups>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tableGroupsControllerGetTableGroupV1(storeUuid, tableGroupUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TableGroupsApi.tableGroupsControllerGetTableGroupV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all table groups for the store
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tableGroupsControllerGetTableGroupsV1(storeUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TableGroups>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tableGroupsControllerGetTableGroupsV1(storeUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TableGroupsApi.tableGroupsControllerGetTableGroupsV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an existing table group in the store
         * @param {string} storeUuid 
         * @param {string} tableGroupUuid 
         * @param {UpdateTableGroupDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tableGroupsControllerUpdateTableGroupV1(storeUuid: string, tableGroupUuid: string, body: UpdateTableGroupDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TableGroups>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tableGroupsControllerUpdateTableGroupV1(storeUuid, tableGroupUuid, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TableGroupsApi.tableGroupsControllerUpdateTableGroupV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TableGroupsApi - factory interface
 */
export const TableGroupsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TableGroupsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new table group for the store
         * @param {TableGroupsApiTableGroupsControllerCreateTableGroupV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tableGroupsControllerCreateTableGroupV1(requestParameters: TableGroupsApiTableGroupsControllerCreateTableGroupV1Request, options?: RawAxiosRequestConfig): AxiosPromise<TableGroups> {
            return localVarFp.tableGroupsControllerCreateTableGroupV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a table group from the store
         * @param {TableGroupsApiTableGroupsControllerDeleteTableGroupV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tableGroupsControllerDeleteTableGroupV1(requestParameters: TableGroupsApiTableGroupsControllerDeleteTableGroupV1Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.tableGroupsControllerDeleteTableGroupV1(requestParameters.storeUuid, requestParameters.tableGroupUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get details of a specific table group in the store
         * @param {TableGroupsApiTableGroupsControllerGetTableGroupV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tableGroupsControllerGetTableGroupV1(requestParameters: TableGroupsApiTableGroupsControllerGetTableGroupV1Request, options?: RawAxiosRequestConfig): AxiosPromise<TableGroups> {
            return localVarFp.tableGroupsControllerGetTableGroupV1(requestParameters.storeUuid, requestParameters.tableGroupUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all table groups for the store
         * @param {TableGroupsApiTableGroupsControllerGetTableGroupsV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tableGroupsControllerGetTableGroupsV1(requestParameters: TableGroupsApiTableGroupsControllerGetTableGroupsV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<TableGroups>> {
            return localVarFp.tableGroupsControllerGetTableGroupsV1(requestParameters.storeUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing table group in the store
         * @param {TableGroupsApiTableGroupsControllerUpdateTableGroupV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tableGroupsControllerUpdateTableGroupV1(requestParameters: TableGroupsApiTableGroupsControllerUpdateTableGroupV1Request, options?: RawAxiosRequestConfig): AxiosPromise<TableGroups> {
            return localVarFp.tableGroupsControllerUpdateTableGroupV1(requestParameters.storeUuid, requestParameters.tableGroupUuid, requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for tableGroupsControllerCreateTableGroupV1 operation in TableGroupsApi.
 */
export interface TableGroupsApiTableGroupsControllerCreateTableGroupV1Request {
    readonly storeUuid: string

    readonly body: CreateTableGroupDto
}

/**
 * Request parameters for tableGroupsControllerDeleteTableGroupV1 operation in TableGroupsApi.
 */
export interface TableGroupsApiTableGroupsControllerDeleteTableGroupV1Request {
    readonly storeUuid: string

    readonly tableGroupUuid: string
}

/**
 * Request parameters for tableGroupsControllerGetTableGroupV1 operation in TableGroupsApi.
 */
export interface TableGroupsApiTableGroupsControllerGetTableGroupV1Request {
    readonly storeUuid: string

    readonly tableGroupUuid: string
}

/**
 * Request parameters for tableGroupsControllerGetTableGroupsV1 operation in TableGroupsApi.
 */
export interface TableGroupsApiTableGroupsControllerGetTableGroupsV1Request {
    readonly storeUuid: string
}

/**
 * Request parameters for tableGroupsControllerUpdateTableGroupV1 operation in TableGroupsApi.
 */
export interface TableGroupsApiTableGroupsControllerUpdateTableGroupV1Request {
    readonly storeUuid: string

    readonly tableGroupUuid: string

    readonly body: UpdateTableGroupDto
}

/**
 * TableGroupsApi - object-oriented interface
 */
export class TableGroupsApi extends BaseAPI {
    /**
     * 
     * @summary Create a new table group for the store
     * @param {TableGroupsApiTableGroupsControllerCreateTableGroupV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public tableGroupsControllerCreateTableGroupV1(requestParameters: TableGroupsApiTableGroupsControllerCreateTableGroupV1Request, options?: RawAxiosRequestConfig) {
        return TableGroupsApiFp(this.configuration).tableGroupsControllerCreateTableGroupV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a table group from the store
     * @param {TableGroupsApiTableGroupsControllerDeleteTableGroupV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public tableGroupsControllerDeleteTableGroupV1(requestParameters: TableGroupsApiTableGroupsControllerDeleteTableGroupV1Request, options?: RawAxiosRequestConfig) {
        return TableGroupsApiFp(this.configuration).tableGroupsControllerDeleteTableGroupV1(requestParameters.storeUuid, requestParameters.tableGroupUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get details of a specific table group in the store
     * @param {TableGroupsApiTableGroupsControllerGetTableGroupV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public tableGroupsControllerGetTableGroupV1(requestParameters: TableGroupsApiTableGroupsControllerGetTableGroupV1Request, options?: RawAxiosRequestConfig) {
        return TableGroupsApiFp(this.configuration).tableGroupsControllerGetTableGroupV1(requestParameters.storeUuid, requestParameters.tableGroupUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all table groups for the store
     * @param {TableGroupsApiTableGroupsControllerGetTableGroupsV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public tableGroupsControllerGetTableGroupsV1(requestParameters: TableGroupsApiTableGroupsControllerGetTableGroupsV1Request, options?: RawAxiosRequestConfig) {
        return TableGroupsApiFp(this.configuration).tableGroupsControllerGetTableGroupsV1(requestParameters.storeUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing table group in the store
     * @param {TableGroupsApiTableGroupsControllerUpdateTableGroupV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public tableGroupsControllerUpdateTableGroupV1(requestParameters: TableGroupsApiTableGroupsControllerUpdateTableGroupV1Request, options?: RawAxiosRequestConfig) {
        return TableGroupsApiFp(this.configuration).tableGroupsControllerUpdateTableGroupV1(requestParameters.storeUuid, requestParameters.tableGroupUuid, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TablesApi - axios parameter creator
 */
export const TablesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new table for the store
         * @param {string} storeUuid 
         * @param {CreateTableDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tablesControllerCreateTableV1: async (storeUuid: string, body: CreateTableDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('tablesControllerCreateTableV1', 'storeUuid', storeUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('tablesControllerCreateTableV1', 'body', body)
            const localVarPath = `/v1/stores/{store_uuid}/tables`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a table from the store
         * @param {string} storeUuid 
         * @param {string} tableUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tablesControllerDeleteTableV1: async (storeUuid: string, tableUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('tablesControllerDeleteTableV1', 'storeUuid', storeUuid)
            // verify required parameter 'tableUuid' is not null or undefined
            assertParamExists('tablesControllerDeleteTableV1', 'tableUuid', tableUuid)
            const localVarPath = `/v1/stores/{store_uuid}/tables/{table_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{table_uuid}', encodeURIComponent(String(tableUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get details of a specific table in the store
         * @param {string} storeUuid 
         * @param {string} tableUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tablesControllerGetTableV1: async (storeUuid: string, tableUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('tablesControllerGetTableV1', 'storeUuid', storeUuid)
            // verify required parameter 'tableUuid' is not null or undefined
            assertParamExists('tablesControllerGetTableV1', 'tableUuid', tableUuid)
            const localVarPath = `/v1/stores/{store_uuid}/tables/{table_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{table_uuid}', encodeURIComponent(String(tableUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all tables for the store
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tablesControllerGetTablesV1: async (storeUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('tablesControllerGetTablesV1', 'storeUuid', storeUuid)
            const localVarPath = `/v1/stores/{store_uuid}/tables`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reorder tables in the store
         * @param {string} storeUuid 
         * @param {ReorderTablesDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tablesControllerReorderTablesV1: async (storeUuid: string, body: ReorderTablesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('tablesControllerReorderTablesV1', 'storeUuid', storeUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('tablesControllerReorderTablesV1', 'body', body)
            const localVarPath = `/v1/stores/{store_uuid}/tables/reorder`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing table in the store
         * @param {string} storeUuid 
         * @param {string} tableUuid 
         * @param {UpdateTableDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tablesControllerUpdateTableV1: async (storeUuid: string, tableUuid: string, body: UpdateTableDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('tablesControllerUpdateTableV1', 'storeUuid', storeUuid)
            // verify required parameter 'tableUuid' is not null or undefined
            assertParamExists('tablesControllerUpdateTableV1', 'tableUuid', tableUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('tablesControllerUpdateTableV1', 'body', body)
            const localVarPath = `/v1/stores/{store_uuid}/tables/{table_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{table_uuid}', encodeURIComponent(String(tableUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TablesApi - functional programming interface
 */
export const TablesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TablesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new table for the store
         * @param {string} storeUuid 
         * @param {CreateTableDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tablesControllerCreateTableV1(storeUuid: string, body: CreateTableDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tables>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tablesControllerCreateTableV1(storeUuid, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TablesApi.tablesControllerCreateTableV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a table from the store
         * @param {string} storeUuid 
         * @param {string} tableUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tablesControllerDeleteTableV1(storeUuid: string, tableUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tablesControllerDeleteTableV1(storeUuid, tableUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TablesApi.tablesControllerDeleteTableV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get details of a specific table in the store
         * @param {string} storeUuid 
         * @param {string} tableUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tablesControllerGetTableV1(storeUuid: string, tableUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tables>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tablesControllerGetTableV1(storeUuid, tableUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TablesApi.tablesControllerGetTableV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all tables for the store
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tablesControllerGetTablesV1(storeUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Tables>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tablesControllerGetTablesV1(storeUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TablesApi.tablesControllerGetTablesV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reorder tables in the store
         * @param {string} storeUuid 
         * @param {ReorderTablesDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tablesControllerReorderTablesV1(storeUuid: string, body: ReorderTablesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Tables>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tablesControllerReorderTablesV1(storeUuid, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TablesApi.tablesControllerReorderTablesV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an existing table in the store
         * @param {string} storeUuid 
         * @param {string} tableUuid 
         * @param {UpdateTableDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tablesControllerUpdateTableV1(storeUuid: string, tableUuid: string, body: UpdateTableDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Tables>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tablesControllerUpdateTableV1(storeUuid, tableUuid, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TablesApi.tablesControllerUpdateTableV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TablesApi - factory interface
 */
export const TablesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TablesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new table for the store
         * @param {TablesApiTablesControllerCreateTableV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tablesControllerCreateTableV1(requestParameters: TablesApiTablesControllerCreateTableV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Tables> {
            return localVarFp.tablesControllerCreateTableV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a table from the store
         * @param {TablesApiTablesControllerDeleteTableV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tablesControllerDeleteTableV1(requestParameters: TablesApiTablesControllerDeleteTableV1Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.tablesControllerDeleteTableV1(requestParameters.storeUuid, requestParameters.tableUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get details of a specific table in the store
         * @param {TablesApiTablesControllerGetTableV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tablesControllerGetTableV1(requestParameters: TablesApiTablesControllerGetTableV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Tables> {
            return localVarFp.tablesControllerGetTableV1(requestParameters.storeUuid, requestParameters.tableUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all tables for the store
         * @param {TablesApiTablesControllerGetTablesV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tablesControllerGetTablesV1(requestParameters: TablesApiTablesControllerGetTablesV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<Tables>> {
            return localVarFp.tablesControllerGetTablesV1(requestParameters.storeUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reorder tables in the store
         * @param {TablesApiTablesControllerReorderTablesV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tablesControllerReorderTablesV1(requestParameters: TablesApiTablesControllerReorderTablesV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<Tables>> {
            return localVarFp.tablesControllerReorderTablesV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing table in the store
         * @param {TablesApiTablesControllerUpdateTableV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tablesControllerUpdateTableV1(requestParameters: TablesApiTablesControllerUpdateTableV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Tables> {
            return localVarFp.tablesControllerUpdateTableV1(requestParameters.storeUuid, requestParameters.tableUuid, requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for tablesControllerCreateTableV1 operation in TablesApi.
 */
export interface TablesApiTablesControllerCreateTableV1Request {
    readonly storeUuid: string

    readonly body: CreateTableDto
}

/**
 * Request parameters for tablesControllerDeleteTableV1 operation in TablesApi.
 */
export interface TablesApiTablesControllerDeleteTableV1Request {
    readonly storeUuid: string

    readonly tableUuid: string
}

/**
 * Request parameters for tablesControllerGetTableV1 operation in TablesApi.
 */
export interface TablesApiTablesControllerGetTableV1Request {
    readonly storeUuid: string

    readonly tableUuid: string
}

/**
 * Request parameters for tablesControllerGetTablesV1 operation in TablesApi.
 */
export interface TablesApiTablesControllerGetTablesV1Request {
    readonly storeUuid: string
}

/**
 * Request parameters for tablesControllerReorderTablesV1 operation in TablesApi.
 */
export interface TablesApiTablesControllerReorderTablesV1Request {
    readonly storeUuid: string

    readonly body: ReorderTablesDto
}

/**
 * Request parameters for tablesControllerUpdateTableV1 operation in TablesApi.
 */
export interface TablesApiTablesControllerUpdateTableV1Request {
    readonly storeUuid: string

    readonly tableUuid: string

    readonly body: UpdateTableDto
}

/**
 * TablesApi - object-oriented interface
 */
export class TablesApi extends BaseAPI {
    /**
     * 
     * @summary Create a new table for the store
     * @param {TablesApiTablesControllerCreateTableV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public tablesControllerCreateTableV1(requestParameters: TablesApiTablesControllerCreateTableV1Request, options?: RawAxiosRequestConfig) {
        return TablesApiFp(this.configuration).tablesControllerCreateTableV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a table from the store
     * @param {TablesApiTablesControllerDeleteTableV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public tablesControllerDeleteTableV1(requestParameters: TablesApiTablesControllerDeleteTableV1Request, options?: RawAxiosRequestConfig) {
        return TablesApiFp(this.configuration).tablesControllerDeleteTableV1(requestParameters.storeUuid, requestParameters.tableUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get details of a specific table in the store
     * @param {TablesApiTablesControllerGetTableV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public tablesControllerGetTableV1(requestParameters: TablesApiTablesControllerGetTableV1Request, options?: RawAxiosRequestConfig) {
        return TablesApiFp(this.configuration).tablesControllerGetTableV1(requestParameters.storeUuid, requestParameters.tableUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all tables for the store
     * @param {TablesApiTablesControllerGetTablesV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public tablesControllerGetTablesV1(requestParameters: TablesApiTablesControllerGetTablesV1Request, options?: RawAxiosRequestConfig) {
        return TablesApiFp(this.configuration).tablesControllerGetTablesV1(requestParameters.storeUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reorder tables in the store
     * @param {TablesApiTablesControllerReorderTablesV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public tablesControllerReorderTablesV1(requestParameters: TablesApiTablesControllerReorderTablesV1Request, options?: RawAxiosRequestConfig) {
        return TablesApiFp(this.configuration).tablesControllerReorderTablesV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing table in the store
     * @param {TablesApiTablesControllerUpdateTableV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public tablesControllerUpdateTableV1(requestParameters: TablesApiTablesControllerUpdateTableV1Request, options?: RawAxiosRequestConfig) {
        return TablesApiFp(this.configuration).tablesControllerUpdateTableV1(requestParameters.storeUuid, requestParameters.tableUuid, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UsersApi - axios parameter creator
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get user\'s details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerGetUserV1: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/users/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user\'s details
         * @param {UpdateUserDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerUpdateUserV1: async (body: UpdateUserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('usersControllerUpdateUserV1', 'body', body)
            const localVarPath = `/v1/users/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get user\'s details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerGetUserV1(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserProfileDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerGetUserV1(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerGetUserV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update user\'s details
         * @param {UpdateUserDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerUpdateUserV1(body: UpdateUserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Users>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerUpdateUserV1(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerUpdateUserV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersApi - factory interface
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @summary Get user\'s details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerGetUserV1(options?: RawAxiosRequestConfig): AxiosPromise<UserProfileDto> {
            return localVarFp.usersControllerGetUserV1(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user\'s details
         * @param {UsersApiUsersControllerUpdateUserV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerUpdateUserV1(requestParameters: UsersApiUsersControllerUpdateUserV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Users> {
            return localVarFp.usersControllerUpdateUserV1(requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for usersControllerUpdateUserV1 operation in UsersApi.
 */
export interface UsersApiUsersControllerUpdateUserV1Request {
    readonly body: UpdateUserDto
}

/**
 * UsersApi - object-oriented interface
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @summary Get user\'s details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public usersControllerGetUserV1(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerGetUserV1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user\'s details
     * @param {UsersApiUsersControllerUpdateUserV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public usersControllerUpdateUserV1(requestParameters: UsersApiUsersControllerUpdateUserV1Request, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerUpdateUserV1(requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WorkingHoursApi - axios parameter creator
 */
export const WorkingHoursApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new working hour for the store
         * @param {string} storeUuid 
         * @param {CreateWorkingHourDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workingHoursControllerCreateWorkingHourV1: async (storeUuid: string, body: CreateWorkingHourDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('workingHoursControllerCreateWorkingHourV1', 'storeUuid', storeUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('workingHoursControllerCreateWorkingHourV1', 'body', body)
            const localVarPath = `/v1/stores/{store_uuid}/working-hours`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a working hour from the store
         * @param {string} storeUuid 
         * @param {string} workingHourUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workingHoursControllerDeleteWorkingHourV1: async (storeUuid: string, workingHourUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('workingHoursControllerDeleteWorkingHourV1', 'storeUuid', storeUuid)
            // verify required parameter 'workingHourUuid' is not null or undefined
            assertParamExists('workingHoursControllerDeleteWorkingHourV1', 'workingHourUuid', workingHourUuid)
            const localVarPath = `/v1/stores/{store_uuid}/working-hours/{working_hour_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{working_hour_uuid}', encodeURIComponent(String(workingHourUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get details of a specific working hour for the store
         * @param {string} storeUuid 
         * @param {string} workingHourUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workingHoursControllerGetWorkingHourV1: async (storeUuid: string, workingHourUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('workingHoursControllerGetWorkingHourV1', 'storeUuid', storeUuid)
            // verify required parameter 'workingHourUuid' is not null or undefined
            assertParamExists('workingHoursControllerGetWorkingHourV1', 'workingHourUuid', workingHourUuid)
            const localVarPath = `/v1/stores/{store_uuid}/working-hours/{working_hour_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{working_hour_uuid}', encodeURIComponent(String(workingHourUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all working hours for the store
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workingHoursControllerGetWorkingHoursV1: async (storeUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('workingHoursControllerGetWorkingHoursV1', 'storeUuid', storeUuid)
            const localVarPath = `/v1/stores/{store_uuid}/working-hours`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing working hour for the store
         * @param {string} storeUuid 
         * @param {string} workingHourUuid 
         * @param {UpdateWorkingHourDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workingHoursControllerUpdateWorkingHourV1: async (storeUuid: string, workingHourUuid: string, body: UpdateWorkingHourDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('workingHoursControllerUpdateWorkingHourV1', 'storeUuid', storeUuid)
            // verify required parameter 'workingHourUuid' is not null or undefined
            assertParamExists('workingHoursControllerUpdateWorkingHourV1', 'workingHourUuid', workingHourUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('workingHoursControllerUpdateWorkingHourV1', 'body', body)
            const localVarPath = `/v1/stores/{store_uuid}/working-hours/{working_hour_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{working_hour_uuid}', encodeURIComponent(String(workingHourUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkingHoursApi - functional programming interface
 */
export const WorkingHoursApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WorkingHoursApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new working hour for the store
         * @param {string} storeUuid 
         * @param {CreateWorkingHourDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workingHoursControllerCreateWorkingHourV1(storeUuid: string, body: CreateWorkingHourDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkingHours>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workingHoursControllerCreateWorkingHourV1(storeUuid, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkingHoursApi.workingHoursControllerCreateWorkingHourV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a working hour from the store
         * @param {string} storeUuid 
         * @param {string} workingHourUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workingHoursControllerDeleteWorkingHourV1(storeUuid: string, workingHourUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workingHoursControllerDeleteWorkingHourV1(storeUuid, workingHourUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkingHoursApi.workingHoursControllerDeleteWorkingHourV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get details of a specific working hour for the store
         * @param {string} storeUuid 
         * @param {string} workingHourUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workingHoursControllerGetWorkingHourV1(storeUuid: string, workingHourUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkingHours>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workingHoursControllerGetWorkingHourV1(storeUuid, workingHourUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkingHoursApi.workingHoursControllerGetWorkingHourV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all working hours for the store
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workingHoursControllerGetWorkingHoursV1(storeUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<WorkingHours>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workingHoursControllerGetWorkingHoursV1(storeUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkingHoursApi.workingHoursControllerGetWorkingHoursV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an existing working hour for the store
         * @param {string} storeUuid 
         * @param {string} workingHourUuid 
         * @param {UpdateWorkingHourDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async workingHoursControllerUpdateWorkingHourV1(storeUuid: string, workingHourUuid: string, body: UpdateWorkingHourDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkingHours>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.workingHoursControllerUpdateWorkingHourV1(storeUuid, workingHourUuid, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WorkingHoursApi.workingHoursControllerUpdateWorkingHourV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WorkingHoursApi - factory interface
 */
export const WorkingHoursApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WorkingHoursApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new working hour for the store
         * @param {WorkingHoursApiWorkingHoursControllerCreateWorkingHourV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workingHoursControllerCreateWorkingHourV1(requestParameters: WorkingHoursApiWorkingHoursControllerCreateWorkingHourV1Request, options?: RawAxiosRequestConfig): AxiosPromise<WorkingHours> {
            return localVarFp.workingHoursControllerCreateWorkingHourV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a working hour from the store
         * @param {WorkingHoursApiWorkingHoursControllerDeleteWorkingHourV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workingHoursControllerDeleteWorkingHourV1(requestParameters: WorkingHoursApiWorkingHoursControllerDeleteWorkingHourV1Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.workingHoursControllerDeleteWorkingHourV1(requestParameters.storeUuid, requestParameters.workingHourUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get details of a specific working hour for the store
         * @param {WorkingHoursApiWorkingHoursControllerGetWorkingHourV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workingHoursControllerGetWorkingHourV1(requestParameters: WorkingHoursApiWorkingHoursControllerGetWorkingHourV1Request, options?: RawAxiosRequestConfig): AxiosPromise<WorkingHours> {
            return localVarFp.workingHoursControllerGetWorkingHourV1(requestParameters.storeUuid, requestParameters.workingHourUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all working hours for the store
         * @param {WorkingHoursApiWorkingHoursControllerGetWorkingHoursV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workingHoursControllerGetWorkingHoursV1(requestParameters: WorkingHoursApiWorkingHoursControllerGetWorkingHoursV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<WorkingHours>> {
            return localVarFp.workingHoursControllerGetWorkingHoursV1(requestParameters.storeUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing working hour for the store
         * @param {WorkingHoursApiWorkingHoursControllerUpdateWorkingHourV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        workingHoursControllerUpdateWorkingHourV1(requestParameters: WorkingHoursApiWorkingHoursControllerUpdateWorkingHourV1Request, options?: RawAxiosRequestConfig): AxiosPromise<WorkingHours> {
            return localVarFp.workingHoursControllerUpdateWorkingHourV1(requestParameters.storeUuid, requestParameters.workingHourUuid, requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for workingHoursControllerCreateWorkingHourV1 operation in WorkingHoursApi.
 */
export interface WorkingHoursApiWorkingHoursControllerCreateWorkingHourV1Request {
    readonly storeUuid: string

    readonly body: CreateWorkingHourDto
}

/**
 * Request parameters for workingHoursControllerDeleteWorkingHourV1 operation in WorkingHoursApi.
 */
export interface WorkingHoursApiWorkingHoursControllerDeleteWorkingHourV1Request {
    readonly storeUuid: string

    readonly workingHourUuid: string
}

/**
 * Request parameters for workingHoursControllerGetWorkingHourV1 operation in WorkingHoursApi.
 */
export interface WorkingHoursApiWorkingHoursControllerGetWorkingHourV1Request {
    readonly storeUuid: string

    readonly workingHourUuid: string
}

/**
 * Request parameters for workingHoursControllerGetWorkingHoursV1 operation in WorkingHoursApi.
 */
export interface WorkingHoursApiWorkingHoursControllerGetWorkingHoursV1Request {
    readonly storeUuid: string
}

/**
 * Request parameters for workingHoursControllerUpdateWorkingHourV1 operation in WorkingHoursApi.
 */
export interface WorkingHoursApiWorkingHoursControllerUpdateWorkingHourV1Request {
    readonly storeUuid: string

    readonly workingHourUuid: string

    readonly body: UpdateWorkingHourDto
}

/**
 * WorkingHoursApi - object-oriented interface
 */
export class WorkingHoursApi extends BaseAPI {
    /**
     * 
     * @summary Create a new working hour for the store
     * @param {WorkingHoursApiWorkingHoursControllerCreateWorkingHourV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public workingHoursControllerCreateWorkingHourV1(requestParameters: WorkingHoursApiWorkingHoursControllerCreateWorkingHourV1Request, options?: RawAxiosRequestConfig) {
        return WorkingHoursApiFp(this.configuration).workingHoursControllerCreateWorkingHourV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a working hour from the store
     * @param {WorkingHoursApiWorkingHoursControllerDeleteWorkingHourV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public workingHoursControllerDeleteWorkingHourV1(requestParameters: WorkingHoursApiWorkingHoursControllerDeleteWorkingHourV1Request, options?: RawAxiosRequestConfig) {
        return WorkingHoursApiFp(this.configuration).workingHoursControllerDeleteWorkingHourV1(requestParameters.storeUuid, requestParameters.workingHourUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get details of a specific working hour for the store
     * @param {WorkingHoursApiWorkingHoursControllerGetWorkingHourV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public workingHoursControllerGetWorkingHourV1(requestParameters: WorkingHoursApiWorkingHoursControllerGetWorkingHourV1Request, options?: RawAxiosRequestConfig) {
        return WorkingHoursApiFp(this.configuration).workingHoursControllerGetWorkingHourV1(requestParameters.storeUuid, requestParameters.workingHourUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all working hours for the store
     * @param {WorkingHoursApiWorkingHoursControllerGetWorkingHoursV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public workingHoursControllerGetWorkingHoursV1(requestParameters: WorkingHoursApiWorkingHoursControllerGetWorkingHoursV1Request, options?: RawAxiosRequestConfig) {
        return WorkingHoursApiFp(this.configuration).workingHoursControllerGetWorkingHoursV1(requestParameters.storeUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing working hour for the store
     * @param {WorkingHoursApiWorkingHoursControllerUpdateWorkingHourV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public workingHoursControllerUpdateWorkingHourV1(requestParameters: WorkingHoursApiWorkingHoursControllerUpdateWorkingHourV1Request, options?: RawAxiosRequestConfig) {
        return WorkingHoursApiFp(this.configuration).workingHoursControllerUpdateWorkingHourV1(requestParameters.storeUuid, requestParameters.workingHourUuid, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ZonesApi - axios parameter creator
 */
export const ZonesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new zone for the store
         * @param {string} storeUuid 
         * @param {ZoneDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesControllerCreateZoneV1: async (storeUuid: string, body: ZoneDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('zonesControllerCreateZoneV1', 'storeUuid', storeUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('zonesControllerCreateZoneV1', 'body', body)
            const localVarPath = `/v1/stores/{store_uuid}/zones`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a zone from the store
         * @param {string} storeUuid 
         * @param {string} zoneUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesControllerDeleteZoneV1: async (storeUuid: string, zoneUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('zonesControllerDeleteZoneV1', 'storeUuid', storeUuid)
            // verify required parameter 'zoneUuid' is not null or undefined
            assertParamExists('zonesControllerDeleteZoneV1', 'zoneUuid', zoneUuid)
            const localVarPath = `/v1/stores/{store_uuid}/zones/{zone_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{zone_uuid}', encodeURIComponent(String(zoneUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get details of a specific zone for the store
         * @param {string} storeUuid 
         * @param {string} zoneUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesControllerGetZoneV1: async (storeUuid: string, zoneUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('zonesControllerGetZoneV1', 'storeUuid', storeUuid)
            // verify required parameter 'zoneUuid' is not null or undefined
            assertParamExists('zonesControllerGetZoneV1', 'zoneUuid', zoneUuid)
            const localVarPath = `/v1/stores/{store_uuid}/zones/{zone_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{zone_uuid}', encodeURIComponent(String(zoneUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all zones for the store
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesControllerGetZonesV1: async (storeUuid: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('zonesControllerGetZonesV1', 'storeUuid', storeUuid)
            const localVarPath = `/v1/stores/{store_uuid}/zones`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an existing zone for the store
         * @param {string} storeUuid 
         * @param {string} zoneUuid 
         * @param {ZoneDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesControllerUpdateZoneV1: async (storeUuid: string, zoneUuid: string, body: ZoneDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeUuid' is not null or undefined
            assertParamExists('zonesControllerUpdateZoneV1', 'storeUuid', storeUuid)
            // verify required parameter 'zoneUuid' is not null or undefined
            assertParamExists('zonesControllerUpdateZoneV1', 'zoneUuid', zoneUuid)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('zonesControllerUpdateZoneV1', 'body', body)
            const localVarPath = `/v1/stores/{store_uuid}/zones/{zone_uuid}`
                .replace('{store_uuid}', encodeURIComponent(String(storeUuid)))
                .replace('{zone_uuid}', encodeURIComponent(String(zoneUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "auth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = '*/*';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ZonesApi - functional programming interface
 */
export const ZonesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ZonesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new zone for the store
         * @param {string} storeUuid 
         * @param {ZoneDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async zonesControllerCreateZoneV1(storeUuid: string, body: ZoneDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Zones>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.zonesControllerCreateZoneV1(storeUuid, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ZonesApi.zonesControllerCreateZoneV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a zone from the store
         * @param {string} storeUuid 
         * @param {string} zoneUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async zonesControllerDeleteZoneV1(storeUuid: string, zoneUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.zonesControllerDeleteZoneV1(storeUuid, zoneUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ZonesApi.zonesControllerDeleteZoneV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get details of a specific zone for the store
         * @param {string} storeUuid 
         * @param {string} zoneUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async zonesControllerGetZoneV1(storeUuid: string, zoneUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Zones>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.zonesControllerGetZoneV1(storeUuid, zoneUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ZonesApi.zonesControllerGetZoneV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all zones for the store
         * @param {string} storeUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async zonesControllerGetZonesV1(storeUuid: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Zones>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.zonesControllerGetZonesV1(storeUuid, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ZonesApi.zonesControllerGetZonesV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an existing zone for the store
         * @param {string} storeUuid 
         * @param {string} zoneUuid 
         * @param {ZoneDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async zonesControllerUpdateZoneV1(storeUuid: string, zoneUuid: string, body: ZoneDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Zones>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.zonesControllerUpdateZoneV1(storeUuid, zoneUuid, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ZonesApi.zonesControllerUpdateZoneV1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ZonesApi - factory interface
 */
export const ZonesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ZonesApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new zone for the store
         * @param {ZonesApiZonesControllerCreateZoneV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesControllerCreateZoneV1(requestParameters: ZonesApiZonesControllerCreateZoneV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Zones> {
            return localVarFp.zonesControllerCreateZoneV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a zone from the store
         * @param {ZonesApiZonesControllerDeleteZoneV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesControllerDeleteZoneV1(requestParameters: ZonesApiZonesControllerDeleteZoneV1Request, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.zonesControllerDeleteZoneV1(requestParameters.storeUuid, requestParameters.zoneUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get details of a specific zone for the store
         * @param {ZonesApiZonesControllerGetZoneV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesControllerGetZoneV1(requestParameters: ZonesApiZonesControllerGetZoneV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Zones> {
            return localVarFp.zonesControllerGetZoneV1(requestParameters.storeUuid, requestParameters.zoneUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all zones for the store
         * @param {ZonesApiZonesControllerGetZonesV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesControllerGetZonesV1(requestParameters: ZonesApiZonesControllerGetZonesV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Array<Zones>> {
            return localVarFp.zonesControllerGetZonesV1(requestParameters.storeUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an existing zone for the store
         * @param {ZonesApiZonesControllerUpdateZoneV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zonesControllerUpdateZoneV1(requestParameters: ZonesApiZonesControllerUpdateZoneV1Request, options?: RawAxiosRequestConfig): AxiosPromise<Zones> {
            return localVarFp.zonesControllerUpdateZoneV1(requestParameters.storeUuid, requestParameters.zoneUuid, requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for zonesControllerCreateZoneV1 operation in ZonesApi.
 */
export interface ZonesApiZonesControllerCreateZoneV1Request {
    readonly storeUuid: string

    readonly body: ZoneDto
}

/**
 * Request parameters for zonesControllerDeleteZoneV1 operation in ZonesApi.
 */
export interface ZonesApiZonesControllerDeleteZoneV1Request {
    readonly storeUuid: string

    readonly zoneUuid: string
}

/**
 * Request parameters for zonesControllerGetZoneV1 operation in ZonesApi.
 */
export interface ZonesApiZonesControllerGetZoneV1Request {
    readonly storeUuid: string

    readonly zoneUuid: string
}

/**
 * Request parameters for zonesControllerGetZonesV1 operation in ZonesApi.
 */
export interface ZonesApiZonesControllerGetZonesV1Request {
    readonly storeUuid: string
}

/**
 * Request parameters for zonesControllerUpdateZoneV1 operation in ZonesApi.
 */
export interface ZonesApiZonesControllerUpdateZoneV1Request {
    readonly storeUuid: string

    readonly zoneUuid: string

    readonly body: ZoneDto
}

/**
 * ZonesApi - object-oriented interface
 */
export class ZonesApi extends BaseAPI {
    /**
     * 
     * @summary Create a new zone for the store
     * @param {ZonesApiZonesControllerCreateZoneV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public zonesControllerCreateZoneV1(requestParameters: ZonesApiZonesControllerCreateZoneV1Request, options?: RawAxiosRequestConfig) {
        return ZonesApiFp(this.configuration).zonesControllerCreateZoneV1(requestParameters.storeUuid, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a zone from the store
     * @param {ZonesApiZonesControllerDeleteZoneV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public zonesControllerDeleteZoneV1(requestParameters: ZonesApiZonesControllerDeleteZoneV1Request, options?: RawAxiosRequestConfig) {
        return ZonesApiFp(this.configuration).zonesControllerDeleteZoneV1(requestParameters.storeUuid, requestParameters.zoneUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get details of a specific zone for the store
     * @param {ZonesApiZonesControllerGetZoneV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public zonesControllerGetZoneV1(requestParameters: ZonesApiZonesControllerGetZoneV1Request, options?: RawAxiosRequestConfig) {
        return ZonesApiFp(this.configuration).zonesControllerGetZoneV1(requestParameters.storeUuid, requestParameters.zoneUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all zones for the store
     * @param {ZonesApiZonesControllerGetZonesV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public zonesControllerGetZonesV1(requestParameters: ZonesApiZonesControllerGetZonesV1Request, options?: RawAxiosRequestConfig) {
        return ZonesApiFp(this.configuration).zonesControllerGetZonesV1(requestParameters.storeUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an existing zone for the store
     * @param {ZonesApiZonesControllerUpdateZoneV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public zonesControllerUpdateZoneV1(requestParameters: ZonesApiZonesControllerUpdateZoneV1Request, options?: RawAxiosRequestConfig) {
        return ZonesApiFp(this.configuration).zonesControllerUpdateZoneV1(requestParameters.storeUuid, requestParameters.zoneUuid, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}



